import { Component, OnInit, Input, Output, EventEmitter, ElementRef, forwardRef, ChangeDetectorRef, ChangeDetectionStrategy, ViewChild, NgZone, Renderer2, Injector, OnDestroy,HostListener } from '@angular/core';
import { FormGroup, FormBuilder, FormArray, Validators, FormControl, NG_VALUE_ACCESSOR, NG_VALIDATORS } from '@angular/forms';
import { BaseService } from '../../shared/services/base.service';
import { ActivatedRoute, LoadChildren, Router } from '@angular/router';
import { Observable, Subscription, fromEvent } from 'rxjs';
import { map } from 'rxjs/operators';
import { DialogService } from '../dialog/dialog.service';
import { CompositeArrayObjectComponent } from '../composite-array/composite-array-object.component';
import { FormService } from '../form/form.service';
import { editableGrid } from './editable-grid.model';
import { LoaderService } from '../../services/loader.service';
import { ModalSize, SmartModalService } from '../../services/smart-modal.service';
import { editableGridService } from '../dynamic-Grid-with-control/editableGrid.service';
import { PopUpOverGridWithControlsComponent } from '../dynamic-Grid-with-control/pop-up-over-grid-with-controls/pop-up-over-grid-with-controls.component';
import { AlertsService } from '../../services/alerts.service';
import { FilterService } from '../../services/filter.service';
import { RolePermissionService } from '../../shared/services/role-permission.service';
import { PrintService } from '../../shared/services/print.service';
import { CommonService } from '../../services/common.service';
import { StorageService } from '../../shared/services/storage.service';
import { UtilService } from '../../services/util.service';
import { AppService } from '../../shared/services/app.service';
import { exportImportFilesService } from '../../services/exportImportFiles.service';
import { TemplateInterceptorComponent } from '../template-interceptor/template-interceptor.component';
import { DialogModalSize, DialogRef } from '../dialog/dialog-ref';
import { DynamicPopUpComponent } from '../data-grid/dynamic-pop-up/dynamic-pop-up.component';
import { AsideBarService } from '../../services/asideBar.service';
import { EditGridOverPopUpComponent } from './edit-grid-over-pop-up/edit-grid-over-pop-up.component';
import { UtilitiesService } from '../../services/utilities.service';
import { DownloadService } from 'src/modules/base/shared/services/download.service';
import { PreferenceService } from '../../shared/services/preference.service';
import get_ from 'lodash-es/get';
import { Location } from '@angular/common';
import { TranslateService } from '../../services/translate.service';
import { ModalService } from '../../services/modal.service';
import { CommunicationService } from '../../services/communication.service';
import { ManageFilterComponent } from '../data-grid/manage-filter/manage-filter.component';
import { DateRangeConfig } from '../daterangepicker/dateconfig.service';
import dayjs from 'dayjs';
import { ShowSubstitutesComponent } from '../show-substitutes/show-substitutes.component';
import { DownloadPopupComponent } from '../data-grid/download-popup/download-popup.component';
import { DataGridPaginationComponent } from '../data-grid-pagination/data-grid-pagination.component';
import { PopUIEngineComponent } from '../pop-uiengine/pop-uiengine.component';
declare var jQuery: any;
export const DROPDOWN_CONTROL_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => EditableGridComponent),
    multi: true
};
const noop = () => { };
@Component({
    selector: 'dhs-editable-grid',
    templateUrl: './editable-grid.component.html',
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: EditableGridComponent,
            multi: true,
        }, {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => EditableGridComponent), multi: true
        }
    ],
    styleUrls: ['./editable-grid.component.scss'],
    standalone: false
})
export class EditableGridComponent implements OnInit, OnDestroy {
    @ViewChild("complexSearch") complexSearchRef: any;
    @Output() listen_changes: EventEmitter<any> = new EventEmitter();
    @Input() resource: string = "";                                           // Resource name to plot grid columns and its settings
    @Input() json: any;
    @Output() valueAdded: EventEmitter<any> = new EventEmitter();           // Remove row event emited
    @Output() saveFinished: EventEmitter<any> = new EventEmitter();
    @Output() barcodeSubmit: EventEmitter<any> = new EventEmitter(); 
    @Output() bulkActionClickedEditGrid = new EventEmitter<BulkActionClickEventEditGrid>();
    @ViewChild('getElementHeight') cardElem: ElementRef;
    @ViewChild('kxFilter') kxFilter: ElementRef;
    @ViewChild('pagination') pagination : DataGridPaginationComponent
    editableTable: FormGroup;                                               // editable grid formGroup
    _editableGridData: any = {};                                               // Main container which contains all variables
    selectedIndices: boolean[] = [];                                         // Selected Index checkbox
    selectedItems: any[] = [];
    obj_table: any = [];
    @Input() validIn: boolean;
    propagateChange = (_: any) => { };
    options_obj: any = {};
    searchConfig: any = { save_filter: true, hideUgfilter: true, hideSaveAs: true };
    //   searchConfig: any = {};
    _currentData: any = {};
    @Input() formFlag: boolean = false;
    @Input() parentForm: any = false;
    barcodeStr: string = '';
    is_grid_sorted: boolean = true;
    @Input() public filterFormGroup: any = false;
    private dummyFilterFormGroup: any = false;
    gridPrintFlag: boolean = false;
    filterFormMapping: any;
    defaultDynamicfilter: any;
    filterFieldGroup: any;
    sortObject: any;
    fullData: any[];
    toggleButtonOn: boolean = false;                                          // settings.toggle_button switch state
    toggleButtonDefault: any;
    @Input() public set config(data: editableGrid) {                                  // In this object we'll get all input fields from another components
        if (data) {
            this._editableGridData = Object.assign(this._editableGridData, data);

            //this sets objects as per each row in checkbox
            if (this._editableGridData.items != undefined) {
                this.settableobj();
            }
        } else {
            this._editableGridData = data;
        }
    }
    currentSort: Map<string, number> = new Map();
    previousFilterVal: any;
    filterSavedVal: string = "";
    private subs: Subscription = new Subscription();
    isTableContextMenuOpen: number | null = null;
    hoveredPopoverCell: string | null = null;

    constructor(
        private baseService: BaseService,
        private route: ActivatedRoute,
        private fb: FormBuilder,
        private dialogService: DialogService,
        private formService: FormService,
        private el: ElementRef,
        public loader: LoaderService,
        public smartModalService: SmartModalService,
        public editableGridService: editableGridService,
        public alerts: AlertsService,
        public filterService: FilterService,
        private cdRef: ChangeDetectorRef,
        private rolePermissionService: RolePermissionService,
        public print_Service: PrintService,
        public commonService: CommonService,
        public storageService: StorageService,
        public utilService: UtilService,
        public appService: AppService,
        public exportImportFiles: exportImportFilesService,
        private ngZone: NgZone,
        public _renderer: Renderer2,
        public UtilitiesService: UtilitiesService,
        public asideBarService: AsideBarService,
        public downloadService: DownloadService,
        public preferenceService: PreferenceService,
        public Router?: Router,
        public locationCommon?: Location,
        public communicationService?: CommunicationService,
        public dialogRef?: DialogRef,
        public translateService?: TranslateService,
        public modalService?: ModalService,
        public injector?: Injector
    ) {
        this._editableGridData['activeField'] = 'table';
        this._editableGridData['tableInitalized'] = false;
        this._editableGridData.user_preference_data = {};
        this._editableGridData.drag_started = true;
        this._editableGridData.barcodeReaderModel = "";
        this._editableGridData.noWrapApplied = false;
    }
    ngOnInit() {
        this.formService.setEditableGrid(true);
        this._editableGridData = Object.assign(new editableGrid(), this._editableGridData); // Merging Input data to defaultData
        this.getResourceDefAndInitiateGrid();// Get resource Def

        // const barcodeScanner = fromEvent(document, 'keypress');
        // this.keyEvent = barcodeScanner.subscribe(event => {

        //     //console.log("inside event", event);
        //     if (!this.flag && this._editableGridData.barcodeConfig != undefined && this._editableGridData.barcodeConfig.populateGrid != undefined && this._editableGridData.barcodeConfig.populateGrid && this.searchConfig.barcode_config != undefined && this.searchConfig.barcode_config) {
        //         //console.log("config ==> ", this.config);
        //         //console.log("grid config", event);

        //         if (event['key'] === 'Enter' && this.combinedCode) {
        //             //console.log("At enter");
        //             this.barcodeStr = this.combinedCode;
        //             this.combinedCode = "";
        //             //console.log("val is as follow", this.combinedCode);
        //             this.bookmarkAdded(x);
        //         } else if (event['key'] !== 'Enter') {
        //             //console.log("At key");
        //             const currentTime = Date.now();
        //             if (this.combinedCode === null) {
        //                 this.combinedCode = event['key'];
        //             } else {
        //                 this.combinedCode = this.combinedCode + event['key'];
        //             }
        //             // this.combinedCode = currentTime - this.lastKeyTime > 40 && this.combinedCode.length != 1 ? null : this.combinedCode;
        //             this.lastKeyTime = currentTime;
        //         }

        //         // this.editableTable.controls.editableRows['controls'][0].patchValue(x);
        //         // for (let index in x) {
        //         //     // this.editableTable.controls.editableRows['controls'][0].controls[index].setValue(x[index]);
        //         //     if (this.editableTable.controls.editableRows['controls'][0].controls[index]['question_component'] != undefined) {
        //         //         let row = undefined;
        //         //         // this.setValue(row, this.editableTable.controls.editableRows['controls'][0], index);
        //         //     }
        //         //     //console.log(index);
        //         // }
        //         //console.log("grid config", event);

        //     }
        // })

    }
    pageConfigChange(event) {
        if (event.config && event.config == "getCount") {
            this.getCount();
        }
    }
     getCount() {
        this._editableGridData.noCount = false;
        if (this._editableGridData.listBlocks.filter.filter_selected) {
            this._editableGridData.existingFilter = this._editableGridData.initialFilter
        }
        this.fetchData(this._editableGridData.listBlocks.APIresource.datasource, this._editableGridData.existingFilter ? this._editableGridData.existingFilter : undefined, this._editableGridData.exsitingComplexSearch ? this._editableGridData.exsitingComplexSearch : undefined, this.sortObject != undefined && this.sortObject ? this.sortObject : this.sortObject);
    }
    getResourceDefAndInitiateGrid(formFlag?) { // Getting resource Def
        var jsonName = (this.json != undefined && this.json.resource != undefined) ? this.json.resource : this.resource;
        this._currentData.json = jsonName;
        this.searchConfig.saveKey = this._currentData.json + "_list_config";
        this.preferenceService.loadInitalConfig(this, jsonName, () => {

            if (this.json != undefined && this.json) {

                /************** APPLYING CONFIGURE GRID FEATURE **********/
                if (this._currentData.uiConfigData != undefined && this._currentData.uiConfigData) {
                    var afterConfig = this.preferenceService.applyJsonConfig({ resouceDef: JSON.parse(JSON.stringify(this.json)) }, this._currentData.uiConfigData);
                    if (afterConfig.resouceDef != undefined) {
                        this.json = afterConfig.resouceDef;
                    }
                }
                /************** APPLYING CONFIGURE GRID FEATURE **********/

                this.setResorcedef(this.json);
            }
            else if (this.resource != undefined && this.resource) {
                this.baseService.getResourceDef(this.resource, (fetchedDef) => {
                    // opt-in "config.config_field_overrides" (eg. 198848 expiry as DD/MM/YYYY): list fields are swapped
                    // on a copy before the grid is built; a json without the key continues synchronously, as before
                    this.utilService.resolveConfigFieldOverrides(fetchedDef, (overrides) => {
                        let resouceDef = fetchedDef;
                        if (resouceDef?.list?.fields && Object.keys(overrides.list).length) {
                            resouceDef = { ...resouceDef, list: { ...resouceDef.list, fields: this.utilService.mergeFieldOverrides(resouceDef.list.fields, overrides.list) } };
                        }
                        if (resouceDef) {
                            /************** APPLYING CONFIGURE GRID FEATURE **********/
                            if (this._currentData.uiConfigData != undefined && this._currentData.uiConfigData) {
                                var afterConfig = this.preferenceService.applyJsonConfig({ resouceDef: resouceDef }, this._currentData.uiConfigData);
                                if (afterConfig.resouceDef != undefined) {
                                    resouceDef = afterConfig.resouceDef;
                                }
                            }
                            /************** APPLYING CONFIGURE GRID FEATURE **********/
                            this.setResorcedef(resouceDef);
                            this._editableGridData.whole_resource = resouceDef;
                            if (formFlag) {
                                if (this._editableGridData && this._editableGridData.listBlocks && this._editableGridData.listBlocks.APIresource && this._editableGridData.listBlocks.APIresource.datasource) {
                                    this.fetchData(this._editableGridData.listBlocks.APIresource.datasource);
                                    this.propagateChange(this._editableGridData.items);
                                } else {
                                    this.initiateForm();
                                    this.propagateChange(this._editableGridData.items);
                                }
                            }
                        }
                    });
                });
            }
        });

    }

    setResorcedef(resouceDef) {
        this.setDecorater(resouceDef);
        if(this.formService && !this.formService.editableGrid){
            this.setEditableGrid(true);
        }
        resouceDef.list.fields.sort((a, b) => { return a.order - b.order });
        this._editableGridData.bookmarks = resouceDef;
        this._editableGridData.actions = resouceDef.list.actions ? resouceDef.list.actions : [];
        if (resouceDef.setCardData != undefined && resouceDef.setCardData) {
            this.formService.setCardData({data:JSON.parse(sessionStorage.getItem('currentData'))}, resouceDef.config);
        }
        if (!this.formFlag) {
            this._editableGridData['cloneFields'] = JSON.parse(JSON.stringify(this.formService.buildQuestions(resouceDef.list.fields)));
        }
        if (this._editableGridData.bookmarks.bookmark)
            this.checkBookmark(this._editableGridData.bookmarks.bookmark);
        if (resouceDef.settings) {
            this._editableGridData = Object.assign(this._editableGridData, resouceDef.settings);
            
            if (resouceDef.settings.hasOwnProperty('defualt_page_size')) {
                this._editableGridData.page_size = resouceDef.settings.defualt_page_size ? resouceDef.settings.defualt_page_size : 10;
            }
            if (this._editableGridData.hasOwnProperty('buttons') && this._editableGridData.buttons.length > 0) { // Check for custom buttons
                this._editableGridData.buttons = this.rolePermissionService.getAllowedContextMenu(false, this._editableGridData.buttons, this.resource);
            }
            if (resouceDef.hasOwnProperty('custom_button') && resouceDef.custom_button.length > 0) {
                this._editableGridData.custom_button = resouceDef.custom_button; //this.rolePermissionService.getAllowedContextMenu(false, resouceDef.custom_button, this.resource);
            }
        }
        if (resouceDef.config) {
            this._editableGridData.noCount = resouceDef.config.noCount === false ? false : true;
        }
        if (resouceDef.list && resouceDef.list.projectionKeys) { // if projection keys is true in config
            this._editableGridData.projectionArray = resouceDef.list.projectionKeys
        }

        if (resouceDef.config && resouceDef.config.projection_keys) { // if projection keys is true in config
            this._editableGridData.projection_keys = resouceDef.config.projection_keys;
            this._editableGridData.projectionKeys = this.baseService.getProjectionKeys(resouceDef.list.fields, this._editableGridData.projectionArray)
        }
        if (resouceDef.config && resouceDef.config.hideHeaderCheckbox) {
            this._editableGridData.hideHeaderCheckbox = resouceDef.config.hideHeaderCheckbox;
        }
        if (resouceDef.config && resouceDef.config.master_upload) {
            this._editableGridData.master_upload = resouceDef.config.master_upload;
        }
        if (resouceDef.config != undefined) {
            this._editableGridData.config = resouceDef.config;
            this.getSavedFilter();
        }
        if (resouceDef.list != null) {
            this._editableGridData.listBlocks = resouceDef.list;
            this._editableGridData.filter_block = resouceDef.list.filter ? resouceDef.list.filter : null;
            this._editableGridData.rowHeader = resouceDef.list.rowHeader ? resouceDef.list.rowHeader : null;
            this._editableGridData.page_limit = resouceDef.list.page_limit ? resouceDef.list.page_limit : null
            if (this._editableGridData && this._editableGridData.listBlocks && this._editableGridData.listBlocks.APIresource != undefined && this._editableGridData.items.length == 0 && !this._editableGridData.default_row && (!this._editableGridData.filter_block || (this._editableGridData.filter_block != undefined && !this._editableGridData.filter_block.default_filter))) { // if Found APIresource in json ==> list hit API to bind grid.
                this.fetchData(this._editableGridData.listBlocks.APIresource.datasource); /// Fetch data from API 

            }
            //this sets the editable grid with fields and value
            this.tablefields();
            // else {
            //     // Need 
            //     this.tablefields();
            // }
            // Setting form controls 
            this.searchConfig.complex_search = resouceDef.list.complex_search;
            this.searchConfig.barcode_config = resouceDef.list.barcode_config;
            this._editableGridData.barcodeConfig = resouceDef.list.barcode_config;
            this._editableGridData.currentResource = resouceDef.resource;
            // //console.log("asda ==>", this._editableGridData.barcodeConfig);
        }
        if(this._editableGridData?.allowEditGridDownloadCommon){
            this.buildCustomButtons()
        }

    }

    displayFilter() {
        this._editableGridData.filter = !this._editableGridData.filter;
        this.searchConfig['filterOpenStatus'] = this._editableGridData.filter;
        setTimeout(() => {
            if (this.cdRef && this._editableGridData.config && !this._editableGridData.config.stopChangeProp) {
                this.cdRef.detectChanges();
                this._editableGridData.config.stopChangeProp = false;
            }
        });
    }
    doSearch(filterStr) {
        if (this._isMaintainCheckBox()) {
            this._editableGridData.isSourceSearchFilter = true;
            this.saveCheckboxState(undefined, undefined, undefined, "searchFilter")
        };

        this.sortObject = false;
        this.currentSort.clear();
        this.kxFilter['config']['quickFilter'] = false;
        this.setFilterprintInfo();
        //this._editableGridData.listBlocks.APIresource.datasource['filter'] = filter + "," + this._editableGridData.listBlocks.APIresource.datasource['filter'];
        ///this._editableGridData.listBlocks.APIresource.datasource['filter'] = this.filterService.removeDuplicateKeysFromString(this._editableGridData.listBlocks.APIresource.datasource);
        //resetting pageno to initial level
        setTimeout(() => {
            if (this._editableGridData != undefined && this._editableGridData.page_no != undefined) {
                this._editableGridData.page_no = 0;
            }
            this._editableGridData.existingFilter = filterStr;
            this._currentData.saveFilterKey = true;
            // for saving applied filter changes in session
            if (this.filterSavedVal == "") {
                this.filterSavedVal = JSON.stringify(this._editableGridData.existingFilter);
                this.storageService.setData('filterSavedVal' + this._editableGridData.currentResource, this.filterSavedVal, () => { });
                this.storageService.setData('filterFormGroup' + this._editableGridData.currentResource, this.filterFormGroup.value, () => { });
            }

            //  decorator emit
            if (this._editableGridData != undefined && this._editableGridData && this._editableGridData.decorator != undefined && this._editableGridData.decorator && this._editableGridData.decorator.filtersOnSubmitEG != undefined) {
                var submitRes = this._editableGridData.decorator.filtersOnSubmitEG(filterStr, this._editableGridData);
                if (!submitRes) {
                    return;
                }
            }
            this.fetchData(this._editableGridData.listBlocks.APIresource.datasource, this._editableGridData.existingFilter, this._editableGridData.exsitingComplexSearch ? this._editableGridData.exsitingComplexSearch : undefined);
        });

    }

    resetQuickFilter() {
        this._editableGridData.config.resetQuickFilter = true;
        this.kxFilter['resetFormClick']('');
    }

    resetFilter(filter, flag?) {
        this._currentData.saveFilterKey = true;
        if (this._editableGridData.config != undefined && this._editableGridData.config && this._editableGridData.config.filterConfig != undefined) {
            this._editableGridData.config.filterConfig.reset = new Date().getTime();
            this._editableGridData.config.filterConfig.quickReset = true;
            this._editableGridData.config.filterConfig = {};
            delete this._editableGridData.config.filterConfig.FilterName;
            delete this._editableGridData.config.filterConfig.currentFilter;
            this._editableGridData.config.filterConfig.submit = new Date().getTime();
        }
        ////console.log("Filter is", filter);

        this._editableGridData.existingFilter = filter;
        if (this._currentData.filterPrintInfo != undefined && this._currentData.gridData != undefined && this._currentData.gridData['filter'] != undefined) {
            this._currentData.filterPrintInfo;
            this._currentData.gridData['filter'];
        }

        if ((flag == undefined || flag == '') && this._editableGridData.config != undefined && this._editableGridData.config && this._editableGridData.config.filterConfig) {
            this._editableGridData.config.filterConfig.reset = new Date().getTime();
            this._editableGridData.config.filterConfig.quickReset = true;
            this._editableGridData.config.filterConfig = {};
            delete this._editableGridData.config.filterConfig.FilterName;
            delete this._editableGridData.config.filterConfig.currentFilter;
            delete this._editableGridData.config.filterConfig.currentFilterName;
            this._editableGridData.config.filterConfig.submit = new Date().getTime();
        }
        if (flag && this._editableGridData.config != undefined && this._editableGridData.config && this._editableGridData.filterLabel != undefined && this._editableGridData.filterConfig != undefined) {
            delete this._editableGridData.config.filterLabel;
            delete this._editableGridData.config.filterConfig.FilterName;
            delete this._editableGridData.config.filterConfig.currentFilter;
            delete this._editableGridData.config.filterConfig.currentFilterName;
            this._editableGridData.config.filterConfig.quickReset = false;
            this.displayFilter();
        }
        if (this._editableGridData.config.resetQuickFilter == undefined && !this._editableGridData.config.resetQuickFilter)
            this.fetchData(this._editableGridData.listBlocks.APIresource.datasource, "");
        
        this.onAllChecked(false);
        // setTimeout(() => {
        //     this.onAllChecked(false);
        // },1000)
    }

    ngAfterOnInit() {
        this._editableGridData.formArray = this.editableTable.get('editableRows') as FormArray;

    }

    tablefields() { // Settings Inputs inside grid
        this.editableTable = this.fb.group({
            editableRows: this.fb.array([])
        });
        //if (this.formFlag) { this.initiateForm(); }
        this.initiateForm();
    }
    listenEvent(obj) {
        this.listen_changes.emit(obj);
        if (this._editableGridData.decorator != undefined && this._editableGridData.decorator && this._editableGridData.decorator.listenChangeEventEG != undefined) {
            this._editableGridData.decorator.listenChangeEventEG(obj, this);
        }
    }
    ngAfterViewInit() {
        /**** SUBSCRIBING TO CHANGE EVENT IN FORM SERVICE */
        this.subs.add(this.formService.getOpionChanged().subscribe((subObj) => {
            // console.log("sub options::", subObj);
            if (subObj) {
                // this.options_obj[subObj.question.key] = subObj.question.options;
                if (this._editableGridData.nestedFields != undefined) {
                    this.setoptions(this._editableGridData.nestedFields, subObj.question, subObj.question.index);
                    // this.cdRef.detectChanges();
                }
                let obj;
                if (this.editableTable != undefined) {
                    obj = { object: this._editableGridData.items, type: "dropdown_binded", editableGrid: this.editableTable.controls.editableRows['controls'], index: subObj.question.index };
                } else {
                    obj = { object: this._editableGridData.items, type: "dropdown_binded", editableGrid: {}, index: subObj.question.index };
                }

                this.listenEvent(obj);
            }
        }));
        if (!this.cdRef['destroyed']) {
            this.cdRef.detectChanges();
        }
        this.checkGridOpensInSmallDevice(); // Checking if is grid opens in Mobile then rows convert into cards
        if (this._editableGridData.barcode_config != undefined && this._editableGridData.barcode_config.datasource) { // if barcode available, in form config only then this condition will sastified to listen barcode 
            // this.ngZone.runOutsideAngular((event) => {
            //    // window.addEventListener('keyup', this.getBarCodeString);
            // });
        }
        this.setDefaultRow();
    }
    isTableContextMenuActive(index: number): boolean {
        return this.isTableContextMenuOpen === index;
    }

    toggleTableContextMenu(index: number, event: MouseEvent) {
        event.stopPropagation();
        event.preventDefault();
        this.isTableContextMenuOpen = this.isTableContextMenuOpen === index ? null : index;
    }
    @HostListener('document:click')
    closeTableContextMenu() {
        this.isTableContextMenuOpen = null;
    }
    applyUserPreference(key) {
        if (key) {
            this.getTableConfig(key, (data) => {
                if (data && Object.keys(data).length) {
                    //********************Barcode will apply by default or not */
                    if (data.barcodeConfig != undefined && this._editableGridData.barcodeConfig) {
                        this._editableGridData['barcodeConfig'] = data.barcodeConfig;
                    }
                    else if (this.searchConfig.barcode_config != undefined && this.searchConfig.barcode_config) {
                        this._editableGridData['barcodeConfig'] = {
                            'populateGrid': false
                        }
                        this._editableGridData['barcodeConfig']['datasource'] = this.searchConfig.barcode_config.datasource;
                    }
                    if (this?._editableGridData?.barcodeConfig?.performActionOnScan) {
                        this.addKeyDownEventIfNeeded();
                    }
                    if (data.fields && data.fields.length > 0) {
                        for (let dg of data.fields) {
                            let control = this._editableGridData.fields.find((d) => { return d.key == dg.key });
                            let order;
                            if (control) {
                                control.hidden = dg.hidden;
                                control.selected = !dg.hidden;
                                control.order = data.fields_order ? data.fields_order[dg.key] : null;
                                // if(isOrder){
                                //      order = data.fields_order[dg.key];
                                //      control.order = order;
                                // }
                            }
                        }

                        // if(this.is_grid_sorted && this._editableGridData.drag_started){
                        //     this._editableGridData.fields.sort((a, b) => { return a.order - b.order });
                        //     this.removeDragListner();
                        //     this._editableGridData['tableInitalized'] = false;
                        //     this._editableGridData['dragStarted'] = true;
                        // }
                    }
                    this.setFieldOrderAndVisibility();
                }
                this._editableGridData.user_preference_data = data;
            });
        }
    }
    HidetoggleVisibility(event, auto = false) {
        const checked = event;
        // this.getFieldsOrder(this._editableGridData.user_preference_json);
        this._editableGridData.fields.forEach((item, index) => {

            if (item.required) {
                item.disabled_ = true; // Will not toggle mandantory fields cause an error while submitting
            } else {
                item.disabled_ = false;
                if (checked && !auto) {
                    item.selected = true;
                    item.hidden = false;
                }
            }
            if (item.hidden == undefined) {
                item.hidden = false;
                item.selected = true;
            }
        });
        if (checked === false) {
            this._editableGridData.fields.forEach((item, index) => {
                if (item.label != '') {
                    if (item.required) {
                        item.disabled_ = true;
                        item.hidden = false;
                        item.selected = true;
                    } else {
                        item.disabled_ = false;
                        item.hidden = true;
                        item.selected = false;
                    }
                }
            });
        }
        if (auto) {
            this.applyUserPreference(this._editableGridData.user_preference_json);
        }
        this.setFieldOrderAndVisibility();
        if (!auto) {
            this.saveTableConfigData(this._editableGridData.user_preference_data);
            this.removeDragListner();
        }
        this.getTableConfig(this._editableGridData.user_preference_json, (data) => {
            if (data && Object.keys(data).length == 0) {
                this.saveTableConfigData(this._editableGridData.user_preference_data);
            }
        });
        // if (!auto) {
        //     this.saveTableConfig();
        //     this.removeDragListner();
        //     this.tableInitalized = false;
        // }
    }
    checkSelectAll() {
        for (let i = 1; i < this._editableGridData.fields.length; i++) {
            if (this._editableGridData.fields[i].selected == true) {
                this._editableGridData.flag_ = true;
            } else {
                this._editableGridData.flag_ = false;
                break;
            }
        }
        if (this._editableGridData.flag_) {
            this._editableGridData.viewAll = true;
        } else {
            this._editableGridData.viewAll = false;
        }
    }
    getInitialFieldOrder(callBack: any = false) {
        if (this._editableGridData?.fields) {
            let isNotHiddenControl = this._editableGridData.fields.filter((d) => { return d.controlType != "hidden" });
            if (isNotHiddenControl && isNotHiddenControl.length > 0) {
                for (let i = 0; i < isNotHiddenControl.length; i++) {
                    this._editableGridData.fieldsOrder[isNotHiddenControl[i].key] = i;
                }
                if (callBack) {
                    callBack(true)
                }
            }
        }
    }
    checkSameKeysHaveDuplicateValues(data, callBack) {
        let valueCounts = {};
        let dupFound = false;
        for (let key in data) {
            let value = data[key];
            if (valueCounts[value]) {
                data[key] += 1;
                dupFound = true;
            } else {
                valueCounts[value] = true;
            }
        }
        let obj = { completed: true, data: data, isDup: dupFound }
        callBack(obj)
    }
    getFieldsOrder(key) {
        if (this._editableGridData.fields && this._editableGridData.fields.length > 0) {
            this._editableGridData.fieldsOrder = {};
            this.getTableConfig(key, (data) => {
                if (data && Object.keys(data).length) {
                    if (data.fields_order) {
                        this.getInitialFieldOrder((d) => {
                            if (d) {
                                this.checkSameKeysHaveDuplicateValues(data.fields_order, cb => {
                                    if (cb.completed, cb.data) {
                                        if (cb.isDup) {
                                            this.saveTableConfigData();
                                        }
                                        Object.keys(cb.data).forEach((index, item) => {
                                            if (this._editableGridData.fieldsOrder.hasOwnProperty(index)) {
                                                this._editableGridData.fieldsOrder[index] = cb.data[index];
                                            }
                                        });
                                        this.setFieldOrderAndVisibility();
                                    }
                                })

                            }
                        })
                    } else {
                        this.getInitialFieldOrder();
                    }
                } else {
                    this.getInitialFieldOrder();
                }
            });
        }
    }
    setFieldOrderAndVisibility(callBack: (success: boolean) => void = () => { }): void {
        const { nestedFields, fields, fieldsOrder, dragStarted } = this._editableGridData;

        if (nestedFields.length === 0 || fields.length === 0) {
            if (callBack) callBack(false);
            return;
        }

        const visibleFields = fields.filter(d => d.controlType !== 'hidden' && d.label !== '');

        for (const field of visibleFields) {
            for (const nestedFieldSet of nestedFields) {
                const control = nestedFieldSet.find(d => d.key === field.key);
                if (control && control.controlType !== 'hidden') {
                    control.hidden = field.hidden;
                }
            }
        }

        Object.entries(fieldsOrder).forEach(([index, order]) => {
            const field = fields.find(d => d.key === index);
            if (field) field.order = order;

            for (const nestedFieldSet of nestedFields) {
                const control = nestedFieldSet.find(d => d.key === index);
                if (control) control.order = order;
                nestedFieldSet.sort((a, b) => a.order - b.order);
                fields.sort((a, b) => a.order - b.order);
            }
        });

        fields.sort((a, b) => a.order - b.order);

        if (dragStarted) {
            this.removeDragListner();
            this._editableGridData.tableInitalized = false;
        }

        this.checkSelectAll();

        if (callBack) callBack(true);
    }

    removeDragListner() {
        if (jQuery('#editable-grid')) {
            var cols = jQuery('#editable-grid').find('thead tr th');
            [].forEach.call(cols, function (col) {
                jQuery(col).off();
            });
        }
    }
    toggleVisibility(event, field) {
        field.hidden = !field.hidden;
        const check = event.target.checked;
        if (check === false) {
            field.selected = false;
            this._editableGridData.viewAll = false;
        }
        else {
            field.selected = true;
            this.checkSelectAll();
        }
        for (let nes of this._editableGridData.nestedFields) {
            let control = nes.find((d) => { return d.key == field.key });
            if (control.controlType != "hidden") {
                control.hidden = field.hidden;
            }
        }
        this.saveTableConfigData(this._editableGridData.user_preference_data);
        this.removeDragListner();
    }
    ngAfterViewChecked() {
        if (this._editableGridData.draggable && !this._editableGridData['tableInitalized'] && jQuery('#editable-grid').length > 0) {
            this._editableGridData['tableInitalized'] = true;
            //console.log("inside ngAfterViewChecked")
            if (this._editableGridData['dragStarted'] && jQuery('#editable-grid')) {
                this.addDragListner();
            } else {
                setTimeout(() => {
                    this.addDragListner();
                }, 3000);
            }
            let obj = { index: undefined, object: {}, type: "grid_rendered" };
            this.listenEvent(obj);
        }
        if(!this._editableGridData.noWrapApplied && this._editableGridData.applyNoWrap){
            setTimeout(() => {
                this.setWhiteSpaceNoWrapForEG();
            }, 100);
        }
        this.checkingDisabledStatus();
    }
    addDragListner() {
        if (this.resource != undefined) {
            jQuery('#editable-grid').dragableColumns({
                drag: true,
                dragClass: 'drag',
                overClass: 'over',
                movedContainerSelector: '.dnd-moved',
                onDragEnd: (fromIndex, toIndex) => {
                    this.onColumnDragEnd(fromIndex, toIndex);
                }
            });
        }
    }
    onColumnDragEnd(fromIndex, toIndex) {
        /// to column
        var tobemainFieldName = jQuery(`#editable-grid`).find('thead tr th').eq(fromIndex).data('name');
        //console.log("Drag from field", tobemainFieldName)
        let mainField = this._editableGridData.fields.find(f => { return f.key == tobemainFieldName });
        let exactPositionFromIndex = this._editableGridData.fieldsOrder[tobemainFieldName];
        if (!exactPositionFromIndex && exactPositionFromIndex != 0) {
            console.error(`Can not Drag this column not find in Order Object ${this._editableGridData.fieldsOrder}, column Name is ${tobemainFieldName}`);
            return
        }

        //from column
        var toFieldName = jQuery(`#editable-grid`).find('thead tr th').eq(toIndex).data('name');
        //console.log("Drag to field", toFieldName)
        let exactPositionToIndex = this._editableGridData.fieldsOrder[toFieldName];
        let tobeReplacedField = this._editableGridData.fields.find(f => { return f.key == toFieldName });
        if (!exactPositionToIndex && exactPositionToIndex != 0) {
            console.error(`Can not Drag this column not find in Order Object ${this._editableGridData.fieldsOrder}, column Name is ${toFieldName}`);
            return
        }

        if (!tobeReplacedField.key) {
            this.alerts.error(`Can not drag this column.`);
            return
        }
        if (!mainField.key) {
            this.alerts.error(`Can not drag this column.`);
            return
        }
        if (toFieldName === tobemainFieldName) {
            console.error("can not drag column to itself");
            return
        }
        let checkField_mainField = this._editableGridData.fields.filter((d) => { return d.key == mainField.key }).length;
        if (checkField_mainField != 1) {
            this.alerts.error(`Dublicate keys found not able to Drag ${mainField.key}`);
            return false;
        }
        let checkField_tobeReplacedField = this._editableGridData.fields.filter((d) => { return d.key == tobeReplacedField.key }).length;
        if (checkField_tobeReplacedField != 1) {
            this.alerts.error(`Dublicate keys found not able to Drag ${tobeReplacedField.key}`);
            return false;
        }
        if (this._editableGridData.nestedFields.length > 0) {
            // for (let data of this._editableGridData.nestedFields) {
            //                                                         //d.order == exactPositionFromIndex &&
            //           let toField_ =   data.find((d) => { return  d.key == mainField.key});
            //           toField_ = JSON.parse(JSON.stringify(toField_));
            //           toField_.order = exactPositionToIndex;

            //                                                     //        d.order == exactPositionToIndex &&
            //           let fromField_ =   data.find((d) => { return  d.key == tobeReplacedField.key});
            //           fromField_ = JSON.parse(JSON.stringify(fromField_));
            //           fromField_.order = exactPositionFromIndex;

            //          let to_pos =  data.findIndex((d) => { return d.key == mainField.key });

            //          let from_pos =  data.findIndex((d) => { return d.key == tobeReplacedField.key });

            //          data[to_pos] = fromField_;
            //          data[from_pos] = toField_;
            // }
            if (mainField.key && tobeReplacedField.key) {
                this._editableGridData.fieldsOrder[mainField.key] = exactPositionToIndex;
                this._editableGridData.fieldsOrder[tobeReplacedField.key] = exactPositionFromIndex;

                let pos_to_field = this._editableGridData.fields.findIndex((d) => { return d.key == mainField.key });

                let pos_from_field = this._editableGridData.fields.findIndex((d) => { return d.key == tobeReplacedField.key });

                this._editableGridData.fields[pos_to_field] = tobeReplacedField;
                this._editableGridData.fields[pos_from_field] = mainField;
            }
        }
        this.setFieldOrderAndVisibility((d) => {
            if (d) {
                this.getTableConfig(this._editableGridData.user_preference_json, (saveData) => {
                    saveData.fields_order = this._editableGridData.fieldsOrder;
                    this._editableGridData.drag_started = false;
                    this.is_grid_sorted = false;
                    this.saveTableConfigData(saveData);
                    this._editableGridData['dragStarted'] = true;
                });
            }
        });
    }
    changeControls(field, index) {
        try {
            this.loader.showSpinner();
            //console.log("field is ", field);
            //console.log("index is", index);
            let rowData = this.editableTable.controls.editableRows['controls'][index].value;
            if (field && field.hasOwnProperty('conversion') && field.conversion) {
                let conversion = field.conversion;
                if (conversion.component == "dropdown" || conversion.component == "searchselect" && conversion.hasOwnProperty('datasource')) {

                    //     let arr = [];
                    //   arr.push(conversion);
                    //   let question =   this.formService.buildQuestions(arr,'',{data:rowData});
                    //   this._editableGridData.nestedFields[index].splice(10, 1, question[0]);
                    //   this.initiateForm(this._editableGridData.nestedFields);
                    //   this.validIn =true;
                    //   this.cdRef.detectChanges();
                    if (!conversion.datasource.possible_value) {
                        if (conversion.component == "dropdown") {
                            this.checkControlTypesAndInitiateForm(conversion.component, field, conversion, rowData)
                        }
                        if (conversion.component == "searchselect") {
                            this.checkControlTypesAndInitiateForm(conversion.component, field, conversion, rowData)
                        }
                    }
                    if (conversion.datasource.possible_value) {
                        field.datasource = conversion.datasource;
                        field.component = conversion.component;
                        field.controlType = conversion.component;
                        field.options = conversion.datasource.possible_value;
                        field.value = rowData[field.key];
                        field.dependents = conversion.dependents
                        field.getterKey = conversion.getterKey
                        field.getterValue = conversion.getterValue
                        field.format = conversion.format
                        field.required = conversion.required
                        field.populate_field = conversion.populate_field
                        field.req_keys = conversion.req_keys
                        this.initiateForm(this._editableGridData.nestedFields);
                        this.cdRef.detectChanges();
                        this.loader.hideSpinner();
                    }

                }
            }
        } catch (error) {
            this.loader.hideSpinner();
        }

    }
    checkControlTypesAndInitiateForm(type, field, conversion, rowData) {
        if (type == "dropdown") {
            this.getOptions(conversion.datasource, rowData, (callBack) => {
                if (callBack) {
                    field.datasource = conversion.datasource;
                    field.component = conversion.component;
                    field.controlType = conversion.component;
                    field.options = callBack;
                    field.value = rowData[field.key];
                    field.dependents = conversion.dependents
                    field.getterKey = conversion.getterKey
                    field.getterValue = conversion.getterValue
                    field.format = conversion.format
                    field.required = conversion.required
                    field.populate_field = conversion.populate_field
                    field.req_keys = conversion.req_keys
                    this.initiateForm(this._editableGridData.nestedFields);
                    this.cdRef.detectChanges();
                    this.loader.hideSpinner();
                }
            });
        }
        if (type == "searchselect") {
            field.datasource = conversion.datasource;
            field.component = conversion.component;
            field.controlType = conversion.component;
            field.value = rowData[field.key];
            field.dependents = conversion.dependents
            field.getterKey = conversion.getterKey
            field.getterValue = conversion.getterValue
            field.format = conversion.format
            field.required = conversion.required
            field.populate_field = conversion.populate_field
            field.defaultsetting = conversion.defaultsetting
            field.flag = conversion.flag
            field.popover = conversion.popover
            field.req_keys = conversion.req_keys
            this.loader.hideSpinner();
            this.initiateForm(this._editableGridData.nestedFields);
            this.cdRef.detectChanges();
            //this.loader.hideSpinner();
        }
    }
    getDefaultValue(field) {
        if (field && field.conversion) {
            return 'Search'
        }
        return ''
    }
    getConversionClass(field) {
        if (field && field.hasOwnProperty('conversion') && field.conversion) {
            return 'on-hover-edit'
        }
        return ''
    }
    getOptions(datasource, data, callBack) {
        let obj = {
            args: datasource.args ? this.baseService.buildDyanamicStr(datasource.args, { data: data }) : '',
            filter: datasource.filter ? this.baseService.buildDyanamicStr(datasource.args, { data: data }) : ''
        }
        this.subs.add(this.baseService.getData(obj, '', datasource.resource, datasource.application, datasource.query_id).subscribe((d) => {
            if (d.errCode == 0 && d.resource && d.resource.length > 0) {
                callBack(d.resource);
            } else {
                callBack([]);
            }
        }, (err) => {
            console.error("err", err);
            callBack([]);
        }))
    }
    getBarCodeString = (event) => { // this function will check datasource and call related api and fill related controls
        this.ngZone.run(() => {
            // let x = document.activeElement.tagName;
            // if (x && x != "BODY") {
            //     return false;
            // }
            if (!event.target.className.includes('barcode_row')) {
                return false;
            }
            if (event.code != "Enter" && this.commonService.checkStrIsAlphaNumeric(event.key)) {
                //this.barcodeStr += event.key;
                this.barcodeStr = event.target.value
            }
            //this.barcodeStr = "SBC-10";// hardcoded only for testing
            if (event.code == "Enter" && event.keyCode == 13) { // when Enter key will be presssed
                if (this._editableGridData.barcode_config.datasource && this._editableGridData.barcode_config.id && this.barcodeStr) {
                    let args;
                    let data = { barCode: this.barcodeStr };
                    args = JSON.parse(JSON.stringify(this._editableGridData.barcode_config.datasource.args != undefined ? this.baseService.buildDyanamicStr(this._editableGridData.barcode_config.datasource.args, { data: data }) : ''));
                    this.loader.showSpinner();
                    this.subs.add(this.baseService.get(this._editableGridData.barcode_config.datasource.query_id, args, this._editableGridData.barcode_config.datasource.resource, this._editableGridData.barcode_config.datasource.application).subscribe((res) => {
                        //console.log("Barcode response is", res);
                        this.barcodeStr = "";
                        if (res.errCode == -1) {
                            this.alerts.error(res.message);
                            let obj = { index: undefined, object: {}, type: "Barcode" };
                            this.listenEvent(obj);
                            this.loader.hideSpinner();
                        } else if (res.errCode == 0) {
                            // Check barcode dependents and fill related controls
                            if (this._editableGridData._currentIndex == undefined && this._editableGridData.barcode_config && this._editableGridData.barcode_config.hasOwnProperty('add_new_row') && this._editableGridData.barcode_config.add_new_row) {
                                this.addRow(this._editableGridData.items.length);
                                this.editableTable.controls.editableRows['controls'][this._editableGridData.items.length - 2].patchValue(res.resource[0])
                                setTimeout(() => {
                                    let obj = { index: this._editableGridData._currentIndex, object: this._editableGridData.items, response: res, type: "Barcode", editableGrid: this.editableTable.controls.editableRows['controls'] };
                                    this.listenEvent(obj);
                                }, 1000)
                            }
                            //   else if(this._editableGridData._currentIndex >= 0){
                            //         setTimeout(()=>{
                            //             let obj = {index:this._editableGridData._currentIndex, object: this._editableGridData.items,response:res, type: "Barcode", editableGrid: this.editableTable.controls.editableRows['controls'] };
                            //             this.listenEvent(obj);
                            //     },1000)
                            //   }
                            else {
                                //TODO
                            }
                            setTimeout(() => {
                                this.cdRef.detectChanges();
                                this.loader.hideSpinner();
                            })
                        }
                    }, (err) => {
                        this.loader.hideSpinner();
                        this.barcodeStr = "";
                    }))
                }
            }
        })
    };
    async getBarCodeData(event, index) {
        let rowData = this.editableTable.controls.editableRows['controls'][index];
        let params = {
            args: `barCode:${event}`
        };
        if (rowData.value && rowData.value.itemCode) {
            params.args += `,itemCode:${rowData.value.itemCode}`;
        }
        this.loader.showSpinner();
        await this.baseService.getData(params, "", this._editableGridData.barcodeConfig.datasource.resource, this._editableGridData.barcodeConfig.datasource.application, this._editableGridData.barcodeConfig.datasource.query_id).toPromise().then(
            (data: any) => {
                if (data.errCode == -1) {
                    this.loader.hideSpinner();
                    ////console.log("Data from barcode API",data);
                    this.alerts.error(data.message);
                } else {
                    let id = `bar_${index}`;
                    document.getElementById(id)['value'] = "";
                    let barcodeData = data.resource[0];
                    if (this._editableGridData.listBlocks && this._editableGridData.listBlocks.barcode_config && this._editableGridData.listBlocks.barcode_config.emitBarcodeAction) {
                        let obj = { data: data, index: index, type: "Barcode_emit", editableGrid: this.editableTable.controls.editableRows['controls'] };
                        this.listenEvent(obj);
                        this.loader.hideSpinner();
                        return false;
                    }
                    let control = this.editableTable.controls.editableRows['controls'][index].controls;
                    if (control.itemName.status == "DISABLED") {
                        control.substituteItemName.setValue(barcodeData.itemName);
                        control.substituteItemCode.setValue(barcodeData.itemCode);
                        this.editableTable.controls.editableRows['controls'][index].controls['substituteItemCode'].question_component.updateDependentValue(control['substituteItemCode'].value);
                    } else {
                        // setting form
                        this.editableTable.controls.editableRows['controls'][index].patchValue(barcodeData);
                        if (this.editableTable.controls.editableRows['controls'][index].controls.itemCode && this.editableTable.controls.editableRows['controls'][index].controls.itemCode.value == "") {
                            this.editableTable.controls.editableRows['controls'][index].controls.itemCode.setValue(barcodeData.itemCode)
                            this.editableTable.controls.editableRows['controls'][index].controls['itemCode'].question_component.updateDependentValue(control['itemCode'].value);
                        }
                        let obj = { data: barcodeData, index: index, type: "Barcode_setValue", editableGrid: this.editableTable.controls.editableRows['controls'] };
                        this.listenEvent(obj);
                    }
                    setTimeout(() => {
                        Object.keys(control).forEach(key => {
                            if (key && this.editableTable.controls.editableRows['controls'][index].controls[key].question_component) {
                                if (this.editableTable.controls.editableRows['controls'][index].controls[key] && this.editableTable.controls.editableRows['controls'][index].controls[key].question_component) {
                                    if (typeof this.editableTable.controls.editableRows['controls'][index].controls[key].question_component.updateDependentValue == 'function') {
                                        this.editableTable.controls.editableRows['controls'][index].controls[key].question_component.updateDependentValue(control[key].value);
                                    }
                                }
                            }
                        })
                    });
                    if (index >= 0 && this._editableGridData.barcode_config && this._editableGridData.barcode_config.hasOwnProperty('add_new_row') && this._editableGridData.barcode_config.add_new_row) {
                        let isEmptyRowExist = this._editableGridData.items.filter((d) => { return d.itemName == "" });
                        if (!isEmptyRowExist.length) {
                            this.addRow(this._editableGridData.items.length);
                            setTimeout(() => {
                                let obj = { index: index, type: "Barcode", editableGrid: this.editableTable.controls.editableRows['controls'] };
                                this.listenEvent(obj);
                                let id = `#bar_${index + 1}`;
                                const element = this._renderer.selectRootElement(id);
                                setTimeout(() => element.focus(), 0);
                            })
                        }
                    }
                    //this.bookmarkAdded(data.resource[0],"",index)
                    this.loader.hideSpinner();
                }
            }, error => {
                //console.log(error);
            }
        )
    }
    barcodeRowScan(str, index) {
        if (this._editableGridData.barcodeConfig && this._editableGridData.barcodeConfig.datasource) {
            this.getBarCodeData(str, index);
        }
    }
    setDefaultRow() { // If default_row = true in this._editableGridData.setting then this function will execute to create a fresh row
        if (this._editableGridData && this._editableGridData.default_row && this._editableGridData.nestedFields && this._editableGridData.nestedFields.length == 0) {
            this.setNestedeQuest([{}], this._editableGridData.listBlocks.fields);
            this.addRow(0, true);
            this.checkValidation();
        } else if (this._editableGridData && !this._editableGridData.default_row && this._editableGridData.nestedFields && this._editableGridData.nestedFields.length == 0 && this._editableGridData.default_row_count > 0) {
            this.setNestedeQuest([{}], this._editableGridData.listBlocks.fields);
            for (let i = 0; i < this._editableGridData.default_row_count; i++) {
                this.addRow(i, false)
            }
            this.checkValidation();
        }
    }
    setoptions(fields, subobj, index) {
        if (fields != undefined && fields[index] != undefined && fields[index].length != undefined && index != undefined) {
            for (let j = 0; j < fields[index].length; j++) {
                if (fields[index][j].controlType == "dropdown" && fields[index][j].index != undefined && subobj['index'] != undefined && (subobj['index'] == fields[index][j].index) && (subobj.key == fields[index][j].key)) {
                    // //console.log("dropdown data is as::", fields[index][j].index,"data ",obj[fields[index][j]['key']]);
                    fields[index][j]['options'] = subobj.options;
                    try {
                        // this.setDefaultDropdown(this.editableTable.controls.editableRows['controls'][index].controls[fields[index][j].key],fields[index][j]); 
                        if (this._editableGridData.decorator != undefined && this._editableGridData.decorator && this._editableGridData.decorator.valueChangeStartEG != undefined) {
                            this._editableGridData.decorator.setDropdownEG(this.buildDecoratorFormObj(this.editableTable.controls.editableRows['controls'][index], index, fields[index][j]));
                        }

                    } catch (error) {

                    }

                }
            }

        }

    }

    createobj(str) {
        try {
            let obj = {};
            let arr = str.split(',');
            for (let item of arr) {
                obj[item.split(':')[0]] = item.split(':')[1]
            }
            return obj;
        } catch (error) { }


    }


    updateCurrentDataFromSavedFilter(searchStr) {
        if (this._currentData.loadSavedFilter != undefined) {
            this._currentData.gridData = {};
            var filterSavedObj = this.getFilterLabel();
            if (filterSavedObj && filterSavedObj["filter"] != undefined) {
                this._currentData.gridData['filter'] = filterSavedObj["filter"];//apply filter which is in url
            }
            if (filterSavedObj && filterSavedObj["filterLabel"] != undefined) {
                this._currentData.filterPrintInfo = filterSavedObj["filterLabel"];//apply filter which is in url
            }
            if (this._editableGridData.config && this._editableGridData.config.filterConfig != undefined && this._editableGridData.config.filterConfig.FilterName != undefined) {
                this._editableGridData.config.filterConfig["FilterName"] = this._editableGridData.config.filterConfig.FilterName ? this._editableGridData.config.filterConfig.FilterName : filterSavedObj["filterName"];
                this._editableGridData.config.filterConfig["currentFilter"] = this._editableGridData.config.filterConfig.currentFilter ? this._editableGridData.config.filterConfig.currentFilter : filterSavedObj["currentFilter"];
            } else {
                if (filterSavedObj && filterSavedObj["filterName"] != undefined && this._editableGridData.config.filterConfig == undefined) {
                    this._editableGridData.config["filterConfig"] = {};
                    this._editableGridData.config.filterConfig["FilterName"] = filterSavedObj["filterName"];
                    this._editableGridData.config.filterConfig["currentFilter"] = filterSavedObj["currentFilter"];
                }
            }
            if (filterSavedObj && filterSavedObj["search_columns"] != undefined) {
                searchStr['key'] = filterSavedObj["search_columns"][0];//apply filter which is in url
                this.searchConfig.searchColumns = searchStr['key'];
            }

            if (filterSavedObj && filterSavedObj["search"] != undefined) {
                searchStr['value'] = filterSavedObj["search"];//apply filter which is in url
                this.searchConfig.search = searchStr['value'];
            }

            if (filterSavedObj && filterSavedObj["searchColumns"] != undefined) {
                this._currentData.gridData['searchColumns'] = filterSavedObj["searchColumns"];//apply filter which is in url

            }
            if (filterSavedObj && filterSavedObj["searchLabel"] != undefined) {
                this._currentData.gridData['searchLabel'] = filterSavedObj["searchLabel"];//apply filter which is in url
            }
            if (filterSavedObj && filterSavedObj["noRule"] != undefined && filterSavedObj["noRule"] != undefined) {
                this._currentData.gridData['noRule'] = filterSavedObj["noRule"];//apply filter which is in url
            }
            if (this.appService.getAccountConfig() && this.appService.getAccountConfig().regex_search != undefined && this.appService.getAccountConfig().regex_search == true) {
                //do nothing
            }
            else if (filterSavedObj && filterSavedObj["eq_search"] != undefined) {
                this._currentData.gridData['eq_search'] = filterSavedObj["eq_search"];//apply filter which is in url

            }

            //var filterSaveKey = "f__k";
            // delete this._currentData.saveFilterKey;
            delete this._currentData.loadSavedFilter;
            /********TODO PRININFO IMPLEMENT ON PRINT FROM SAVED FILTER *******/
            //this.storageService.removeSesssionData(filterSaveKey+"_"+this._currentData.resouceDef.resource);
        }
    }

    private _isMaintainCheckBox(): boolean {
        return Array.isArray(this._editableGridData?.maintainCheckBox) &&
            this._editableGridData.maintainCheckBox.length > 0;
    }

    saveCheckboxState(isAllchecked?:boolean , isChecked?:boolean, index?:number, source?:string) {
        try {
            // const currentData = JSON.parse(sessionStorage.getItem('currentData')) || {};
            // const uniq = currentData.id?currentData.id:'' ;
            let location_id = this.appService.getCurrentLocation()?.location_id || '';
            const key = `${this._editableGridData.currentResource}_${location_id}_checkbox_state`;

            const alreadyCheckedBox = sessionStorage.getItem(key);
            let allSavedItems = alreadyCheckedBox ? JSON.parse(alreadyCheckedBox) : [];

            const configuredKey = this._editableGridData?.maintainCheckBox?.[0]?.key;

            const currentIds = new Set((this._editableGridData.items || []).map(item =>
                configuredKey && item[configuredKey] !== undefined ? item[configuredKey] : item.id || item.sq_no
            ));
            let itemToRemove;
            let itemsToRemove = []
            if (isChecked === false) {
                if (this.editableTable?.controls?.editableRows?.['controls']?.[index]) {
                    itemToRemove = this.editableTable.controls.editableRows['controls'][index];
                }
            }
            allSavedItems = allSavedItems.filter(item => {
                const keyVal = configuredKey && item.uniKey !== undefined ? item.uniKey : item.id || item.sq_no;
                return !currentIds.has(keyVal);
            });
            if (isAllchecked === false && source === "allChecked" && !this._editableGridData.isSourceSearchFilter) {
                if (this.editableTable?.controls?.editableRows?.['controls']) {
                    this.editableTable?.controls?.editableRows?.['controls'].forEach(element => {
                        if (element?.value[configuredKey]) {
                            itemsToRemove.push(element?.value[configuredKey]);
                        }
                    });
                }
            }
            // remove unchecked items
            if (itemToRemove && configuredKey && allSavedItems.length > 0) {
                allSavedItems = allSavedItems.filter((item) => item.uniKey != itemToRemove?.value[configuredKey]);
            }
            //remove all
            if (itemsToRemove.length > 0  && configuredKey && allSavedItems.length > 0) {
                allSavedItems = allSavedItems.filter((item) => !itemsToRemove.includes(item.uniKey));
            }

            const currentSelectedItems = this.selectedItems.map(item => ({
                index: item.index,
                CompleteItem: { ...item },
                sq_no: item.sq_no,
                id: item.id,
                uniKey: configuredKey && item[configuredKey] !== undefined ? item[configuredKey] : ''
            }));

            const updatedSavedItems = [...allSavedItems, ...currentSelectedItems];
            sessionStorage.setItem(key, JSON.stringify(updatedSavedItems));
        } catch (e) {
            console.error('Error saving checkbox state:', e);
        }
    }

    restoreCheckboxState() {
        try {
            let location_id = this.appService.getCurrentLocation()?.location_id || '';
            const key = `${this._editableGridData.currentResource}_${location_id}_checkbox_state`;
            const checkNoxToRestor = sessionStorage.getItem(key);

            if (checkNoxToRestor && this._editableGridData.items) {
                const savedCheckboxes = JSON.parse(checkNoxToRestor);

                this.selectedIndices = [];
                this.selectedItems = [];

                this._editableGridData.items.forEach((item, idx) => {
                    const configuredKey = this._editableGridData?.maintainCheckBox?.[0]?.key;
                    const savedItem = savedCheckboxes.find(saved => {
                        const matchByProvidedKeys = configuredKey &&
                            saved.uniKey &&
                            item[configuredKey] !== undefined &&
                            saved.uniKey === item[configuredKey];

                        const matchByIDss = (saved.id && item.id && saved.id === item.id) ||
                            (saved.sq_no !== undefined && item.sq_no !== undefined && saved.sq_no === item.sq_no);

                        // const itemMatchByIcode = saved.itemCode === item.itemCode &&
                        //     saved.itemCategoryKey === item.itemCategoryKey;

                        // return matchByIDss || itemMatchByIcode;
                        return matchByProvidedKeys || matchByIDss;
                    });

                    if (savedItem) {
                        this.selectedIndices[idx] = true;

                        const restoredItem = {
                            ...item,
                            ...savedItem.CompleteItem,
                            index: idx
                        };

                        this.selectedItems.push(restoredItem);
                        if (this.editableTable?.controls?.editableRows?.['controls']?.[idx]) {
                            this.editableTable.controls.editableRows['controls'][idx].patchValue(savedItem.CompleteItem);
                        }
                    } else {
                        this.selectedIndices[idx] = false;
                    }
                });

                this.value = this.selectedItems;
                this.propagateChange(this.selectedItems);
                // //console.log('Restored checkbox state with updated data - Total selections:', this.selectedItems.length);
            }
        } catch (e) {
            console.error('Error restoring checkbox state:', e);
        }
    }

    getAllSelectedItemsForSubmission() {
        try {
            // const currentData = JSON.parse(sessionStorage.getItem('currentData')) || {};
            // const uniq = currentData.id?currentData.id:'' ;
            let location_id = this.appService.getCurrentLocation() && this.appService.getCurrentLocation().location_id ? this.appService.getCurrentLocation().location_id : '';
            const key = `${this._editableGridData.currentResource}_${location_id}_checkbox_state`;

            const alreadySavedItems = sessionStorage.getItem(key);

            if (alreadySavedItems) {
                const allSavedItems = JSON.parse(alreadySavedItems);
                return allSavedItems.map(item => item.CompleteItem || item).filter(item => item);
            }

            return this.selectedItems;
        } catch (e) {
            console.error('Error getting all selected items:', e);
            return this.selectedItems;
        }
    }

    clearCheckboxState() {
        try {
            // const currentData = JSON.parse(sessionStorage.getItem('currentData')) || {};
            // const uniq = currentData.id?currentData.id:'' ;
            let location_id = this.appService.getCurrentLocation() && this.appService.getCurrentLocation().location_id ? this.appService.getCurrentLocation().location_id : '';
            const key = `${this._editableGridData.currentResource}_${location_id}_checkbox_state`;

            sessionStorage.removeItem(key);
            this.selectedItems = [];
            this.selectedIndices = [];
            this.value = [];

            // //console.log('Cleared checkbox state');
        } catch (e) {
            console.error('Error clearing checkbox state:', e);
        }
    }

    @HostListener('window:beforeunload', ['$event'])
    handleBeforeUnload(event: Event) {
        if (this._isMaintainCheckBox()) {
            this.clearCheckboxState();
        }
    }

    // private generateCacheKey(params: any, datasource: any): string {
    //     const rawKey = [
    //     params?.args,
    //     params?.filter,
    //     datasource?.resource,
    //     datasource?.application,
    //     datasource?.query_id,
    //     params?.page_no,
    //     params?.page_size
    //     ]
    //     .map(value => JSON.stringify(value ?? ''))
    //     .join('|');
    //     return CryptoJS.MD5(rawKey).toString();
    // }


    //***********************************Get data from DB based on Datasource **************************************/
    async fetchData(datasource, filterStr_?, searchStr_?, sortObj?) { // Get Data from API funtion
        this._editableGridData.isDataLoading = true;
        this._currentData.loadSavedFilter = true;
        let searchStr = searchStr_?.value != ''? searchStr_:''
        let filterStr = filterStr_;

        //************************************** for grid prsistance  */
        if (searchStr_ == undefined && (this._editableGridData != undefined && this._editableGridData.bookmarks != undefined && this._editableGridData.bookmarks.config != undefined && this._editableGridData.bookmarks.config.persistance != undefined && this._editableGridData.bookmarks.config.persistance)) {
            searchStr = {};
            this.updateCurrentDataFromSavedFilter(searchStr);
            if (this._currentData != undefined && this._currentData.gridData != undefined && this._currentData.gridData['filter'] != undefined && this._currentData.gridData['filter'] && (filterStr_ == undefined)) {
                this.searchConfig['filterLabel'] = this._currentData.filterPrintInfo;
                filterStr = this._currentData.gridData['filter'];
            }
        }

        let search = '';
        let search_columns: any;
        // let sortObj_ = sortObj;
        if (typeof searchStr == 'object') {
            if (searchStr.key != undefined && searchStr.value != undefined) {
                search_columns = [searchStr.key];
                search = searchStr.value;
            }

        } else {
            search = searchStr;
        }
        this.loader.showSpinner();
        if (datasource != undefined) {
            datasource = JSON.parse(JSON.stringify(datasource));
            var data_ = JSON.parse(sessionStorage.getItem('currentData')) != undefined && JSON.parse(sessionStorage.getItem('currentData')) ? JSON.parse(sessionStorage.getItem('currentData')) : {};
            //Merging formcontrol in data_ if available in this._editableGridData
            if (this._editableGridData.hasOwnProperty('form_controls')) {
                data_ = { ...data_, ...this._editableGridData['form_controls'] }
            }
            if(datasource?.org_location){
                  let storeId = {storeId:this.appService.getCurrentLocation().location_id}
                  data_ = {...data_,...storeId}  
            }
            //Reading data from snapshot to make params
            if (this.route && this.route.snapshot.params && typeof this.route.snapshot.params == "object") {
                data_ = { ...data_, ...this.route.snapshot.params };
                if (datasource.isSnapshotdata && this.route?.snapshot?.queryParams?.query_params) { //isSnapshotdata == true in datasource
                    let snap = this.route.snapshot.queryParams.query_params.split(',');
                    if (snap?.length) {
                        for (const d of snap) {
                            if (d.includes(':')) {
                                let ind = d.split(':');
                                let key = ind[0];
                                let value = ind[1];
                                if (!data_.hasOwnProperty(key)) {
                                    data_[key] = value;
                                }
                            }
                        }
                    }
                }
            }
            this._editableGridData.args_filter = data_;
            //binding dynamic args
            datasource.args = datasource.args != undefined ? this.baseService.buildDyanamicStr(datasource.args, { data: data_ }) : '';
            //binding dynamic filters
            datasource.filter = datasource.filter != undefined ? this.baseService.buildDyanamicStr(datasource.filter, { data: data_ }) : '';
            if (this._editableGridData.noCount) {
                if (datasource.args) {
                    datasource.args += ",noCount:1"
                } else {
                    datasource.args += "noCount:1"
                }
            }
            var params = {
                args: datasource.args,
                filter: datasource.filter ? (filterStr ? (filterStr + ',' + datasource.filter) : datasource.filter) : (filterStr ? filterStr : ''),
                page_no: this._editableGridData.page_no,
                page_size: this._editableGridData.page_size,
                search_columns: search_columns ? search_columns : '',
                search: search ? search : "",
                order_by: datasource.order_by != undefined && datasource.order_by ? datasource.order_by : ''
            }
            if (params.page_no == 0) {
                delete params.page_no
            }
            if (sortObj != undefined && sortObj) {
                params['order_by'] = sortObj.key + " " + sortObj.value;

            }
            if (this._editableGridData.projection_keys) {
                params['projectionKeys'] = this._editableGridData.projectionKeys
            }

            //added to support exact search
            if (this.appService.getAccountConfig() && this.appService.getAccountConfig().regex_search != undefined && this.appService.getAccountConfig().regex_search == true) {
                //do nothing
              } else{
                if (searchStr_ != undefined && searchStr_.searchObj != undefined && searchStr_.searchObj.eq_search != undefined) {
                    params['eq_search'] = 'y';
                } else if (this._currentData != undefined && this._currentData.gridData != undefined && this._currentData.gridData.eq_search != undefined) {
                    params['eq_search'] = this._currentData.gridData.eq_search;
                }
              }
            

            //setting code for persistance 
            try {

                if (this._currentData.saveFilterKey != undefined && this.persistGrid() && (this._editableGridData != undefined && this._editableGridData.bookmarks != undefined && this._editableGridData.bookmarks.config != undefined && this._editableGridData.bookmarks.config.persistance != undefined && this._editableGridData.bookmarks.config.persistance)) {
                    delete this._currentData.saveFilterKey;
                    this.saveFilterObj({ gridData: params }, (responseConfig) => {
                        var queryObj = {};
                        queryObj[responseConfig["filterSaveKey"]] = responseConfig["filterKey"];

                        var url = this.Router.createUrlTree([], { relativeTo: this.route, queryParams: queryObj, queryParamsHandling: 'merge' }).toString()
                        this.locationCommon.replaceState(url);

                        //this.router.onSameUrlNavigation = 'ignore';
                        this.Router.navigate(['.'], { relativeTo: this.route, queryParams: queryObj, replaceUrl: true, queryParamsHandling: 'merge' });//maintain history so that user could go back (uncommenting because router params was not updating)
                    });
                }

            } catch (e) {
                //console.log(e);
            }
            // for appending default_filter 
            if (params && params.filter && this._editableGridData && this._editableGridData.initialFilter != undefined && this._editableGridData.initialFilter) {
                params.filter = params.filter + ',' + this._editableGridData.initialFilter;
            }
            //persistance end
            params.filter = this.filterService.removeDuplicateKeysFromString(params);  // Removing duplicate keys from filter
            // if (this.baseService.validateParams(datasource.args) && this.baseService.validateParams(datasource.filter)){
            //console.log("params are :; ", params, " datasource.resource ", datasource.resource);
            await this.baseService.getData(params, "", datasource.resource, datasource.application, datasource.query_id).toPromise().then(
                (data: any) => {
                    // this._editableGridData.resourceData = data;
                    this._editableGridData.isDataLoading = false;
                    if (data.errCode == -1) {
                        this.loader.hideSpinner();
                        // TODO
                        this.alerts.error(data.message);
                        this._editableGridData['show_'] = false;
                    } else if (data.errCode == 0 && data.hasOwnProperty('resource')) {
                        if(datasource?.predict){
                            this.buildRows(data,datasource);
                        }else{
                            this._editableGridData.selectedCount = 0;
                            this._editableGridData.items = [];
                            this.selectedIndices = [];
                            //console.log("params", params);
                            if (data.count == -1) {
                                this._editableGridData.itemsCount = -1;
                            } else {
                                this._editableGridData.itemsCount = data.count;
                            }
                            this._editableGridData.currentItemCount = data.resource.length;
                            this._editableGridData.items = data.resource;
                            if (datasource.gridItemsKey && data.resource[0]) { //need to refactor by sauravdeep this include because of data comes inside API
                                this._editableGridData.items = data.resource[0][datasource.gridItemsKey].data;
                                this._editableGridData.itemsCount = data.resource[0][datasource.gridItemsKey].data.length
                            }
                            // if (!this.formFlag) { // Commented by Sanjay grid is not loading on indent issue page
                            this.initiateForm();
                            //}
                            this._editableGridData.items = data.resource;
                            this.checkingDisabledStatus();
                            if (this._isMaintainCheckBox()) {
                                this.restoreCheckboxState();
                            };
                            this.loader.hideSpinner();
                            if (this._editableGridData.all_selected) {
                                setTimeout(() => {
                                    if (this.obj_table.length > 0) {
                                        for (let item of this.obj_table) {
                                            if (this._editableGridData.all_selected_condition && eval(this._editableGridData.all_selected_condition.expression)) {
                                                this.selectedItems.push(item);
                                            }
                                            if (!this._editableGridData.all_selected_condition)
                                                this.selectedItems.push(item);
                                        }
                                        if (!this._editableGridData.all_selected_condition)
                                            this.onAllChecked(true)
                                        if (this._editableGridData.all_selected_condition)
                                            this.onSelectedItemChek(true)
                                    }
                                });
                            }
                        }
                    }
                    this._editableGridData.filter = false;
                }, error => {
                    //console.log(error);
                }
            )
            //}

        }

    }
    buildRows<T>(data: { count: number; resource: T[] }, datasource: { gridItemsKey?: string }): void {

        const grid = this._editableGridData;

        if (!data || !Array.isArray(data.resource)) {
            this.loader.hideSpinner();
            return;
        }

        // Reset selection state
        grid.selectedCount = 0;
        grid.items = [];
        this.selectedIndices = [];

        // Extract items safely
        const extractedItems: T[] = this.extractItems(data.resource, datasource);

        grid.itemsCount = data.count === -1
            ? extractedItems.length
            : data.count;

        grid.currentItemCount = extractedItems.length;
        grid.items = extractedItems;
        this.initiateForm();
        this.checkingDisabledStatus();
        this.handleCheckboxRestore();
        this.handleAllSelectedLogic(extractedItems);

        this.loader.hideSpinner();
    }
    private extractItems<T>(resource: T[],datasource: { gridItemsKey?: string }): T[] {
        if (!datasource?.gridItemsKey || !resource?.length) {
           return resource;
        }
        const firstItem = resource[0] as any;

        const nested = firstItem?.[datasource.gridItemsKey]?.data;

        return Array.isArray(nested) ? nested : resource;
    }
    private handleCheckboxRestore(): void {

        const grid = this._editableGridData;

        if (Array.isArray(grid?.maintainCheckBox) && grid.maintainCheckBox.length > 0) {
          this.restoreCheckboxState();
        }
    }
    all_selected_condition: { 
        predicate: (item: any) => boolean;
    }

    private handleAllSelectedLogic<T>(items: T[]): void {

        const grid = this._editableGridData;

        if (!grid?.all_selected || !items?.length) return;

        const condition = grid.all_selected_condition?.predicate;

        this.selectedItems = condition
            ? items.filter(condition)
            : [...items];

        if (condition) {
            this.onSelectedItemChek(true);
        } else {
            this.onAllChecked(true);
        }
    }

    saveFilterObj(config, callback) {
        var filterSaveKey = "f__k";
        var gridData;
        var filterKey = this.baseService.generateID(5);
        var filterObj = { key: filterKey };
        var savedObj = this.getFilterLabel();

        if (savedObj && savedObj["key"] != undefined) {
            filterObj["key"] = savedObj["key"]; //we found already saved filter whose key is present in url bar
        }

        if (config["gridData"] != undefined) {
            gridData = config["gridData"];
            if (gridData['filter'] != undefined && gridData['filter']) {

                if (gridData['filter'] != undefined) {
                    filterObj["filter"] = gridData['filter'];
                }

                if (this._currentData.filterPrintInfo != undefined) {
                    filterObj["filterLabel"] = this._currentData.filterPrintInfo;
                }

            }

            if (gridData && gridData["search_columns"] != undefined) {
                filterObj["search_columns"] = gridData["search_columns"];
            }

            if (gridData && gridData["search"] != undefined) {
                filterObj["search"] = gridData["search"];
            }
            if (gridData && gridData["searchLabel"] != undefined) {
                filterObj["searchLabel"] = gridData["searchLabel"];
            }

            if (gridData && gridData["searchColumns"] != undefined) {
                filterObj["searchColumns"] = gridData["searchColumns"];
            }
            if (gridData && gridData["noRule"] != undefined) {
                filterObj["noRule"] = gridData["noRule"];
            }
            if (this.appService.getAccountConfig() && this.appService.getAccountConfig().regex_search != undefined && this.appService.getAccountConfig().regex_search == true) {
                //do nothing
            }
           else if (gridData && gridData["eq_search"] != undefined) {
                filterObj["eq_search"] = gridData["eq_search"];
            }

            if (this._editableGridData && this._editableGridData.config != undefined && this._editableGridData.config.filterConfig != undefined && this._editableGridData.config.filterConfig.FilterName != undefined) {
                filterObj["filterName"] = this._editableGridData.config.filterConfig.FilterName;
                filterObj["currentFilter"] = this._editableGridData.config.filterConfig.currentFilter;
            }
            if (this._editableGridData && this._editableGridData.existingFilter != undefined && this._editableGridData.existingFilter) {
                filterObj['existingFilter'] = this._editableGridData.existingFilter;
            }
            this.storageService.setSessionStorageData(filterSaveKey + "_eg" + this._editableGridData.currentResource, filterObj, () => {
                callback({ filterSaveKey: filterSaveKey, filterKey: filterObj["key"] });
            });
        }

        return false;


    }

    getFilterLabel() {
        //console.log("========getFilterLabel===============");
        if (this.persistGrid()) {
            try {
                var snapshot = this.route.snapshot;
                var filterSaveKey = "f__k";
                var params = { ...snapshot.queryParams };
                if (params[filterSaveKey] != undefined && params[filterSaveKey]) {
                    var filterObj = this.storageService.getSessionStorageDataSync(filterSaveKey + "_eg" + this._currentData.json);
                    if (filterObj) {
                        if (filterObj["key"] != undefined && filterObj["key"] == params[filterSaveKey]) {
                            return filterObj;
                        } else {
                            return false;
                        }
                    } else {
                        return false;
                    }
                } else {
                    return false;
                }
            } catch (e) {
                return false;
            }
        } else {
            return false;
        }

    }


    setFilterprintInfo() {
        let filterInfo: any = {};
        //this works to set value of filters
        if (this.kxFilter != undefined && this.kxFilter['form'] != undefined && this.kxFilter['form'].form != undefined && this.kxFilter['form'].form.controls != undefined) {
            let controls = this.kxFilter['form'].form.controls;
            Object.keys(controls).forEach(key => {
                //check condition
                let condition_ = controls[key] != undefined && controls[key] && controls[key].value != undefined && controls[key].value && controls[key].question_component != undefined && controls[key].question_component.question != undefined && controls[key].question_component.question.visible != undefined && controls[key].question_component.question.visible && this.kxFilter['filterVal'] != undefined && this.kxFilter['filterVal'] && get_(this.kxFilter['filterVal'], key) ? true : false;

                if (controls[key].question_component == undefined) {
                    return;
                }
                let question = controls[key].question_component.question;

                //this case works for singelselect
                if (condition_ && (controls[key].question_component.question.controlType === "dropdown" || (controls[key].question_component.question.controlType === "searchselect" && controls[key].question_component.question.defaultsetting != undefined && controls[key].question_component.question.defaultsetting.singleSelection != undefined && controls[key].question_component.question.defaultsetting.singleSelection)) && question != undefined && question.options != undefined && question.options.length != undefined) {
                    let currentOption = question.options.find(x => x[question.getterKey] === get_(this.kxFilter['filterVal'], key));
                    if (currentOption) {
                        this.baseService.asyncLanguageProcess(question.label).then((res: any) => {
                            let key_ = res;
                            filterInfo[key_] = currentOption[question.getterValue];
                        })
                    }
                }

                //this works in case of multiselect
                else if (condition_ && controls[key].question_component.question.controlType == "searchselect" && Array.isArray(get_(this.kxFilter['filterVal'], key)) && get_(this.kxFilter['filterVal'], key).length != undefined && get_(this.kxFilter['filterVal'], key).length > 0) {
                    this.baseService.asyncLanguageProcess(question.label).then((res: any) => {
                        let val = JSON.parse(JSON.stringify(get_(this.kxFilter['filterVal'], key)));
                        let val_ = val.map(e => e.text).join(",");
                        let key_ = res;
                        filterInfo[key_] = val_;
                    })
                }
                //all other cases
                else if (condition_ && controls[key].question_component.question.controlType != "hidden" && controls[key].question_component.question.controlType != "monthYearPicker" && controls[key].question_component.question.controlType != "daterangepicker" && controls[key].question_component.question.controlType != "searchselect" && controls[key].question_component.question.controlType != "dropdown") {
                    this.baseService.asyncLanguageProcess(question.label).then((res: any) => {
                        let key_ = res;
                        filterInfo[key_] = get_(this.kxFilter['filterVal'], key);
                    })
                }
                else if (condition_ && controls[key].question_component.question.controlType === "daterangepicker") {
                    this.baseService.asyncLanguageProcess(question.label).then((res: any) => {
                        let key_ = res;
                        let val = get_(this.kxFilter['filterVal'], key);
                        if (val && val.FROM != undefined && val.FROM && val.TO != undefined && val.TO && !controls[key].question_component.question.singleDatePicker) {
                            let modVal = this.utilService.toTimeZoneDateFormat(val.FROM, 'date') + " - " + this.utilService.toTimeZoneDateFormat(val.TO, 'date');
                            filterInfo[key_] = modVal;
                        }
                        else if (controls[key].question_component.question.locale != undefined && controls[key].question_component.question.locale.format != undefined && controls[key].question_component.question.outPutFormat != undefined && controls[key].question_component.question.outPutFormat) {
                            filterInfo[key_] = val;
                        }
                        else if (val && controls[key].question_component.question.singleDatePicker) {
                            let modVal = this.utilService.toTimeZoneDateFormat(val, 'date')
                            filterInfo[key_] = modVal;
                        }
                    })
                } else if (condition_ && controls[key].question_component.question.controlType === "monthYearPicker") {
                    this.baseService.asyncLanguageProcess(question.label).then((res: any) => {
                        let key_ = res;
                        let val = get_(this.kxFilter['filterVal'], key);
                        if (val) {
                            let modVal = this.utilService.toTimeZoneDateFormat(val, 'monthYear');
                            filterInfo[key_] = modVal;
                        }
                    })
                }
            });

            //console.log("filterPrintInfo", filterInfo);
            this._currentData.filterPrintInfo = filterInfo;
            // if (data.noComplexSearch == undefined) {
            //     //support for complex search
            //     if (this.complexSearchRef != undefined && this.complexSearchRef != undefined && this.complexSearchRef.config != undefined && this.complexSearchRef.config.searchField != undefined) {
            //         this.baseService.asyncLanguageProcess(this.complexSearchRef.config.searchField.label).then((res: any) => {
            //             if (this.complexSearchRef.finalFilterVal != undefined && this.complexSearchRef.finalFilterVal) {
            //                 let obj = {};
            //                 obj[res] = this.complexSearchRef.finalFilterVal;
            //                 filterInfo = { ...filterInfo, ...obj };
            //             }
            //         });
            //         // let complexSearch = {}

            //     }
            // }

        }
    }


    persistGrid() {
        if (this._currentData.origArhiveConfig != undefined) {
            return false;
        }
        if (this._currentData && this._currentData["archiveConfig"] != undefined && this._currentData["archiveConfig"]["applied"] != undefined && this._currentData["archiveConfig"]["applied"]) {
            return false;
        }
        return (this.constructor.name.toLowerCase() == "editablegridcomponent");
    }


    showHideSearch() {
        let flag = false;
        if (this._editableGridData.hasOwnProperty('search')) {
            if (this._editableGridData.search) {
                flag = true;
            } else {
                flag = false;
            }
        }
        else if (this._editableGridData.hasOwnProperty('allowConfigGrid')) {
            flag = true;
        } else if (!this._editableGridData.hasOwnProperty('search')) {
            flag = true;
        }
        if (this._editableGridData.hasOwnProperty('barcode_reader') && this._editableGridData.barcode_reader) {
            flag = true;
        }
        return flag;
    }
    //setting obj
    settableobj() {
        this.obj_table = JSON.parse(JSON.stringify(this._editableGridData.items));
        for (let i = 0; i < this.obj_table.length; i++) {
            if (this.obj_table[i].sq_no == undefined || this.obj_table[i].sq_no == null) {
                this.obj_table[i].sq_no = i;
            }
            if (this.obj_table[i].selected == true) {
                this.selectedIndices[i] = true;
                const index = this.selectedItems.findIndex(item => this.isSameItem(item, this.obj_table[i]));
                if (index === -1) {
                    this._editableGridData.selectedCount++;
                    this.selectedItems.push(this.obj_table[i]);
                }
            }
        }
    }

    get value() {
        return this._editableGridData.items;
    }

    set value(val) {
        this._editableGridData.items = val;
        this.propagateChange(val);
    }

    writeValue(value) {
        try {
            if (value && value.length > 0) {
                this._editableGridData.items = value;
                this.value = value;
                if (this.formFlag) {
                    // await setTimeout(() => {
                    if (!this._editableGridData.listBlocks) {
                        this.getResourceDefAndInitiateGrid(true);
                    } else {
                        this.initiateForm();
                        this.propagateChange(this._editableGridData.items);
                    }
                    // });
                }
            }
            else {
                this._editableGridData.fields = this._editableGridData.listBlocks.fields;
                this.setNestedeQuest([{}], this._editableGridData.listBlocks.fields);
                this._editableGridData.nestedFields = [];
            }
        } catch (error) {

        }

    }
    registerOnChange(fn: any): void {
        this.propagateChange = fn;
    }
    registerOnTouched(fn: any): void {

    }

    initiateForm(nestedFields?) { // Initating each and every control in Grid
        //this function clones the value in an object for checkbox functionality
        const startTime = performance.now();
        this.settableobj();
        if(this.formService && !this.formService.editableGrid){
            this.setEditableGrid(true);
        }
        if (!this.formFlag && this._editableGridData.listBlocks) {
            this._editableGridData.fields = this.formService.buildQuestions(this._editableGridData.listBlocks.fields);
        }
        if (this.editableTable != undefined) {
            const control = this.editableTable.get('editableRows') as FormArray;
            control.clear();
            if (nestedFields) {
                this._editableGridData.nestedFields = nestedFields;
            } else {
                this._editableGridData.nestedFields = this.setNestedeQuest(this._editableGridData.items, this._editableGridData.listBlocks.fields) || [];
            }
            //console.log("nestedFields", this._editableGridData.nestedFields);
            let cloneCapability = structuredClone(this._editableGridData.bookmarks.capability);
            if (this.findNestedCapability(cloneCapability)) { // check Nested Capability in exits
                const maxLength = Math.max(...cloneCapability.filter(Array.isArray).map(arr => arr.length));
                const arraysWithMaxLength = cloneCapability.filter(arr => Array.isArray(arr) && arr.length === maxLength);
                if (arraysWithMaxLength.length > 0) {
                    cloneCapability = []
                    cloneCapability = arraysWithMaxLength[0]
                }
            }
            this._editableGridData.items.forEach((element, index) => { // Creating grid rows if item exist  
                let group: any = {};
                this._editableGridData.nestedFields[index].forEach(field => {
                    //setUpdateValue sets value of each control
                    let val = this.setUpdateValue(field, element);
                    group[field.key] = field.required ? new FormControl(val, Validators.required)
                        : new FormControl(val);
                    //this will save each question in form control which will let us know the current question in each control
                    group[field.key]['question_component'] = { "question": field };

                    // for TAT validation -- @182319
                    if ((field.key == "TAT" || field.key == "tat") && field.currentStage) {
                        const className = this.setTatFlag(field, element);
                        field.tatClass = className || '';
                    }
                });
                control.push(new FormGroup(group, Validators.required));
                //fires dependent
                this.setDependentUpdate(control, index);
                 // safely update capability
                 if(cloneCapability){
                    setTimeout(() => {
                        this._editableGridData.bookmarks.capability = [...this._editableGridData.bookmarks.capability.slice(0, index), this.addCapability(index, this._editableGridData.items[index], cloneCapability), ...this._editableGridData.bookmarks.capability.slice(index + 1)];
                    }, 700);
                    this.cdRef.detectChanges()
                }
            });

            if (this._editableGridData.selectall != undefined && this._editableGridData.selectall) {
                this.value = this.selectedItems != undefined ? this.selectedItems : [];
            }
            else {
                this.value = this._editableGridData.items;
            }
            let obj = { object: this._editableGridData.items, type: "data_binded", editableGrid: this.editableTable.controls.editableRows['controls'] };
            this.listenEvent(obj);
            setTimeout(() => {
                this.setDefaultRow();
                if (this._editableGridData.draggable || this._editableGridData.cog) {
                    if (this._editableGridData.currentResource != undefined) {
                        let key = this._editableGridData.currentResource + "_list_config";
                        this._editableGridData.user_preference_json = key;
                        this.getFieldsOrder(key);
                        this.HidetoggleVisibility(true, true);
                        if (this._editableGridData['tableInitalized']) {
                            this._editableGridData['tableInitalized'] = false;
                        }
                    }
                }
            }, 1000);
        }
        const endTime = performance.now();
        const executionTime = (endTime - startTime) / 1000;
        //console.log("Time taken to render Editable with data", executionTime)
    }
    checkItemSelection() {
        if (this._editableGridData.selectall && this.selectedItems.length == 0) {
            return false;
        }
        else {
            return true;
        }
    }
    //sets value of each control
    setUpdateValue(field, element) {
        if (field.type == "number" || field.fieldType == "number") {
            return element[field.key] || 0;
        }
        if(field.type == 'date' && field.controlType == "daterangepicker" ){
            if(element[field.key] != undefined){
                return element[field.key];
            }else if(field.value != undefined && field.autoApply != undefined && field.value !="" && field.value){
                return field.value;
            }else{
                return "";
            }
        }
        if (field.type == "boolean" || field.fieldType == "boolean") {
            return element[field.key] || false;
        }
        else {
            return element[field.key] || "";
        }
    }

    setTatFlag(field, item) {
        if (item.tat != undefined) {
            let fromMatched = this.baseService.buildDyanamicStr(field.currentStage, { data: item });
            let toMatched = 'end_stage';
            for (let obj of item.tat) {
                if (obj[toMatched] === fromMatched) {
                    let class_ = obj['critical_tat_expired'] != undefined && obj['critical_tat_expired'] ? 'grid-high-icon' : obj['warn_tat_expired'] != undefined && obj['warn_tat_expired'] ? 'grid-medium-icon' : '';
                    return class_ || '';
                }
            }
        }
    }

    //*******************************************fires dependent initially as in of update******************************************************* */
    setDependentUpdate(control, index) {
        for (let i = 0; i < this._editableGridData.nestedFields[index].length; i++) {
            //if this condition is true than only we have to fire dependents
            if (this._editableGridData.nestedFields[index][i].dependents != undefined && this._editableGridData.nestedFields[index][i].dependents.length > 0) {
                let itemObj = JSON.parse(JSON.stringify(this._editableGridData.nestedFields[index][i]));
                // let itemObj = Object.assign({}, );
                // ;
                //event sets the value as expected by on valuechange function
                let event = { "val": control.controls[index].controls[itemObj.key].value, "question": itemObj, "index": index };
                this.onValueChanged(event, control.controls[index], index);
            }
        }

        // this.onValueChanged(event, current_form, row_index ?);
    }
    getValueBasedOnType(field) {
        if (field && field.hasOwnProperty('type')) {
            switch (field.type) {
                case 'number': {
                    return 0;
                }
                case 'string': {
                    return "";
                }
                case 'boolean': {
                    return false;
                }
                case 'array': {
                    return [];
                }
                case 'monthYear': {
                    return null;
                }
                default: {
                    return field.value ? field.value : "";
                }
            }
        } else {
            if (field.hasOwnProperty('fieldType') && field.fieldType === 'number') {
                return 0;
            } else {
                return ""
            }
        }
    }
    //****************************************************************************for new row added******************************************************
    new_row = (control, index?) => {
        let group: any = {};
        if (this._editableGridData['cloneFields'] != undefined && this._editableGridData['cloneFields']) {
            this._editableGridData['cloneFields'].forEach(field => {
                //added as sometimes default value is set in questions
                if (field.value != undefined && field.value != "" && field.value != null) {
                    group[field.key] = field.required ? new FormControl(field.value, Validators.required)
                        : new FormControl(field.value);
                }
                else {
                    group[field.key] = field.required ? new FormControl(this.getValueBasedOnType(field), Validators.required)
                        : new FormControl(this.getValueBasedOnType(field));
                }
            });
            if (index != undefined)
                control.controls.splice(index, 0, new FormGroup(group));
            else
                control.push(new FormGroup(group));
            this._editableGridData.default_row_added = true;
            this._editableGridData['show_'] = true;
            this.propagateChange(this._editableGridData.nestedFields);
        }
    }

    //******************************************************************get form controls and definitions *************************************/
    get getFormControls() { // Settings form conotrols definition
        const control = this.editableTable.get('editableRows') as FormArray;
        if (control != null) {
            this._editableGridData.items = control.getRawValue(); // need to check again;
            if (this._editableGridData.listBlocks.selectAll) {
                if (this.selectedIndices != null) {
                    this._editableGridData.selectedCount = 0;
                    for (let i = 0; i < this._editableGridData.items.length; i++) {
                        const index = this.selectedItems.findIndex(item => this.isSameItem(item, this._editableGridData.items[i]));
                        if (index > -1) {
                            this._editableGridData.selectedCount++;
                            this.selectedItems[index] = this._editableGridData.items[i];
                        }
                    }
                }
            } else {
                //TODO
            }
        }
        return control;
    }
    //*************************************************checkBox disabled condition*********************************** */
    checkingDisabledStatus() {
        if (this.obj_table && this.obj_table.length > 0 && this._editableGridData.items.length == 0) {
            this._editableGridData.items = this.obj_table;
        }
        if (this._editableGridData.selectallCondition) {
            let arr = [];
            this._editableGridData.items.forEach(item => {
                item['disabled_'] = eval(this._editableGridData.selectallCondition.expression);
                arr.push(item['disabled_']);
            });
            ////console.log("Dynamic Grid ", arr);
            if (arr.includes(false)) {
                this._editableGridData.checkboxCondition = false;
                return this._editableGridData.checkboxCondition;
            } else {
                this._editableGridData.checkboxCondition = true;
                return this._editableGridData.checkboxCondition;
            }
        } else if (this._editableGridData.hideHeaderCheckbox) {
            this._editableGridData.checkboxCondition = true;
            return this._editableGridData.checkboxCondition;
        }
        else if (this.obj_table && this.obj_table.length == 0) {
            this._editableGridData.checkboxCondition = true;
            return this._editableGridData.checkboxCondition;
        }
        else {
            this._editableGridData.checkboxCondition = false;
            return this._editableGridData.checkboxCondition;
        }
    }


    updateCurrentEventLoop(value: boolean) {
       // setTimeout(() => {
            this._editableGridData.checkboxCondition = value;
        //}, 0);
    }

    ////***************************************Disabling each row checkbox based on condition************************* */
    disableSingleItem(item) {
        if (this._editableGridData.selectallCondition) {
            let disabled = eval(this._editableGridData.selectallCondition.expression);
            return disabled;
        } else {
            return false;
        }
    }
    /// *************************Checkbox select All/DeselectAll  event**********************************
    async onAllChecked(checked: boolean) {
        if (this.isSelectAllOverLimit(checked)) {
            return;
        }
        let items = [];
        this._editableGridData.items.forEach((item, index) => {
            item['index'] = index;
            if (this._editableGridData.selectallCondition) {
                let disabled = eval(this._editableGridData.selectallCondition.expression)
                if (!disabled) {
                    this.selectedIndices[index] = checked;
                    if (checked)
                        items.push(item);
                }
            } else {
                this.selectedIndices[index] = checked;
                if (checked) {
                    items.push(item);
                }
            }
        });
        this.selectedItems = items;
        this.value = items;
        await this.listenEvent({ object: items, type: "checkbox", checked: checked, editableGrid: this.editableTable.controls.editableRows['controls'] });
        if (this._isMaintainCheckBox()) {
            this.saveCheckboxState(checked,undefined, undefined, "allChecked")
        };

    }


    async onSelectedItemChek(checked: any) {
        let items = [];
        this._editableGridData.items.forEach((item, index) => {
            item['index'] = index;
            //console.log("this._editableGridData", this._editableGridData)
            if (this._editableGridData.all_selected_condition) {
                let checked_ = eval(this._editableGridData.all_selected_condition.expression)
                if (checked_) {
                    this.selectedIndices[index] = true;
                    items.push(item);
                } else {
                    this.selectedIndices[index] = false;
                    // items.push(item);
                }
            }
        });
        this.selectedItems = items;
        this.value = items;
        await this.listenEvent({ object: items, type: "checkbox", checked: checked, editableGrid: this.editableTable.controls.editableRows['controls'] });
    }

    // settings.max_select: true when checking this row would exceed the limit; shows the error and unticks the row checkbox again
    isSelectLimitReached(checked: boolean, index: number): boolean {
        const max = this._editableGridData.max_select;
        if (!checked || !max || this.selectedItems.length < max) {
            return false;
        }
        this.alerts.error("You can select only up to " + max + " rows");
        this.selectedIndices[index] = true;
        this.cdRef.detectChanges();
        this.selectedIndices[index] = false;
        this.cdRef.detectChanges();
        return true;
    }

    // settings.max_select: true when select-all would check more rows than the limit; shows the error and unticks the header checkbox again
    isSelectAllOverLimit(checked: boolean): boolean {
        const max = this._editableGridData.max_select;
        if (!checked || !max) {
            return false;
        }
        const selectable = this._editableGridData.items.filter(item => !(this._editableGridData.selectallCondition && eval(this._editableGridData.selectallCondition.expression))).length;
        if (selectable <= max) {
            return false;
        }
        this.alerts.error("You can select only up to " + max + " rows");
        const selectedItems = this.selectedItems;
        this.selectedItems = [...this.obj_table];
        this.cdRef.detectChanges();
        this.selectedItems = selectedItems;
        this.cdRef.detectChanges();
        return true;
    }

    ///********************************************************Each row checkbox check event ********************************* */
    onItemChecked(checked: boolean, index: number, current_form) { // checkbox in each row checked /unchecked event
        if (this.isSelectLimitReached(checked, index)) {
            return;
        }
        //FOR IMP mULTI CHECK Func on same field val
        if (this._editableGridData != undefined && this._editableGridData.config != undefined && this._editableGridData.config.checkBoxConfig != undefined && this._editableGridData.config.checkBoxConfig.GROUP_KEY != undefined && this.appService!=undefined && this.appService.getAccountConfig()!=undefined &&this.appService.getAccountConfig().enableMultiSelectOnEditabeGrid!=undefined && this.appService.getAccountConfig().enableMultiSelectOnEditabeGrid===true) {
            let GROUP_KEY = this._editableGridData.config.checkBoxConfig.GROUP_KEY;
            const formArray = this.getFormControls;
            formArray.controls.forEach((group: FormGroup, i: number) => {
                if (current_form.get(GROUP_KEY)?.value && group.value?.[GROUP_KEY] && group.value?.[GROUP_KEY] && group.value?.[GROUP_KEY] === current_form.get(GROUP_KEY)?.value) {
                    this.checkItem(checked, i);
                } else {
                    this.checkItem(checked, index);
                }
            });
        }
        else {
            this.checkItem(checked, index);
        }
        if (this._isMaintainCheckBox()) {
            const currentPage = this._editableGridData.page_no || 0;
            const itemPage = this.selectedItems[index]?.page || currentPage;
            if (itemPage === currentPage) {
                this.saveCheckboxState(undefined, checked, index, "singleCheck")
            }
        };
    }
    // **********************************************************Checking item position in data***************************************************
    private checkItem(checked: boolean, index: number) {
        this.selectedIndices[index] = checked;
        this.selectedItems = [];
        for (let d in this.selectedIndices) {
            if (this.selectedIndices[d]) {
                this.editableTable.controls.editableRows['controls'][d].value['index'] = d;
                let val = this.editableTable.controls.editableRows['controls'][d].value;
                let rawVal = this.editableTable.controls.editableRows['controls'][d].getRawValue();
                //merging form value and rawvalue as we have set index in value which don't contains the value of disabled attributes 
                let resultObj = { ...val, ...rawVal };;
                this.selectedItems.push(resultObj);
            }
        }
        this.value = this.selectedItems; //added as it will set value to the 
        // if(this.selectedItems.length==0){ 
        //     this.checkingDisabledStatus();
        //     this.onAllChecked(false);
        // }
        let obj = { object: this.selectedItems, type: "checkbox", checked: checked, index: index, editableGrid: this.editableTable.controls.editableRows['controls'] };
        this.listenEvent(obj);
        //this.listen_changes.emit({ object: this.selectedItems, type: "checkbox", checked: checked, index: index });  //emitting checkbox actions 
    }

    private isSameItem(i1: any, i2: any): boolean { // checing for Same  item in grid
        return this.getNestedValue(i1, "sq_no") === this.getNestedValue(i2, "sq_no");
    }

    private getNestedValue(obj: any, key: string): any { // Need rafactoring 
        const keys = key.split('.');
        for (const k of keys) {
            obj = obj[k];
        }
        return obj;
    }

    getIdKey(option, key) {
        if (option.hasOwnProperty(key.getterKey)) {
            return option[key.getterKey];
        }
    }
    /*********************************************Calculating eval()******************************************** */
    getValue(currentFormGroup, field) {
        let item = currentFormGroup.value;
        if (field.expression != undefined) {
            if (field.expression != undefined && item != undefined) {
                return eval(field.expression);
            }
        }
    }

    getDictionary(url: string, queryId: any = false, application?: any, args?: any, filter?: any): Observable<any> {
        var queryId = (queryId) ? queryId : 'GET_ALL';
        var application = (application) ? application : '';
        if (args == null)
            args = '';
        return this.baseService.getDataAsPerResource(queryId, args, url, application, filter)
            .pipe(map(res => this.extractData(res.resource)));

    }

    private extractData(res) {
        let data = (res != undefined) ? res.data || res : [];
        return data;
    }
    perRowAdd(index: number, act) { /////*******************************Per row add button click************************ */
        let isAdd = this._editableGridData.listBlocks.actions[0].conditions.filter(d => {
            return d.add_row == true
        })
        if (isAdd && isAdd.length > 0) {
            this.addRow(this._editableGridData.items.length);
        }
        let obj = { object: this.editableTable.controls.editableRows.value[index], index: index, type: "add" };
        this.listenEvent(obj);
    }
    ///**********************************************************add new row function************************************ */
    addRow(index: number, default_row?) { // Add new row in grid event
        /******** DEOCRATOR IMPLEMENTATION *******/
        if (this._editableGridData.decorator != undefined && this._editableGridData.decorator && this._editableGridData.decorator.beforeAddRowEG != undefined) {
            if (this._editableGridData.decorator.beforeAddRowEG(this.buildDecoratorFormObj(null, index)) === false) {
                return;
            }
        }
        /******** DEOCRATOR IMPLEMENTATION *******/
        if (this.formService && !this.formService.editableGrid) {
            this.setEditableGrid(true);
        }
        this.loader.showSpinner();
        this.setToInitialPostion('scroll-to-initial', 0);
        let item = this._editableGridData.items[index];
        var itemObj: any = {};
        if (item != undefined) {
            itemObj = Object.assign({}, item);
            if (itemObj.id) itemObj.id = null;
            this._editableGridData.items.splice(index + 1, 0, itemObj);
            const control = this.editableTable.get('editableRows') as FormArray;
            this.new_row(control);
        } else {
            for (let data of this._editableGridData.listBlocks.fields) {
                if (data.type) {
                    if (data.type.toLocaleLowerCase() === "string") itemObj[data.name] = "";
                    else if (data.type.toLocaleLowerCase() === "number") itemObj[data.name] = 0;
                    else if (data.type.toLocaleLowerCase() === "boolean") itemObj[data.name] = false;
                    else itemObj[data.name] = "";
                } else {
                    itemObj[data.name] = "";
                }
                data['index'] = index;
            }
            this._editableGridData.items.splice(1, 0, itemObj);
            // this._editableGridData.items.push(itemObj);
            const control = this.editableTable.get('editableRows') as FormArray;
            this.new_row(control);
            ////console.log("this._editableGridData.nestedFields  = this._editableGridData.items;", this._editableGridData.nestedFields, this._editableGridData.items);
            let fields_ = JSON.parse(JSON.stringify(this._editableGridData.listBlocks.fields));
            let newRow;
            if (!default_row) {
                newRow = this.formService.buildQuestions(fields_);
            }
            else {
                newRow = this._editableGridData['cloneFields'];
            }
            if (newRow.length > 0 && this._editableGridData.fieldsOrder && Object.keys(this._editableGridData.fieldsOrder).length > 0) {
                for (let d of newRow) {
                    if (this._editableGridData.fieldsOrder.hasOwnProperty(d.key)) {
                        d.order = this._editableGridData.fieldsOrder[d.key];
                    }
                }
                newRow.sort((a, b) => { return a.order - b.order });
            }
            this._editableGridData.nestedFields.push(newRow);
        }
        this.checkValidation();
        let obj = { object: itemObj, index: index, type: "new_row", editableGrid: this.editableTable.controls.editableRows['controls'] };
        this.listenEvent(obj);
        this.propagateChange(this._editableGridData.items);
        this._editableGridData['show_'] = true;
        this.loader.hideSpinner();
        this.removeDragListner();
        this._editableGridData.tableInitalized = false;
        this.applyUserPreference(this._editableGridData.user_preference_json);
    }
    removeAll(id) {
        var element = document.getElementsByTagName(id), index;
        for (let index = element.length - 1; index >= 0; index--) {
            element[index].parentNode.removeChild(element[index]);
        }
    }
    geTitile() {
        if (this._editableGridData) {
            return "EDIT"
        }
    }
    editRowOnPopup(index: number) {
        //console.log("Index is", index);
        this.removeAll("app-aside-ui-engine");
        this.removeAll('aside-modal-container');
        let row_data;
        if (this._editableGridData && this._editableGridData.items && this._editableGridData.items.length > 0) {
            row_data = this._editableGridData.items[index]
        }
        let componentConfig = {
            inputs: { data: { row_data: row_data, configData: this._editableGridData, title: this.geTitile() } }
        };
        if (true) {
            this.subs.add(this.asideBarService.appendComponentTo('aside-modal-container', EditGridOverPopUpComponent, componentConfig, 'lg', 'Edit').subscribe((res: any) => {
                if (res) {
                    debugger;
                }
            }))
        }

    }
    editRow(index: number) { // Edit erow event -- Need to disscuss // Not in use for now
        let activatedResource = this.route.snapshot.data.decorator;
        let action = 'MODIFY';
        let dataVal = this._editableGridData.items[index];
        let newobj = { data: { formblocks: this._editableGridData.formBlocks, data: dataVal, activatedResource: activatedResource, action: action } };
        this.subs.add(this.dialogService.open(CompositeArrayObjectComponent, newobj).afterClosed.subscribe(
            response => {
                if (response != null) {
                    this._editableGridData.items.splice(index, 1);
                    this._editableGridData.items.push(response.result);
                    this.initiateForm();
                }
            }));
    }
    // //*****************************************************In filter apply() functin click************************************************** */
    filterClick(event) {
        this.sortObject = false;
        this.currentSort.clear();
        this._currentData.saveFilterKey = true;
        let filter = "";
        if (this._editableGridData && this._editableGridData.existingFilter) {
            filter = this._editableGridData.existingFilter;
        }
        //setting page no to zero as yhis should be on first page
        this._editableGridData.page_no = 0;
        this.fetchData(this._editableGridData.listBlocks.APIresource.datasource, filter
            ? filter : "", event);
        this._editableGridData.exsitingComplexSearch = event;
    }
    // public onFilter(event) {
    //     var valid = this.filterValidate(event);
    //     if (valid) {
    //         if (event.keyCode === 13) {
    //             this.applySearch(event.target.value);
    //         }
    //     }
    // }
    // ///**************************************************Validating filter string*********************************************************** */
    // public filterValidate(e) {
    //     var invalidChars = ["%"];
    //     if (invalidChars.includes(e.key)) {
    //         e.preventDefault();
    //         return false;
    //     } else {
    //         return true;
    //     }
    // }
    // onFilterClick(event) {
    //     this.applySearch(event.target.value);
    // }
    // applySearch(searchStr) {
    //     this.fetchData(this._editableGridData.listBlocks.APIresource.datasource, "", searchStr);
    // }

    //**********************************************************for copy row************************************************************
    default_row = (control, index?) => {
        let group: any = {};
        this._editableGridData.fields.forEach(field => {
            //added as sometimes default value is set in questions
            group[field.key] = field.required ? new FormControl('', Validators.required)
                : new FormControl('');
            let obj = JSON.parse(JSON.stringify(field));
            if (obj) {
                obj.index = obj.index + 1;
                group[field.key]['question_component'] = { "question": obj };
            }
        });
        if (index != undefined) {
            //control.controls.splice(index, 0, new FormGroup({ ...group }));
            control.insert(index, new FormGroup({ ...group }));//197746 fix
        }
        else
            control.push(new FormGroup(group));
        this._editableGridData.default_row_added = true;
        this._editableGridData['show_'] = true;
    }
    //****************************************Copy row function ******************************************************************** */
    copyRow(index: number) {
        var data = this.editableTable.getRawValue();
        let newItem = JSON.parse(JSON.stringify(data.editableRows[index]));
        if (newItem.hasOwnProperty('id')) {
            newItem.id = "";
        }
        this._editableGridData.items.splice(index, 0, newItem);
        // this.updatingIndex(this._editableGridData.items);
        const control = this.editableTable.get('editableRows') as FormArray;
        this.default_row(control, index + 1);
        control.controls[index + 1].patchValue(newItem);
        let cloneObj = JSON.parse(JSON.stringify(this._editableGridData.nestedFields[index]));
        for (let i = 0; i < cloneObj.length; i++) {
            cloneObj[i]['index'] = index + 1;
        }
        this._editableGridData.nestedFields.splice(index + 1, 0, cloneObj);

        if (this._editableGridData.selectall && this._editableGridData.all_selected) {
            if (this.selectedIndices[index]) {
                this.selectedIndices.splice(index + 1, 0, true);
                this.selectedItems.splice(index + 1, 0, this._editableGridData.items[index + 1]);
            } else {
                this.selectedIndices.splice(index + 1, 0, false);
            }
            this.settableobj();
        }
        setTimeout(() => {
            this.updatingIndex(this._editableGridData.nestedFields);
            this.propagateChange(this._editableGridData.items);
            this.cdRef.detectChanges();

            let obj = { object: control, index: index, type: "copy_row" };
            this.listenEvent(obj);
        });
        this.cdRef.detectChanges();
    }
    // this will update index of each question 
    updatingIndex(array_) {
        if (array_ && array_.length) {
            // this.loader.showSpinner();
            for (let i = 0; i < array_.length; i++) {
                let item = array_[i];
                if (item) {
                    for (let currenRow of item) {
                        currenRow['index'] = i;
                    }
                }
            }
            //this.loader.hideSpinner();
        }
    }

    //******************************************************Delete data from DB***********************************************// 
    delete_Data(datasource, data) {
        this.subs.add(this.baseService.action(data, datasource.action, datasource.application, datasource.resource, false).subscribe((res) => {
            // console.log("respponse is", res);
            if (res.errCode == 0) {
                if (datasource.hasOwnProperty('refresh_grid') && !datasource.refresh_grid) {
                    this.loader.hideSpinner();
                    this.alerts.success(res.message);
                } else {
                    this.fetchData(this._editableGridData.listBlocks.APIresource.datasource)
                    this.alerts.success(res.message);
                }
            } else if (res.errCode == -1) {
                this.alerts.error(res.message);
                this.loader.hideSpinner();
            }
        }, (err) => {
            //console.log("respponse is", err);
            this.loader.hideSpinner();
        }))
    }
    //************Info in actions****************************** */
    onInfoClick(index: number) {
        if (this._editableGridData.actions.length > 0) {
            var flagAction = this._editableGridData.actions[0].conditions.find(x => x['info'] == true);
            if (flagAction) {
                this.listenEvent({ object: this.editableTable, index: index, type: "info_clicked", editableGrid: this.editableTable.controls.editableRows['controls'], metadata: flagAction });
            }
        }
    }

    //***************End****************************** */

    //************Flag in actions****************************** */
    onFlagClick(index: number) {
        if (this._editableGridData.actions.length > 0) {
            var flagAction = this._editableGridData.actions[0].conditions.find(x => x['flag'] == true);
            if (flagAction) {
                this.listenEvent({ object: this.editableTable, index: index, type: "Flag_clicked", editableGrid: this.editableTable.controls.editableRows['controls'] });
            }
        }
    }
    //***************End****************************** */

    //************Decorator Based in actions****************************** */
    decoratorBased(action, index){
        if (action && action.decorator_based && this._editableGridData.actions.length > 0 && this.editableTable) {
            this.listenEvent({ action: action, object: this.editableTable, index: index, type: "decorator_based", editableGrid: this.editableTable.controls.editableRows['controls'] });
        }
    }
    //***************End****************************** */

    // ******************************************************Remove row event**********************************************************************
    removeRow(index: number) {
        if (this._editableGridData.actions.length > 0) {
            this.loader.showSpinner();
            var deleteAction = this._editableGridData.actions[0].conditions.find(x => x['delete'] == true);
            if (deleteAction.hasOwnProperty('datasource')) {
                if (deleteAction.emitDelete != undefined && deleteAction.emitDelete) {
                    this.listenEvent({ object: this.editableTable, index: index, type: "delete_value", editableGrid: this.editableTable.controls.editableRows['controls'], datasource: deleteAction.datasource });
                    // this.fetchData(this._editableGridData.listBlocks.APIresource.datasource);
                    this.loader.hideSpinner();
                    return false;
                } else if (deleteAction.confirm_delete) {
                    const dialogRef = this.modalService.confirm("CONFIRM", 'Are you sure want to Delete ?');
                    this.loader.hideSpinner();
                    this.subs.add(dialogRef.subscribe(result => {
                        if (result) {
                            this.delete_Data(deleteAction.datasource, this._editableGridData.items[index]);
                        }
                    }))
                } else {
                    this.delete_Data(deleteAction.datasource, this._editableGridData.items[index]);
                }
            } else {
                // if(index==0){
                //     this.loader.hideSpinner();
                //     return false;
                // }
                if (!this._editableGridData.add_new && index == 0 && this._editableGridData.items.length == 1) {
                    this.loader.hideSpinner();
                    if (this._editableGridData.hasOwnProperty('item_deleted') && this._editableGridData.item_deleted) {
                        //TODO
                    } else {
                        this.listenEvent({ object: this.editableTable, index: index, type: "remove_row", editableGrid: this.editableTable.controls.editableRows['controls'] });
                        this.alerts.info("only item can not be deleted");
                        return false;
                    }
                }

                if (deleteAction.hasOwnProperty('datasourceWithDelete')) {
                    let exp = false;
                    let item = this._editableGridData.items[index];
                    exp = eval(deleteAction.datasourceWithDelete.expression);
                    if (exp) {
                        this.delete_Data(deleteAction.datasourceWithDelete, this._editableGridData.items[index]);
                    }
                }
                // static pagination hndling
                if (this?._editableGridData?.static_pagination && this.fullData?.length > 0) {
                    const page = this?.pagination?.currentPage || 1;
                    const limit = this?.pagination?.limit || 25;
                    const fullDataIndex = ((page - 1) * limit) + index;
                    if (fullDataIndex >= 0 && fullDataIndex < this.fullData.length) {
                        this.fullData.splice(fullDataIndex, 1);
                    }
                }
                this._editableGridData.items.splice(index, 1);
                if (this.selectedIndices.length > 0 && this._editableGridData.selectall && this.selectedItems.length) {
                    this.selectedIndices.splice(index, 1);
                    this.selectedItems = [];
                    for (let df in this.selectedIndices) {
                        if (this.selectedIndices[df]) {
                            this.selectedItems.push(this.editableTable.value.editableRows[df])
                        }
                    }
                }
                const control = this.editableTable.get('editableRows') as FormArray;
                control.removeAt(index);
                this._editableGridData.nestedFields.splice(index, 1);
                this.valueAdded.emit({ type: true, items: this._editableGridData.items });
                this.value = this.editableTable.value.editableRows;
                //this.listen_changes.emit({ object: this.editableTable.value.editableRows[index], type: "remove_row" });
                this.propagateChange(this._editableGridData.items);
                this._editableGridData.itemsCount = this._editableGridData.items.length;
                this.writeValue(this._editableGridData.items);
                this.listenEvent({ object: this.editableTable, index: index, type: "remove_row", editableGrid: this.editableTable.controls.editableRows['controls'] });
                if (this?._editableGridData?.static_pagination && this.fullData?.length > 0) {
                    const currentPage = this?.pagination?.currentPage || 1;
                    this.setUiPagination();
                    if (this._editableGridData.items.length === 0 && currentPage > 1) {
                        this.pagination.currentPage = currentPage - 1;
                        this._editableGridData.page_no = currentPage - 2;
                        this.setUiPagination();
                    }
                }
                this.loader.hideSpinner();
                return false;
            }
        }
    }


    getFormattedValue(index: any, field: any) {
        const myForm = (this.editableTable.get('editableRows') as FormArray).at(index);
        if (field && field.format) { // for composite label name
            var item = myForm.value;
            var ed_fn;
            let u = eval(field.format)(item)
            return u;
        }
        return myForm.get(field.key).value;
    }
    checkValidation() {
        if (this.editableTable.status === 'VALID') {
            this.validIn = false;
        } else {
            this.validIn = true;
        }

    }
    buildDecoratorFormObj(current_form, row_index, question?) {
        return {
            'current_form': current_form,
            'index': row_index,
            'editableTable': this.editableTable,
            'parentForm': this.parentForm != undefined ? this.parentForm : false,
            'question': question != undefined ? question : false,
            'selectedIndices': this.selectedIndices,
            'selectededItem': this.selectedItems
        };
    }
    //************************************************any change in grid controls this function will call each and every time****************************************************// 
    onValueChanged(event, current_form, row_index?) {
        /******** DEOCRATOR IMPLEMENTATION *******/
        if (this._editableGridData.decorator != undefined && this._editableGridData.decorator && this._editableGridData.decorator.valueChangeStartEG != undefined) {
            this._editableGridData.decorator.valueChangeStartEG(event, this.buildDecoratorFormObj(current_form, row_index));
        }
        /******** DEOCRATOR IMPLEMENTATION *******/
        if (event.question != undefined && event.question.dependents != undefined && event.question.dependents.length > 0) {
            for (let index = 0; index < event.question.dependents.length; index++) {
                var dependents = event.question.dependents[index];
                var conditionMet: boolean = false;
                var conditionNotMet: boolean = false;
                if (dependents.hasOwnProperty('expression')) {
                    let item = current_form.value;
                    let result = eval(dependents.expression)
                    if (result == true)
                        conditionMet = true;
                    else
                        conditionNotMet = true;
                }
                else if (typeof event.val === 'object') {
                    conditionMet = event.val[event.question.getterKey] === dependents.value ? true : false;
                    conditionNotMet = event.val[event.question.getterKey] != dependents.value ? true : false;
                }
                else {
                    conditionMet = event.val === dependents.value ? true : false;
                    conditionNotMet = event.val != dependents.value ? true : false;
                }
                if (conditionMet) {
                    this.metDependent(current_form, dependents, event.val, row_index);
                }
                if (conditionNotMet) {
                    if (!dependents?.change_value_expression) {
                    this.unmetDependent(current_form, dependents, event.val, row_index);
                    }
                }
            }
        }
        this.checkValidation();
        //sets value to the control
        this.setValue(row_index, current_form, event.question.key);
        this.propagateChange(this._editableGridData.items);
        /******** DEOCRATOR IMPLEMENTATION *******/
        if (this._editableGridData.decorator != undefined && this._editableGridData.decorator && this._editableGridData.decorator.valueChangeEndEG != undefined) {
            this._editableGridData.decorator.valueChangeEndEG(event, this.buildDecoratorFormObj(current_form, row_index));
        }
        /******** DEOCRATOR IMPLEMENTATION *******/
        this.cdRef.detectChanges();
    }
    //set value to the control
    setValue(row_index, current_form, control?) {
        if (this._editableGridData.selectall != undefined && this._editableGridData.selectall && this.selectedItems != undefined) {
            if (this.selectedItems != undefined) {
                for (let i = 0; i < this.selectedItems.length; i++) {
                    if (this.selectedItems[i]['index'] == row_index) {
                        this.selectedItems[i] = Object.assign(this.selectedItems[i], current_form.value);
                    }
                }
                this.value = this.selectedItems;
                current_form.controls[control].updateValueAndValidity();
                if (current_form && !current_form.pristine && this._isMaintainCheckBox()) {
                    this.saveCheckboxState()
                };
            }
        }else {
            this.value = this.editableTable.getRawValue().editableRows;
        }
        if(this?._editableGridData?.static_pagination){
            if(this?.fullData?.[row_index]){
                let indx_data =  current_form.getRawValue();
                const item = this.fullData.find(x => x.id === indx_data.id);
                if (item) {
                    item[control] = indx_data[control];
                }
            }
            this.listenEvent({full_data:this.fullData, object: current_form, type: "full_data", question: current_form.controls[control].question_component.question, editableGrid: this.editableTable.controls.editableRows['controls'], index: row_index });
        }
        this.updatingIndex(this._editableGridData.nestedFields);
        if (current_form.controls[control] != undefined && current_form.controls[control].question_component != undefined && current_form.controls[control].question_component.question != undefined && current_form.controls[control].question_component.question.controlType == 'searchselect') {
            setTimeout(() => {
                this.listenEvent({ object: current_form, type: "searchselect", question: current_form.controls[control].question_component.question, editableGrid: this.editableTable.controls.editableRows['controls'], index: row_index });
            });
        } else {
            this.listenEvent({ object: current_form, type: "field_change", index: row_index, editableGrid: this.editableTable.controls.editableRows['controls'], question: current_form.controls[control].question_component != undefined ? current_form.controls[control].question_component.question : {}, selectedItems: this.value });
        }


    }
    //for condition met dependent
    metDependent(current_form, dependents, currentVal, row_index?) {
        switch (dependents.action) {
            case 'change_value':
                this.changeValue(current_form, dependents);
                break;
            case 'disable':
                this.setFieldDisabled(current_form, dependents);
                break;
            case 'enable':
                this.setFieldEnable(current_form, dependents);
                break;
            case 'populate_field':
                this.populateField(current_form, dependents, currentVal);
                break;
            case 'change_value_fill_controls':
                this.getDependentApi(current_form, dependents, currentVal);
                break;
            case 'calculate':
                this.calculateValue(current_form, dependents, currentVal);
                break;
            case 'validate':
                this.changeRunTimeValidation(current_form, dependents, currentVal);
                break;
            case 'visible':
                this.setFieldVisible(current_form, dependents);
                break;
            case 'invisible':
                this.setFieldInVisible(current_form, dependents);
                break;
            default:
                //do nothing
                break;
        }
    }
    unmetDependent(current_form, dependents, currentVal, row_index) {
        switch (dependents.action) {
            case 'change_value':
                this.changeValue(current_form, dependents, row_index);
                break;
            case 'disable':
                this.setFieldEnable(current_form, dependents);
                break;
            case 'enable':
                this.setFieldDisabled(current_form, dependents);
                break;
            case 'populate_field':
                this.populateField(current_form, dependents, currentVal);
                break;
            case 'change_value_fill_controls':
                this.getDependentApi(current_form, dependents, currentVal);
                break;
            case 'calculate':
                this.calculateValue(current_form, dependents, currentVal);
                break;
            case 'validate':
                this.changeRunTimeValidation(current_form, dependents, currentVal);
                break;
            case 'visible':
                this.setFieldInVisible(current_form, dependents);
                break;
            case 'invisible':
                this.setFieldVisible(current_form, dependents);
                break;
            default:
                //do nothing
                break;
        }
    }
    changeRunTimeValidation(current_form, dependents, currentVal) {
        let item = current_form.value;
        if (dependents.validations && item) {
            if (dependents.validations.validation_type == "compare") {
                if (eval(dependents.validations.expression)) {
                    current_form.controls[dependents.validations.control_to_validate].setValidators([Validators.max(current_form.controls[dependents.dependent_field].value)]);
                    current_form.controls[dependents.validations.control_to_validate].updateValueAndValidity();
                } else {
                    //TODO
                }
            }
            if (dependents.validations.validation_type == "validate") {
                if (eval(dependents.validations.expression)) {
                    current_form.controls[dependents.validations.control_to_validate].setValidators([Validators.required]);
                    current_form.controls[dependents.validations.control_to_validate].updateValueAndValidity();
                }
                else if (dependents.validations && dependents.validations.removeValidate != undefined && dependents.validations.removeValidate) {
                    current_form.controls[dependents.validations.control_to_validate].clearValidators();
                    current_form.controls[dependents.validations.control_to_validate].updateValueAndValidity();
                }
            }
        }
        this.checkValidation();
    }
    calculateValue(current_form, dependents, currentVal) {
        let item = currentVal;
        if (item) {
            current_form.controls[dependents.dependent_field].setValue(eval(dependents.expression));
        }
        if (dependents && dependents.hasOwnProperty('calculation')) {
            let item = current_form.value;
            current_form.controls[dependents.dependent_field].setValue(eval(dependents.expression));
        }
    }
    getDependentApi(current_form, dependents, currentVal) {
        // this.value = this.editableTable.value
        if (currentVal) {
            var obj = {
                args: dependents.args ? this.baseService.buildDyanamicStr(dependents.args, { data: current_form.value }) : '',
                filter: dependents.filter ? this.baseService.buildDyanamicStr(dependents.filter, { data: current_form.value }) : '',
            }
            if (this.baseService.validateParams(obj.args) && this.baseService.validateParams(obj.filter)) {
                this.loader.showSpinner();
                this.subs.add(this.baseService.getData(obj, "", dependents.resource, dependents.application, dependents.query_id).subscribe((res) => {
                    if (res.errCode == 0 && res.hasOwnProperty('resource') && res.resource.length > 0) {
                        for (let data of dependents['fill-controls']) {
                            if (data) {
                                if (this.formService.questionMapping[data] != undefined && current_form._manualChange != undefined && current_form._manualChange) {
                                    // this.formService.questionMapping[data] = res.resource[0][data];
                                    current_form.controls[data].setValue(res.resource[0][data]);
                                }
                                var question = current_form.controls != undefined && current_form.controls[data] != undefined && current_form.controls[data].question_component != undefined ? current_form.controls[data].question_component.question : "";
                                if (question && question.dependents != undefined && question.dependents) {
                                    this.onValueChanged({ question: question, val: res.resource[0][data] }, current_form);
                                }
                            }
                        }
                        this.loader.hideSpinner();
                        this.listenEvent({ object: current_form, type: "api_change" });
                    } else {
                        this.alerts.info(res.message);
                        this.loader.hideSpinner();
                        // TODO
                    }
                    //this.populateField(current_form, dependents, currentVal);
                }, (err) => {
                    //console.log("error ");
                }))
            }
            else {
                console.error("Invalid args or filters");
            }
        } else { // start reversersing value for dependent fields
            if (dependents.hasOwnProperty('fill-controls') && dependents.hasOwnProperty('reverse_value')) {
                for (let data of dependents['fill-controls']) {
                    if (data) {
                        if (this.formService.questionMapping[data] != undefined && current_form._manualChange != undefined && current_form._manualChange) {
                            current_form.controls[data].setValue(this.getValueBasedOnType(this.formService.questionMapping[data]));
                        }
                    }
                }
                this.loader.hideSpinner();
            }
        }
    }
    //populate actions
    populateField(current_form, dependent, currentVal) {
        if (this.formService.questionMapping[dependent.dependent_field] != undefined && current_form._manualChange != undefined && current_form._manualChange) {
            if (dependent.expression != undefined) {
                let item = current_form.value;
                let val = eval(dependent.expression);
                current_form.controls[dependent.dependent_field].setValue(val);
            }
            else {
                if (current_form.controls != undefined && current_form.controls[dependent.dependent_field] != undefined && currentVal != undefined && currentVal[dependent.value] != undefined) {
                    current_form.controls[dependent.dependent_field].setValue(currentVal[dependent.value]);
                }
                else {
                    if (typeof currentVal == "object" && !currentVal.hasOwnProperty(dependent.dependent_field) && current_form.controls[dependent.dependent_field].question_component) {
                        current_form.controls[dependent.dependent_field].setValue(this.getValueBasedOnType(current_form.controls[dependent.dependent_field].question_component.question));
                    }
                }

            }
            if (current_form.controls != undefined && current_form.controls[dependent.dependent_field] != undefined && current_form.controls[dependent.dependent_field].question_component != undefined && current_form.controls[dependent.dependent_field].question_component.question != undefined) {
                var question = current_form.controls[dependent.dependent_field].question_component.question;
                if (currentVal && currentVal[dependent.value])
                    this.fireDependent(question, current_form, currentVal[dependent.value]);
                if (!currentVal) {
                    current_form.controls[dependent.dependent_field].setValue(this.getValueBasedOnType(current_form.controls[dependent.dependent_field].question_component.question));
                }
            }
            // if(current_form.controls != undefined && current_form.controls[dependent.dependent_field] != undefined && (currentVal == undefined ||  currentVal=="")){
            //     current_form.controls[dependent.dependent_field].setValue(currentVal);
            // }


            //this.value = this.editableTable.value.editableRows;
            //this.listen_changes.emit({ object: current_form, type: "populate_field" });
        } else if (this.formService.questionMapping[dependent.dependent_field] != undefined && dependent.hasOwnProperty('populate_hidden')) {
            if (current_form.controls[dependent.dependent_field].question_component) {
                if (!current_form.controls[dependent.dependent_field].value) { // if value is undefined then populate value based on type
                    current_form.controls[dependent.dependent_field].setValue(this.getValueBasedOnType(current_form.controls[dependent.dependent_field].question_component.question));
                }
            }
        }
    }
    //recursive call to onvaluechanged
    fireDependent(question, current_form, val) {
        if (question.dependents != undefined && question.dependents.length > 0) {
            this.onValueChanged({ question: question, val: val }, current_form);
        }
    }
    //disable
    setFieldDisabled(current_form, dependent) {
        if (current_form.controls[dependent.dependent_field] != undefined || !(current_form.controls[dependent.dependent_field])) {
            current_form.controls[dependent.dependent_field].question_component.question.disabled = true;
            current_form.controls[dependent.dependent_field].disable();
               //for value set to default
            if(dependent.setToDefault && current_form._manualChange){
                current_form.controls[dependent.dependent_field].setValue(this.getBlankValue(current_form.controls[dependent.dependent_field].value))
            }
        }
     
    }

    getBlankValue(value: any): any {
        if (Array.isArray(value)) {
          return [];
        }
        switch (typeof value) {
          case 'string':
            return '';
          case 'number':
            return 0;
          case 'boolean':
            return false;
          case 'object':
            return {};
          default:
            return null;
        }
    }
    //enable
    setFieldEnable(current_form, dependent) {
        if (current_form.controls[dependent.dependent_field] != undefined) {
            current_form.controls[dependent.dependent_field].question_component.question.disabled = false;
            current_form.controls[dependent.dependent_field].enable();
        }
    }
    //visible
    setFieldVisible(current_form, dependent) {
        if (current_form.controls[dependent.dependent_field] != undefined) {
            current_form.controls[dependent.dependent_field].question_component.question.visible = false;
        }
        setTimeout(() => {
            if (current_form.controls[dependent.dependent_field] != undefined) {
                current_form.controls[dependent.dependent_field].question_component.question.visible = true;
            }
        });
    }
    //invisible
    setFieldInVisible(current_form, dependent) {
        if (current_form.controls[dependent.dependent_field] != undefined) {
            current_form.controls[dependent.dependent_field].question_component.question.visible = false;
        }
        if (dependent && dependent.hasOwnProperty('expression')) {
            let item = current_form.getRawValue();
            if (item) {
                let result = eval(dependent.expression);
                if (result) {
                    current_form.controls[dependent.dependent_field].question_component.question.visible = false;
                }
            }
        }
    }
    //change_value
    changeValue(current_form, dependent, index?: number) {
        //cloning the question of dependent into question variable
        let cloneDependent = JSON.parse(JSON.stringify(dependent));
        if (cloneDependent && cloneDependent.dependent_field && current_form.controls[cloneDependent.dependent_field].question_component && current_form.controls[cloneDependent.dependent_field].question_component.question) {
            var question = current_form.controls[cloneDependent.dependent_field].question_component.question;
            if (index && question.index != index) {
                question.index = index;
            }
            cloneDependent.args = cloneDependent.args ? this.baseService.buildDyanamicStr(cloneDependent.args, { data: current_form.getRawValue() }) : '',
                cloneDependent.filter = cloneDependent.filter ? this.baseService.buildDyanamicStr(cloneDependent.filter, { data: current_form.getRawValue() }) : ''
            var field: any = {};
            field.datasource = cloneDependent;
            //tbd as getterKey & getterKey should not be taken from root level it must be the part of dependent obj
            field.getterKey = question.getterKey;
            field.getterValue = question.getterValue;
            field.req_keys = question.req_keys;
            if (this.baseService.validateParams(cloneDependent.args)) {
                this.formService.setdropdownOptions(field, question, this);
                if (question.cloneDependent != undefined && question.cloneDependent.length > 0) {
                    this.onValueChanged({ question: question, val: "" }, current_form);
                }
            }
        }
    }
    getColspan() {
        const arr = this._editableGridData.fields.filter(e => {
            return e.heading != false;
        })
        return this._editableGridData.listBlocks.selectAll ? arr.length + 1 : arr.length;
    }
    submit() {  // Final submit event in Case of button exist with grid
        //For validetaion
        const invalidControl = this.el.nativeElement.querySelector('.ng-invalid');
        if (invalidControl) {
            this.validIn = true;
        }
        else {
            this.saveFinished.emit({ result: this.editableTable.value });
            //console.log("Data ", this.editableTable.value);
        }
        // //console.log("IN"); 
    }
    onPageChanged(page) {
        //console.log("page no is", page);
        if (this._isMaintainCheckBox()) {
            this.saveCheckboxState()
        };
        this._editableGridData.page_no = page.page - 1;
        this._currentData.saveFilterKey = true;
        if (this._editableGridData.listBlocks && this._editableGridData.listBlocks.hasOwnProperty('APIresource')) {
            if (this._editableGridData && this._editableGridData.existingFilter) {

            }
             if(this._editableGridData && this._editableGridData.listBlocks && this._editableGridData.listBlocks.filter && this._editableGridData.listBlocks.filter.filter_selected)
            {
                this._editableGridData.existingFilter = this._editableGridData.initialFilter
            }
            this.fetchData(this._editableGridData.listBlocks.APIresource.datasource, this._editableGridData.existingFilter ? this._editableGridData.existingFilter : undefined, this._editableGridData.exsitingComplexSearch ? this._editableGridData.exsitingComplexSearch : undefined, this.sortObject ? this.sortObject : undefined);
            //this.obj_table = [];
            this.selectedItems = [];
        } else {
            this.listenEvent({ page: page, type: "page_change" });
        }
        this.setUiPagination();
        let obj = { object: this._editableGridData.items, type: "next_page", editableGrid: this.editableTable.controls.editableRows['controls'] };
        this.listenEvent(obj);
    }
    view_details(i, field) {
        //console.log("index is", i);
        //console.log("field is", field);
        /******** DEOCRATOR IMPLEMENTATION *******/
        if (this._editableGridData.decorator != undefined && this._editableGridData.decorator && this._editableGridData.decorator.valueChangeStartEG != undefined) {
            this._editableGridData.decorator.valueChangeStartEG(event, this.buildDecoratorFormObj(field, i));
        }
        if (field.action_config && field.action_config.hasOwnProperty('event_out')) {
            this.listenEvent({ object: field, type: "link", index: i, editableGrid: this.editableTable.controls.editableRows['controls'] });
        } else {
            if (field.aciton_type === "popup" || field.aciton_type === "view_documents") {
                var data2PassOverpopUp = {
                    resourcedef: { ...field.action_config.datasource, ...field.action_config }, // Need to recheck
                    currentData: this.editableTable.value.editableRows[i],
                    type: field.action_config.type,
                    field: field
                };
                this.subs.add(this.smartModalService.open(PopUpOverGridWithControlsComponent, data2PassOverpopUp, field.action_config.header, this.editableGridService.checkingModalSize(field.action_config.size ? field.action_config.size : 'sm')).subscribe(
                    response => {
                        this.fetchData(this._editableGridData.listBlocks.APIresource.datasource);
                        //console.log("model closed");
                    }, err => {

                    }
                ));
            } else if (field.aciton_type == "templateInterceptor") {
                var config_obj = JSON.parse(JSON.stringify(field.action_config))
                if (config_obj.templateInterceptor && config_obj.templateInterceptor.datasource)
                    config_obj.templateInterceptor.datasource.args = config_obj.templateInterceptor.datasource.args ? this.baseService.buildDyanamicStr(config_obj.templateInterceptor.datasource.args, { data: this.editableTable.value.editableRows[i] }) : '';
                let popobj = { data: { action: config_obj, data: this.editableTable.value.editableRows[i] }, title: 'Template', size: DialogModalSize.Lg };
                if (config_obj.config)
                    popobj.data['config'] = config_obj.config
                this.subs.add(this.dialogService.open(TemplateInterceptorComponent, popobj).afterClosed.subscribe(
                    res => {

                    }));
            } else if (field.aciton_type == "show_substitute") {
                let popobj = { data: { action: config_obj, data: this.editableTable.value.editableRows[i] }, title: `Substitutes for ${this.editableTable.getRawValue().editableRows[i].itemName}`, size: DialogModalSize.Sm };
                this.subs.add(this.dialogService.open(ShowSubstitutesComponent, popobj).afterClosed.subscribe(res => {
                    if (res) {
                        const obj = {
                            object: this.selectedItems,
                            type: Object.keys(res).length > 0 ? "substitute_added" : "substitute_removed",
                            index: i,
                            editableGrid: this.editableTable.controls.editableRows['controls'],
                            ...(Object.keys(res).length > 0 && { subs_data: res })
                        };
                        this.listenEvent(obj);
                    }
                }));

            }
            else if (field.aciton_type == "PopUIEngineComponent") {
                let popobj = { 
                    data: {resource:field.action_config.resource, bannerJson: { key: this.editableTable.value.editableRows[i] }}, 
                    title: field.action_config.title, 
                    size: DialogModalSize.Lg 
                };
                this.dialogService.open(PopUIEngineComponent, popobj).afterClosed.subscribe(res => {
                    if (res) {
                        const obj = {
                            object: this.selectedItems,
                            type: "PopUIEngineComponent",
                            index: i,
                            editableGrid: this.editableTable.controls.editableRows['controls']
                        };
                        this.listenEvent(obj);
                    }
                });
                
            }
        }
        /******** DEOCRATOR IMPLEMENTATION *******/
        if (this._editableGridData.decorator != undefined && this._editableGridData.decorator && this._editableGridData.decorator.valueChangeStartEG != undefined) {
            this._editableGridData.decorator.valueChangeEndEG(event, this.buildDecoratorFormObj(field, i));
        }
    }
    removeSubstitute(index, field) {
        if (index === undefined) return;
    
        const rowControls = this.editableTable.controls.editableRows['controls'][index].controls;
        rowControls.substituteItemName.setValue("");
        rowControls.substituteItemCode.setValue("");
    
        const eventObj = {
            object: this.selectedItems,
            type: "substitute_removed",
            index,
            editableGrid: this.editableTable.controls.editableRows['controls']
        };
    
        this.listenEvent(eventObj);
    }

    bookmarkAdded(event, type?) {
        this.addRow(this._editableGridData.items.length);
        this.editableTable.controls.editableRows['controls'][this._editableGridData.items.length - 1].patchValue(event);
        let control = this.editableTable.controls.editableRows['controls'][this._editableGridData.items.length - 1].controls;
        setTimeout(() => {
            Object.keys(control).forEach(key => {
                this.editableTable.controls.editableRows['controls'][this._editableGridData.items.length - 1].controls[key].question_component.updateDependentValue(control[key].value);
            })
        })
    }

    checkBookmark(bookmarkData) {
        bookmarkData.cardData = JSON.parse(sessionStorage.getItem('currentData'));
    }
    //this fire validation 
    validate(value: FormControl) {
        if (this._editableGridData.selectall != undefined && this._editableGridData.selectall) {
            //console.log("returned value is as::", value);
            return this.setCheckBoxValidation(value);
        }
        else {
            if (this.editableTable && this.editableTable.status == "INVALID") {
                //console.log("Form Array invalid");
                return {
                    invalid: true
                }
            }
            else {
                //console.log("Form Array valid");
                value.setErrors(null);
            }
        }
        // if (value['question_component'] != undefined && value['question_component'].question != undefined && value['question_component'].question.required) {
        //     if (this.editableTable.status == "INVALID") {
        //         return {
        //             invalid: true
        //         }
        //     }
        //     else {
        //         value.setErrors(null);
        //     }
        // }
        // else if (this._editableGridData.selectall != undefined && this._editableGridData.selectall) {
        //     return this.setCheckBoxValidation(value);
        // }
    }
    setCheckBoxValidation(control) {
        let indexarr = [];
        if (control.value == undefined) control.value = []; // In Some case value is coming null

        if (control.value.length == 0) {
            return {
                invalid: true
            }
        }
        else {
            for (let i = 0; i < control.value.length; i++) {
                if (control.value[i]['index'] != undefined) { indexarr.push(control.value[i]['index']); }
            }
            return this.getValid(indexarr, control);
        }

    }

    //return control is valid or not 
    getValid(indexarr, value) {
        for (let i = 0; i < indexarr.length; i++) {
            if (this.editableTable.controls.editableRows['controls'][indexarr[i]] != undefined && this.editableTable.controls.editableRows['controls'][indexarr[i]].status != undefined && this.editableTable.controls.editableRows['controls'][indexarr[i]].status == "INVALID") {
                return {
                    invalid: true
                }
            }
            else {
                value.setErrors(null);
                // value.status ='VALID';
                // return {
                //     valid: true,
                // }
            }
            //this is added  to check we are at end
            // else if (i == indexarr.length - 1) {
            //     value.setErrors({valid: true});
            //     value.updateValueAndValidity();
            //     return {
            //         valid: true
            //     }
            // }
        }
    }


    checkExpressionForComponent(item, expression) {
        try {
            return eval(expression);
        } catch (error) {
            return false;
        }
    }

    //setNestedeQuest
    setNestedeQuest(data, fields) {
        if(this.formService && !this.formService.editableGrid){
            this.setEditableGrid(true);
        }
        if (data.length != undefined && data.length > 0) {
            let arr: Array<any> = [];
            for (let i = 0; i < data.length; i++) {
                let fieldArray = [];
                if (fields != undefined && fields.length != undefined) {
                    for (let j = 0; j < fields.length; j++) {
                        //adding row index in each question
                        fields[j]['index'] = i;
                        let itemObj = Object.assign({}, fields[j]);
                        if (itemObj.component_expression != undefined && this.checkExpressionForComponent(data[i], itemObj.component_expression)) {
                            fieldArray.push(itemObj);
                        }
                        else if (!itemObj.component_expression) {
                            fieldArray.push(itemObj);
                        }
                    }

                    let obj = this.formService.buildQuestions(fieldArray);
                    if (!this._editableGridData.hasOwnProperty('cloneFields')) {
                        this._editableGridData['cloneFields'] = JSON.parse(JSON.stringify(obj));
                    }
                    this._editableGridData.fields = obj;
                    arr.push(obj);
                }

            }
            //console.log("Array is as follows::", arr);
            return arr;
        }
    }
    ngAfterContentChecked(): void {
        // this.cdRef.detectChanges()
    }
    ngDoCheck() {
        // //console.log('ngdocheck editableGrid');
        if (!this.cdRef['destroyed']) {
            this.cdRef.detectChanges();
        }
    }
    setEditableGrid(status: boolean) {
        if (this.formService && !this.formService.editableGrid) {
            this.formService.editableGrid = status;
        }
    }
    setUiPagination() {
    if (this?._editableGridData?.static_pagination && this.fullData?.length>0) {
        this._editableGridData.itemsCount = this.fullData.length;
        this.applyPagination(this?.pagination?.currentPage || 1,this?.pagination?.limit || 25);
        }
    }
    applyPagination(page: number, limit: number) {
        const startIndex = (page - 1) * limit;
        const endIndex = startIndex + limit;
        this._editableGridData.items = this.fullData.slice(startIndex, endIndex);
        this.initiateForm();
    }
    ngOnChanges(changes) {
        //this.cdRef.detectChanges();
        try {
           this.setEditableGrid(true);
            //console.log("Changes ", changes);
            if (changes && changes.hasOwnProperty('config') && changes.config.hasOwnProperty('currentValue')
                && changes.config.currentValue != undefined && changes.config.currentValue.hasOwnProperty('items')
                && changes.config.currentValue.hasOwnProperty('move_item') && changes.config.currentValue.move_item) {
                 this.fullData = changes?.config?.currentValue?.items || []; // store full dataset
                 if(this?._editableGridData?.static_pagination && changes?.config?.currentValue?.items){
                    this.setUiPagination();
                }else{
                    this._editableGridData.items = changes.config.currentValue.items;
                    this._editableGridData.itemsCount = this._editableGridData.items.length;
                    this.initiateForm();
                }
            }
            if (changes && changes.hasOwnProperty('config') && changes.config.hasOwnProperty('currentValue')
                && changes.config.currentValue != undefined && changes.config.currentValue.hasOwnProperty('items')
                && changes.config.currentValue.hasOwnProperty('bind_data') && changes.config.currentValue.bind_data) {
                this._editableGridData.items = changes.config.currentValue.items;
                this._editableGridData.itemsCount = this._editableGridData.items.length;
                //this._editableGridData.nestedFields[0] = this._editableGridData.items;
                // this.initiateForm();
                this.getResourceDefAndInitiateGrid();
                if (this._editableGridData.listBlocks && this._editableGridData.listBlocks.APIresource) {
                    this.fetchData(this._editableGridData.listBlocks.APIresource.datasource)
                }
            }
            if (changes && changes.hasOwnProperty('config') && changes.config.hasOwnProperty('currentValue')
                && changes.config.currentValue != undefined && changes.config.currentValue.hasOwnProperty('items')
                && changes.config.currentValue.hasOwnProperty('dynamiColumns') && changes.config.currentValue.dynamiColumns) {
                this._editableGridData.items = changes.config.currentValue.items;
                this._editableGridData.itemsCount = this._editableGridData.items.length;
                //this._editableGridData.nestedFields[0] = this._editableGridData.items;
                // this.initiateForm();
                this._editableGridData.listBlocks = {
                    fields: changes.config.currentValue.dynamiColumns,
                    actions: this._editableGridData.actions
                }
                this._editableGridData.fields = changes.config.currentValue.dynamiColumns;
                this.initiateForm();
            }
        } catch(e) {
            //TODO
            //console.log("error",e)
        }
    }

    onLimit(pageSize) {
        //console.log("page no is", pageSize);
        if (this._isMaintainCheckBox()) {
            this.saveCheckboxState()
        };
        this._currentData.saveFilterKey = true;
        this._editableGridData.page_no = 0;
        this._editableGridData.page_size = pageSize;
        if (this._editableGridData.listBlocks && this._editableGridData.listBlocks.hasOwnProperty('APIresource')) {
            this.fetchData(this._editableGridData.listBlocks.APIresource.datasource, this._editableGridData.existingFilter ? this._editableGridData.existingFilter : null, undefined, this.sortObject != undefined && this.sortObject ? this.sortObject : undefined);
            // this.fetchData(this._editableGridData.listBlocks.APIresource.datasource)
        } else {
            // this.listen_changes.emit({ page: page, type: "page_change" })
        }
    }

    // Switches the grid between its own datasource and settings.toggle_button.datasource and reloads from page 1
    onToggleButton() {
        if (this.toggleButtonDefault == undefined) {
            this.toggleButtonDefault = this._editableGridData.listBlocks.APIresource.datasource;
        }
        this.toggleButtonOn = !this.toggleButtonOn;
        let datasource = this.toggleButtonOn ? this._editableGridData.toggle_button.datasource : this.toggleButtonDefault;
        this._editableGridData.listBlocks = { ...this._editableGridData.listBlocks, APIresource: { ...this._editableGridData.listBlocks.APIresource, datasource: datasource } };
        this._editableGridData.page_no = 0;
        this.fetchData(datasource, this._editableGridData.existingFilter ? this._editableGridData.existingFilter : undefined, this._editableGridData.exsitingComplexSearch ? this._editableGridData.exsitingComplexSearch : undefined);
    }

    getGridInfoForPrint(callback: any = false) {
        let allPromiseObj = [];
        let gridInfo = [];
        if (this._editableGridData && this._editableGridData.fields) {
            for (let singleField of this._editableGridData.fields) {
                if (singleField && singleField.label && singleField.controlType != 'hidden') {
                    allPromiseObj.push(this.baseService.asyncLanguageProcess(singleField.label));
                    gridInfo.push({
                        heading: singleField.label,
                        type: (singleField.type != undefined) ? singleField.type : "string",
                        value: (singleField.value != undefined) ? singleField.value : '',
                        name: singleField.key,
                        format: (singleField.format != undefined) ? btoa(singleField.format) : "",
                        getterArrayKey: singleField.getterArrayKey ? singleField.getterArrayKey : '' //for special array type, basically dynamic header
                    })
                }
            }
            Promise.all(allPromiseObj).then(promiseResponse => {
                for (let i in gridInfo) {
                    gridInfo[i].heading = promiseResponse[i];
                }
                callback(gridInfo);
            });
        }
    }
    getTemplate(obj) {
        if (obj && obj.file_data && obj.file_data.template) {
            return obj.file_data.template;
        }
        return 'grid';
    }
    print_file(obj, callback = null) {
        this.loader.showSpinner();
        obj.file_data['contentType'] = 'pdf';
        let location_id = this.appService.getCurrentLocation() && this.appService.getCurrentLocation().location_id ? this.appService.getCurrentLocation().location_id : '';
        let filterStr = "";
        if(this._editableGridData.existingFilter){
            filterStr = this._editableGridData.existingFilter
        }
        filterStr = obj.file_data.filter ? (filterStr ? (filterStr + ',' + obj.file_data.filter) : obj.file_data.filter) : (filterStr ? filterStr : '');
        var fileObj = {
            "contentType": 'pdf',
            "action": obj.action,
            "template": obj.file_data.template,
            "queryId": obj.file_data.query_id,
            "args": `${obj.file_data.args},location_id:${location_id}`,
            "filter": filterStr,
            "file_type": "pdf",
            "page_no": this._editableGridData.page_no,
            "page_size": this._editableGridData.page_size,
            "search": '',
            "gridHeading": obj.file_data.gridHeading,
            //"gridInfo": this.getGridInfoForPrint(),
            "bannerData": "",
            "bannerInfo": "",
            "filterPrintInfo": false
        }
        fileObj.filter = this.filterService.removeDuplicateKeysFromString(fileObj);
        let application = obj.file_data.application;
        let resource = `${obj.file_data.resource}/print`;
        this.getGridInfoForPrint((res) => {
            if (res) {
                try {
                    //console.log("Res", res);
                    if (location_id) {
                        fileObj['gridInfo'] = btoa(JSON.stringify(res)); //this.getGridInfoForPrint();
                        if (fileObj.template == 'grid') {
                            fileObj["actionType"] = "download"
                        }
                        if (fileObj["actionType"] != undefined && fileObj["actionType"] == "download") {
                            fileObj.args = fileObj.args + ',downloadCSV:true';
                            var response_type = "application/text"

                            this.subs.add(this.baseService.action(fileObj, "", application, resource, "", { responseType: response_type, printApplication: true }).subscribe(
                                (data: any) => {
                                    if (fileObj) {
                                        if (fileObj["actionType"] != undefined && fileObj["actionType"] == "download") {
                                            fileObj['gridInfo'] = res;
                                            fileObj["postObj"] = { ...fileObj };
                                            fileObj["postObj"].gridInfo = btoa(JSON.stringify(res))
                                            fileObj["resource"] = resource;
                                            var fileName = fileObj['gridHeading'];
                                            fileName += ".csv";
                                            this.downloadService.formatData(data, fileObj, fileName);
                                        }
                                        else {
                                            this.print_Service.handleFileReponse({ contentType: 'pdf', key: fileObj['gridHeading'] }, 'print', data);
                                        }
                                    } else {
                                        //if not print
                                        if (data.errCode == -1) {
                                            this.alerts.error(data.message);
                                            if (callback)
                                                callback(false);
                                        } else {

                                        }
                                    }
                                    this.loader.hideSpinner();
                                }, error => {
                                    //console.log(error);
                                    this.alerts.error('API error');
                                    this.loader.hideSpinner();
                                    if (callback)
                                        callback(false);
                                }
                            ));
                        }
                        else {
                            this.subs.add(this.baseService.action(fileObj, "", false, resource, "", { responseType: "blob" }).subscribe(
                                (data: any) => {
                                    if (fileObj) {
                                        this.print_Service.handleFileReponse({ contentType: 'pdf', key: fileObj['gridHeading'] }, 'print', data);
                                    } else {
                                        //if not print
                                        if (data.errCode == -1) {
                                            this.alerts.error(data.message);
                                            if (callback)
                                                callback(false);
                                        } else {

                                        }
                                    }
                                    this.loader.hideSpinner();
                                }, error => {
                                    //console.log(error);
                                    this.alerts.error('API error');
                                    this.loader.hideSpinner();
                                    if (callback)
                                        callback(false);
                                }
                            ));
                        }
                    } else {
                        this.loader.hideSpinner();
                        this.alerts.error('Facility not selected');
                    }
                } catch (e) {
                    this.loader.hideSpinner();
                }
            }
        })
    }
    getDownloadExcelColumns(params) {
        let data = [];
        if (this._editableGridData?.allowEditGridDownload && params && params['projectionKeys'] && params['projectionKeys'].length > 0) {
            for (let d of params['projectionKeys']) {
                const matchedField = this._editableGridData.cloneFields?.find((f: any) => f.key === d);
                this.subs.add(this.translateService.translate(matchedField?.label ? matchedField.label : matchedField?.key).subscribe(x => {
                    if (x) {
                        data.push({ label: x || d, key: d, type: matchedField?.type });
                    }
                }));
            }
        } else {
            for (let d of this._editableGridData.cloneFields) {
                if (d.hasOwnProperty('controlType') && d.controlType != 'hidden' && d.controlType != 'link' && d.controlType != 'flags') {
                    this.subs.add(this.translateService.translate(d?.label ? d.label : d?.key).subscribe(x => {
                        if (x) {
                            data.push({ label: x || d.key, key: d.key, type: d.type });
                        }
                    }));
                }
            }
        }
        return data;
    }

    async exportToCsv(data) { // Need to implement functionality download excel file based on column and row
        this.loader.showSpinner();
        //Downlaod ALL
        if (this._editableGridData?.allowEditGridDownload && data?.["downloadAllWithCSV"]) {
            if (this._editableGridData.listBlocks.APIresource.datasource) {
                var data_ = JSON.parse(sessionStorage.getItem('currentData')) != undefined && JSON.parse(sessionStorage.getItem('currentData')) ? JSON.parse(sessionStorage.getItem('currentData')) : {};
                const dataSrc = this._editableGridData.listBlocks.APIresource.datasource
                if (this._editableGridData.hasOwnProperty('form_controls')) {
                    data_ = { ...data_, ...this._editableGridData['form_controls'] }
                }
                dataSrc.args = dataSrc.args != undefined ? this.baseService.buildDyanamicStr(dataSrc.args, { data: data_ }) : '';
                dataSrc.filter = dataSrc.filter != undefined ? this.baseService.buildDyanamicStr(dataSrc.filter, { data: data_ }) : '';
                let filterStr = "";
                if (this._editableGridData.existingFilter) {
                    filterStr = this._editableGridData.existingFilter;
                    //console.log("existingFilter for CSV-- ", filterStr);
                }
                filterStr = dataSrc.filter ? (filterStr ? (filterStr + ',' + dataSrc.filter) : dataSrc.filter) : (filterStr ? filterStr : '');
                var params = {
                    args: dataSrc.args,
                    filter: filterStr,
                    page_size: 999999,
                    order_by: dataSrc.order_by != undefined && dataSrc.order_by ? dataSrc.order_by : ''
                }
                if (this._editableGridData?.allowEditGridDownload && this._editableGridData.allowEditGridDownload.projectionKeys && this._editableGridData.allowEditGridDownload.projectionKeys.length >0) {
                    params['projectionKeys'] = this._editableGridData.allowEditGridDownload.projectionKeys
                }

                await this.baseService.getData(params, "", dataSrc.resource, dataSrc.application, dataSrc.query_id).toPromise().then(
                    (res: any) => {
                        if (res.errCode == -1) {
                            this.loader.hideSpinner();
                            this.alerts.error(res.message);
                        } else if (res.errCode == 0 && res.hasOwnProperty('resource')) {
                            // const filteredData = this.filterDataByProjectionKeys(
                            //     res.resource,
                            //     params['projectionKeys']
                            // );
                            this.exportImportFiles.downloadFile(res.resource,
                                this._editableGridData.currentResource, this.getDownloadExcelColumns(params), data_, this.isExportFileBannerReq(data));
                            this.loader.hideSpinner();
                        }
                    }, error => {
                        this.loader.hideSpinner();
                    }
                )
            }
        } 
        else { // Downlaod Current
            var data_ = JSON.parse(sessionStorage.getItem('currentData')) != undefined && JSON.parse(sessionStorage.getItem('currentData')) ? JSON.parse(sessionStorage.getItem('currentData')) : {};
            this.exportImportFiles.downloadFile(this.editableTable.getRawValue().editableRows,
                this._editableGridData.currentResource, this.getDownloadExcelColumns(params), data_, this.isExportFileBannerReq(data));
            this.loader.hideSpinner();
        }
    }
    isExportFileBannerReq(data) {
        if (data && data.hasOwnProperty('banner_required') && data.banner_required == false) {
            return false;
        }
        return true;
    }
    onButtonClicked(obj: Object) { // custom button click event
        switch (obj['action']) {
            case "print":
                if (obj.hasOwnProperty('file_data') && (obj['file_data'].hasOwnProperty('args') || obj['file_data'].hasOwnProperty('filter'))) {
                    obj['file_data'].args = obj['file_data'].args ? this.baseService.buildDyanamicStr(obj['file_data'].args, { data: this._editableGridData.args_filter }) : "";
                    obj['file_data'].filter = obj['file_data'].filter ? this.baseService.buildDyanamicStr(obj['file_data'].filter, { data: this._editableGridData.args_filter }) : "";
                }
                this.print_file(obj);
                break;
            case "downloadExcel":
                if (obj) {
                    if (this._editableGridData?.allowEditGridDownload) {
                        let popobj = { title: 'Download', size: DialogModalSize.Sm, popupConfig: this._editableGridData.config.archiveConfig, isEditableGrid:true };
                        this.subs.add(this.dialogService.open(DownloadPopupComponent, popobj).afterClosed.subscribe(
                            response => {
                                if (response) {
                                    if(response === "download"){
                                        obj["downloadAllWithCSV"] = false;
                                        this.exportToCsv(obj);
                                    }else{
                                        obj["downloadAllWithCSV"] = true;
                                        this.exportToCsv(obj);
                                    }
                                }
                            }));
                    } else {
                        obj["downloadAllWithCSV"] = false;
                        this.exportToCsv(obj);
                        //console.log("download excel", obj)
                    }
                }
                break;
            case "custom":
                    if (obj) {
                        //console.log("custom icon clicked", obj);
                        this.listenEvent({ button: obj, edit_table: this.editableTable, object: this._editableGridData.items, type:"onButtonClicked", editableGrid: this.editableTable.controls.editableRows['controls']});
                    }
                break;
            case "download":
                let popobj = { title: 'Download', size: DialogModalSize.Sm, popupConfig: this._editableGridData.config.archiveConfig };
                this.subs.add(this.dialogService.open(DownloadPopupComponent, popobj).afterClosed.subscribe(
                    response => {
                        if (response) {
                            if (typeof response == "object" && response.chunk_download != undefined) {
                                var newData = JSON.parse(JSON.stringify(obj));
                                newData.file_data.actionType = response.type;
                                newData.file_data.chunk_download = true;
                                if (response.chunk_size != undefined) {
                                    newData.file_data.chunk_size = response.chunk_size;
                                }
                                this.sendButtonData(newData);
                            } else {
                                obj["file_data"].actionType = response;
                                this.sendButtonData(obj);
                            }
                        }
                    }));
                break;
            default:
                break;
        }
    }

    buildCustomButtons() {
        if (this._editableGridData.config != undefined && (this._editableGridData.config.customButtonsAllowed || this._editableGridData.config.customButtonsAllowed == undefined)) {
            var customActions = [];
            if (this._editableGridData.new_buttons == undefined) {
                this._editableGridData.new_buttons = [];
            } else {
                for (let button of this._editableGridData.new_buttons) {
                    customActions.push(button.action);
                }
            }
            if (customActions.indexOf('download') == -1) {
                this.addCustomButtons('download');
            }
        }
        this._editableGridData.new_buttons = this.rolePermissionService.getAllowedContextMenu(false, this._editableGridData.new_buttons, this._editableGridData.currentResource);
    }

    addCustomButtons(action) {
        switch (action) {
            case "download":
                this._editableGridData.new_buttons.push({
                    "action": "download",
                    "label": "field.label.download",
                    "class_name": "fa fa-download",
                    "permission_required": false,
                    "file_data": {
                        "file_type": "xlsx"
                    }
                });
                break;
            default:
                break;
        }
    }

    sendButtonData(data, callback: any = false, $event?) {
        data.file_data.action = data.action;
        if (data.action == "print") {
            if (data.file_data.csvprint == null)
                data.file_data.actionType = "download";
        }
        if (data.file_data != undefined) {
            var argData = {
                page_size: this._editableGridData.page_size,
                page_no: this._editableGridData.page_no
            };

            if (data.file_data.args != undefined && data.file_data.args != "") {
                data.file_data.args = this.baseService.buildDyanamicStr(data.file_data.args, { data: argData });
            }

            if (data.file_data.template == undefined || (data.file_data.print_data != undefined && data.file_data.print_data == "grid")) {
                if (this._editableGridData.fields.length > 0) {
                    this.buildGridInfoForDownload(data, callback, $event);
                }
            } else {
                if (!callback) {
                    const event = new BulkActionClickEventEditGrid(
                        data.action,
                        data,
                        null,
                        null,
                        this._editableGridData.config?.['projection_keys'],
                        $event
                    );
                    // this.communicationService.emitbulkActionEditGrid(event)

                    this.bulkActionClickedEditGrid.emit(event);
                } else {
                    return callback(data);
                }
            }
        }
    }

    buildGridInfoForDownload(data, callback: any = false, $event?) {
        let gridInfo: any = [];
        let bannerInfo = [];
        let filterInfo: any = {};
        var fieldsClone = JSON.parse(JSON.stringify(this._editableGridData.fields));
        let allPromiseObj: any = [];
        let allPromiseBannerObj: any = [];

        for (let singleField of fieldsClone) {
            if (!singleField.hidden) {
                allPromiseObj.push(this.baseService.asyncLanguageProcess(singleField.heading));

                var itemObj = {
                    heading: singleField.heading,
                    type: singleField.type ?? "string",
                    value: singleField.value ?? '',
                    name: singleField.name ? singleField.name : singleField.key,
                    name_expression: singleField.name_expression ?? "",
                    isFrontend: singleField.isFrontend ?? false,
                    format: singleField.format ? btoa(singleField.format) : "",
                    print_format: singleField.print_format ? btoa(singleField.print_format) : "",
                    class_conditions: singleField.class_conditions ?
                        btoa(JSON.stringify(singleField.class_conditions)) : "",
                    map: singleField.map ? btoa(JSON.stringify(singleField.map)) : "",
                    getterArrayKey: singleField.getterArrayKey ?? '',
                    getterValue: singleField.getterValue ?? '',
                    getterKey: singleField.getterKey ?? ''
                };

                if (itemObj.type == "specialArray" && singleField.setterKey != undefined) {
                    itemObj["setterKey"] = singleField.setterKey;
                }

                gridInfo.push(itemObj);
            }
        }

        if (this._editableGridData.config?.showBanner &&
            this.commonService.bannerInfo?.bannerObj?.jsonFields?.fields) {
            this.buildBannerInfoForDownload(bannerInfo, allPromiseBannerObj, data);
        }

        this.buildFilterInfoForDownload(filterInfo, data);

        Promise.all(allPromiseObj).then(promiseResponse => {
            for (let i in gridInfo) {
                gridInfo[i].heading = promiseResponse[i];
            }

            if (data?.file_data) {
                data.file_data['filterPrintInfo'] = Object.keys(filterInfo).length ?
                    filterInfo : false;
            }

            data.file_data.gridInfo = gridInfo;
            data.file_data.secondaryUhidKey = this._editableGridData.config?.secondary_uhid_default ?? false;
            data.file_data.ehrViewKey = this._editableGridData.config?.ehr_view_default ?? false;


            if (this.filterFormGroup?.value && this.filterFormMapping) {
                this.buildLabelFromMapping(
                    this.baseService.cleanObject(JSON.parse(JSON.stringify(this.filterFormGroup.value))),
                    this.filterFormMapping,
                    (filterInfo) => {
                        if (filterInfo && Object.keys(filterInfo).length) {
                            data.file_data.filterInfo = filterInfo;
                        } else {
                            delete data.file_data.filterInfo;
                        }
                        if (!callback) {
                            const event = new BulkActionClickEventEditGrid(
                                data.action,
                                data,
                                null,
                                null,
                                this._editableGridData.config?.['projection_keys'],
                                $event
                            );
                            debugger;
                            // this.communicationService.emitbulkActionEditGrid(event)

                            this.bulkActionClickedEditGrid.emit(event);
                        } else {
                            return callback(data);
                        }
                    }
                );
            } else {
                if (!callback) {
                    const event = new BulkActionClickEventEditGrid(
                        data.action,
                        data,
                        null,
                        null,
                        this._editableGridData.config?.['projection_keys'],
                        $event
                    );
                    // this.communicationService.emitbulkActionEditGrid(event)

                    this.bulkActionClickedEditGrid.emit(event);
                } else {
                    return callback(data);
                }
            }
        });

    }

    buildLabelFromMapping(data, mapping, callback) {
        if (Object.keys(data).length) {
            try {
                var allPromiseObj = [];
                var finalData = {};
                let dataInfo = [];
                for (let key in data) {
                    if (mapping[key] != undefined && mapping[key]["label"] != undefined && mapping[key]["label"] != "") {
                        allPromiseObj.push(this.baseService.asyncLanguageProcess(mapping[key]["label"]));
                        dataInfo.push(key);
                    }
                }
                Promise.all(allPromiseObj).then((promiseResponse) => {
                    for (let i in dataInfo) {
                        finalData[dataInfo[i]] = promiseResponse[i];
                    }
                    callback(finalData);
                }).catch(() => {
                    callback({});
                });
            } catch (e) {
                callback({});
            }
        } else {
            callback({});
        }
    }

    buildBannerInfoForDownload(bannerInfo: any[], allPromiseBannerObj: any[], data) {
        if (this.commonService.bannerInfo.bannerObj?.jsonFields?.fields) {
            let bannerFieldClone = JSON.parse(
                JSON.stringify(this.commonService.bannerInfo.bannerObj.jsonFields.fields)
            );
            let val = this.commonService.bannerInfo.val;
            for (let singleField of bannerFieldClone) {
                if (!singleField.hidden && this.checkBannerExpression(singleField.expression, val)) {
                    var formatted = '';
                    if (singleField.format != undefined) {
                        let fn;
                        if (this.utilService.checkExpression(singleField, val)) {
                            formatted = eval(singleField.format)(val);
                        }
                    }

                    allPromiseBannerObj.push(this.baseService.asyncLanguageProcess(singleField.heading));

                    if (formatted != '' || val[singleField.name] != '') {
                        bannerInfo.push({
                            heading: singleField.heading,
                            type: (singleField.type != undefined) ? singleField.type : "string",
                            value: (singleField.format != undefined) ? formatted : (val[singleField.name] != undefined ? val[singleField.name] : ''),
                            name: singleField.name,
                            isFrontend: singleField.isFrontend ? singleField.isFrontend : false,
                            format: (singleField.format != undefined) ? btoa(singleField.format) : "",
                            class_conditions: (singleField.class_conditions != undefined) ? btoa(JSON.stringify(singleField.class_conditions)) : "",
                            map: (btoa(JSON.stringify(singleField.map)) != undefined) ? singleField.map : ""
                        })
                    }

                }
            }

            Promise.all(allPromiseBannerObj).then(promiseResponse => {
                if (bannerInfo && bannerInfo.length > 0) {
                    for (let i in bannerInfo) {
                        bannerInfo[i].heading = promiseResponse[i];
                    }
                }
            })
            data.file_data.bannerInfo = bannerInfo.length ? bannerInfo : false;
            data.file_data.bannerData = val;
        }
    }
    checkBannerExpression(expression, item): boolean {
        let flag = true;
        try {
            if (expression != undefined) {
                flag = eval(expression);
            }
        } catch (error) { }
        return flag;
    }

    buildFilterInfoForDownload(filterInfo: any, data) {
        if (this.kxFilter != undefined && this.kxFilter['form'] != undefined && this.kxFilter['form'].form != undefined && this.kxFilter['form'].form.controls != undefined) {
            let controls = this.kxFilter['form'].form.controls;
            Object.keys(controls).forEach(key => {
                let condition_ = controls[key] != undefined && controls[key] && controls[key].value != undefined && controls[key].value && controls[key].question_component != undefined && controls[key].question_component.question != undefined && controls[key].question_component.question.visible != undefined && controls[key].question_component.question.visible && this.kxFilter['filterVal'] != undefined && this.kxFilter['filterVal'] && get_(this.kxFilter['filterVal'], key) ? true : false;

                if (controls[key].question_component == undefined) {
                    return;
                }
                let question = controls[key].question_component.question;

                if (condition_ && (controls[key].question_component.question.controlType === "dropdown" || (controls[key].question_component.question.controlType === "searchselect" && controls[key].question_component.question.defaultsetting != undefined && controls[key].question_component.question.defaultsetting.singleSelection != undefined && controls[key].question_component.question.defaultsetting.singleSelection)) && question != undefined && question.options != undefined && question.options.length != undefined) {
                    let currentOption = question.options.find(x => x[question.getterKey] === get_(this.kxFilter['filterVal'], key));
                    if (currentOption) {
                        this.baseService.asyncLanguageProcess(question.label).then((res: any) => {
                            let key_ = res;
                            filterInfo[key_] = currentOption[question.getterValue];
                        })
                    }
                }

                else if (condition_ && controls[key].question_component.question.controlType == "searchselect" && Array.isArray(get_(this.kxFilter['filterVal'], key)) && get_(this.kxFilter['filterVal'], key).length != undefined && get_(this.kxFilter['filterVal'], key).length > 0) {
                    this.baseService.asyncLanguageProcess(question.label).then((res: any) => {
                        let valO = get_(this.kxFilter['filterVal'], key);
                        controls[key].setValue(valO);
                        let val = JSON.parse(JSON.stringify(valO));
                        let val_ = val.map(e => e.text).join(",");
                        let key_ = res;
                        filterInfo[key_] = val_;
                    })
                }
                else if (condition_ && controls[key].question_component.question.controlType != "hidden" && controls[key].question_component.question.controlType != "monthYearPicker" && controls[key].question_component.question.controlType != "daterangepicker" && controls[key].question_component.question.controlType != "searchselect" && controls[key].question_component.question.controlType != "dropdown") {
                    this.baseService.asyncLanguageProcess(question.label).then((res: any) => {
                        let key_ = res;
                        filterInfo[key_] = get_(this.kxFilter['filterVal'], key);
                    })
                }
                else if (condition_ && controls[key].question_component.question.controlType === "daterangepicker") {
                    this.baseService.asyncLanguageProcess(question.label).then((res: any) => {
                        let key_ = res;
                        let val = get_(this.kxFilter['filterVal'], key);
                        if (val && val.FROM != undefined && val.FROM && val.TO != undefined && val.TO && !controls[key].question_component.question.singleDatePicker) {
                            let modVal = this.utilService.toTimeZoneDateFormat(val.FROM, 'date') + " - " + this.utilService.toTimeZoneDateFormat(val.TO, 'date');
                            filterInfo[key_] = modVal;
                        }
                        else if (controls[key].question_component.question.locale != undefined && controls[key].question_component.question.locale.format != undefined && controls[key].question_component.question.outPutFormat != undefined && controls[key].question_component.question.outPutFormat) {
                            filterInfo[key_] = val;
                        }
                        else if (val && controls[key].question_component.question.singleDatePicker) {
                            let modVal = this.utilService.toTimeZoneDateFormat(val, 'date')
                            filterInfo[key_] = modVal;
                        }
                    })
                } else if (condition_ && controls[key].question_component.question.controlType === "monthYearPicker") {
                    this.baseService.asyncLanguageProcess(question.label).then((res: any) => {
                        let key_ = res;
                        let val = get_(this.kxFilter['filterVal'], key);
                        if (val) {
                            let modVal = this.utilService.toTimeZoneDateFormat(val, 'monthYear');
                            filterInfo[key_] = modVal;
                        }
                    })
                }
            });

            if (data.noComplexSearch == undefined) {
                if (this.complexSearchRef != undefined && this.complexSearchRef != undefined && this.complexSearchRef.config != undefined && this.complexSearchRef.config.searchField != undefined && this.gridPrintFlag) {
                    this.baseService.asyncLanguageProcess(this.complexSearchRef.config.searchField.label).then((res: any) => {
                        if (this.complexSearchRef.finalFilterVal != undefined && this.complexSearchRef.finalFilterVal) {
                            let obj = {};
                            obj[res] = this.complexSearchRef.finalFilterVal;
                            filterInfo = { ...filterInfo, ...obj };
                        }
                    });
                    // let complexSearch = {}

                } else if (this.complexSearchRef != undefined && this.complexSearchRef != undefined && this.complexSearchRef.config != undefined && this.complexSearchRef.config.searchField != undefined && !this.gridPrintFlag) {
                    filterInfo = { ...filterInfo };
                }
            }

            if (this.appService.getUniversalConfig("multi_care_type") && this.filterFieldGroup && this.filterFieldGroup.blocks && this.filterFieldGroup.blocks.config && this.filterFieldGroup.blocks.config.care_type && this.filterFieldGroup.blocks.config.care_type.header && data.action == "download") {
                let obj = {}; let filter_key = "Care Type";
                let value = this.appService.getDynamicFunctions("getCurrentCareTypeName")
                obj[filter_key] = value;
                filterInfo = { ...filterInfo, ...obj };
            }

        }
    }

    onBottomButtonClicked(obj: any) { //  Bottom buttons click event
        // //console.log("obj",obj)
        if (this._editableGridData.decorator != undefined && this._editableGridData.decorator && this._editableGridData.decorator.beforeOnSubmitEG != undefined) {
            let submitRes = "";
            if (this.formService && this.formService.form && this.formService.form.value) {
                submitRes = this._editableGridData.decorator.beforeOnSubmitEG(this.formService.form.value, this);
            }
            else {
                this._editableGridData.selectedItems = this.selectedItems;
                if (this._isMaintainCheckBox()) {
                    this._editableGridData.selectedItems = this.getAllSelectedItemsForSubmission();
                };
                submitRes = this._editableGridData.decorator.beforeOnSubmitEG(this._editableGridData, this);
            }
            if (!submitRes) {
                return;
            }
        }
        if (obj) {
            if (this.formService.form && this.formService.form.value && obj.action) {
                this.loader.showSpinner();
                let formData = {};

                if (this._isMaintainCheckBox()) {
                    formData = {
                        ...this.formService.form.value,
                        selectedItems: this.getAllSelectedItemsForSubmission()
                    };
                } else {
                    formData = this.formService.form.value;
                }
                this.subs.add(this.baseService.action(formData, obj.action, obj.application ? obj.application : this.appService.getApplication(),
                    obj.resource, false).subscribe((res) => {
                        if (res.errCode == 0) {
                            if (this._isMaintainCheckBox()) {
                                this.clearCheckboxState();
                            };
                            this.selectedItems = [];
                            this.listenEvent({ object: this._editableGridData.items, type: "submitted", editableGrid: this.editableTable.controls.editableRows['controls'] });
                            this.alerts.success("");
                        } else {
                            this.alerts.error(res.message)
                        }
                        this.loader.hideSpinner();
                    }, (err) => {
                        this.alerts.success(err.message);
                        this.loader.hideSpinner();
                        this.listenEvent({ object: this._editableGridData.items, type: "submit_failed", editableGrid: this.editableTable.controls.editableRows['controls'] });
                    }))
            } else {
                if (this.formService.form && this.formService.form.value) {
                    this.listenEvent({ button: obj, edit_table: this.editableTable, object: this._editableGridData.items, type: obj.type ? obj.type : "button_Click", editableGrid: this.editableTable.controls.editableRows['controls'], selectedValue: this.formService.form.value });
                } else if (this._editableGridData.selectall) {
                    this.listenEvent({ button: obj, edit_table: this.editableTable, object_all: this._editableGridData.items, object_selected: this.selectedItems, type: obj.type ? obj.type : "emit_selected_values", editableGrid: this.editableTable.controls.editableRows['controls'] });
                } else {
                    this.listenEvent({ button: obj, edit_table: this.editableTable, object: this._editableGridData.items, type: obj.type ? obj.type : "button_Click", editableGrid: this.editableTable.controls.editableRows['controls'] });
                }
            }
        }
    }
    /*-------------------Get popover details-------------*/
    getDetails(j, row) {
        try {
            return this.editableTable.controls.editableRows.value[row][j]
        } catch (error) {
            return 'NA'
        }

    }
    getSubsDetails(field: string, index: number): string | undefined {
        let str = "";
        let isPopOverReady = false;
    
        const row = this.editableTable?.controls?.editableRows['controls'][index].getRawValue();
    
        if (row) {
             // Add substitute item name if it exists
             if (row.substituteItemName) {
                str += `<div><b>ItemName:</b> ${row.substituteItemName}</div>`;
                isPopOverReady = true;
            }
            // Add composition if it exists
            if (row.substituteComposition) {
                str += `<div><b>Composition:</b> ${row.substituteComposition}</div>`;
                isPopOverReady = true;
            }
            // Handle itemFlag details
            const itemFlags = row && row.substituteItemFlag && row.substituteItemFlag?.filter(flag => flag?.text).map(flag => flag.text) || [];
            if (itemFlags.length > 0) {
                str += `<div><b>Flags:</b> ${itemFlags.join(", ")}</div>`;
                isPopOverReady = true;
            }
        }
    
        return isPopOverReady ? str : undefined;
    }
    
    setToInitialPostion(id, postion) {
        if (this._editableGridData['activeField'] == 'table') {
            var elmnt = document.getElementById(id);
            if (elmnt) {
                elmnt.scrollLeft = postion;
            }
        }
    }
    setDecorater(resouceDef) {
        /******** DEOCRATOR IMPLEMENTATION *******/
        if (resouceDef.config != undefined && resouceDef.config.decorator != undefined) {
            //if decorator  not initialzed or its not same as previous decorator then initialze it
            if (!this._editableGridData.decorator || (this._editableGridData.decorator != undefined && this._editableGridData.decorator && this._editableGridData.decorator.className != undefined && this._editableGridData.decorator.className != resouceDef.config.decorator)) {
                this._editableGridData.decorator = this.baseService.initDecorator(resouceDef.config.decorator, this.route, this.injector);
                this.setFormForDecorater();
            }
        }
        //added for dynamic table template-need to make common
        //#205544: template grid decorator moved from static to flag-based (resource_config.editableGrid_decorator_inside_templateForm)
        //2nd clause checks the rowHeader key, not its value: dynamic-table grids have rowHeader: undefined
        if ((resouceDef.list && resouceDef.list.rowHeader && typeof resouceDef.list.rowHeader == 'object') || (resouceDef.list && Object.prototype.hasOwnProperty.call(resouceDef.list, 'rowHeader'))) {
           // this._editableGridData.decorator = this.baseService.initDecorator("clmTemplateServicePackage", this.route);
                if (this.formService?.config?.resource_config?.editableGrid_decorator_inside_templateForm) {
                    if (this.formService?.config?.resource_config?.decorator) {
                        this._editableGridData.decorator = this.baseService.initDecorator(this.formService?.config?.resource_config?.decorator, this.route);
                    }
                }
        }
        /******** DEOCRATOR IMPLEMENTATION *******/
    }
    setFormForDecorater() {
        /******** DEOCRATOR IMPLEMENTATION *******/
        if (this._editableGridData.decorator != undefined && this._editableGridData.decorator && this._editableGridData.decorator != undefined) {
            // if (this.formtype == '') {
            this._editableGridData.decorator.setData(this.formService, this._editableGridData.items);
            //     }
            // } else {
            //     this.decorator = false;
            // }
            /******** DEOCRATOR IMPLEMENTATION *******/
        }
    }

    toggleBarcodeScan() {
        var key = this._editableGridData.currentResource + "_list_config";
        this.getTableConfig(key, (saveData) => {
            saveData = (saveData) ? saveData : {};
            if (this._editableGridData['barcodeConfig'] != undefined && this._editableGridData['barcodeConfig']['populateGrid'] != undefined) {
                saveData['barcodeConfig'] = {
                    'populateGrid': !this._editableGridData['barcodeConfig']['populateGrid'],
                    'isBarcodeText': !this._editableGridData['barcodeConfig']['isBarcodeText'],
                    'datasource': this._editableGridData['barcodeConfig']['datasource'],
                    'emitBarcodeAction': this._editableGridData['barcodeConfig']['emitBarcodeAction'] ? this._editableGridData['barcodeConfig']['emitBarcodeAction'] : false
                }
            }
            // this._editableGridData['barcodeConfig']['datasource'] = this.searchConfig.barcode_config.datasource;
            saveData['barcodeConfig']['datasource'] = this.searchConfig.barcode_config.datasource;
            if (this.searchConfig?.barcode_config?.performActionOnScan) {
                saveData['barcodeConfig'].isBarcodeText = saveData['barcodeConfig'].populateGrid = false;
                saveData['barcodeConfig'].performActionOnScan = !this._editableGridData['barcodeConfig']?.performActionOnScan;
            }
            this._editableGridData['barcodeConfig'] = saveData['barcodeConfig'];
            this._editableGridData.user_preference_data = saveData;
            this.saveTableConfigData(saveData);
            this.addKeyDownEventIfNeeded();
        });

    }
    addKeyDownEventIfNeeded() {
        if (this._editableGridData.barcodeConfig?.performActionOnScan) {
            this.removeExistingBarcodeListener();
            const originalListener = this?._editableGridData?.decorator?.barcodeKeydownListener;

            if (originalListener) {
                const handleKeydown = originalListener.bind(this); 
                document.addEventListener('keydown', handleKeydown);
                this.utilService.setBoundBarcodeListener(handleKeydown);
            }
        } else {
            this.removeExistingBarcodeListener();
        }
    }
    removeExistingBarcodeListener() {
        if (this.utilService.getBoundBarcodeListener()) {
            document.removeEventListener('keydown', this.utilService.getBoundBarcodeListener());
            this.utilService.setBoundBarcodeListener(undefined);
        }
    }

    getTableConfig(key, callback) {
        this.storageService.getData(key, (data) => {
            if (data) {
                callback(data);
            } else {
                this.getTableConfigByRequest(key, callback);
            }
        })
    }

    getTableConfigFn(callback, account?) {
        var key = this.searchConfig.saveKey;
        //if account is true then we will not load the cached data
        this.preferenceService.getUserPreferenceConfig(key, (data) => {
            if (!account) {
                this._editableGridData.config.localStorageData = data;
            }
            callback(data);
        }, account);
    }

    getTableConfigByRequest(key, callback) {
        if (callback != undefined) {
            this.loader.showSpinner();
            this.subs.add(this.baseService.getWithoutfacilityId("GET_BY_NAME", "", "user_preference", "account-management", "name:" + key).subscribe(
                (data: any) => {
                    if (data.errCode == -1) {
                        callback({});
                    } else {
                        if (data.resource != undefined && data.resource.length) {
                            try {
                                var json = JSON.parse(data.resource[0].json);
                                this.storageService.setData(key, json, () => {
                                    callback(json);
                                })
                            } catch (e) {
                                callback({});
                            }
                        } else {
                            callback({});
                        }
                    }
                    this.loader.hideSpinner();
                }, error => {
                    //console.log(error);
                    this.loader.hideSpinner();
                    callback({})
                }
            ));
        } else {
            this.getTableConfigFn(key);
        }
    }
    resetDefaultConfig() {
        if (this.resource == undefined) {
            console.error("resource not found");
        } else {
            this._editableGridData.fields.forEach((item, index) => {
                if (item.controlType != "hidden") {
                    item.selected = true;
                    item.hidden = false;
                    item.order = index
                }
            });
            if (this._editableGridData?.listBlocks?.fields) {
                for (let dg of this._editableGridData.listBlocks.fields) {
                    if (dg.component !== 'hidden' && dg.name) {
                        this._editableGridData.fieldsOrder[dg.name] = dg.order || this.getDefaultOrder(dg);
                    }
                }
            }
            this.saveTableConfigData();
            // this.getInitialFieldOrder((d)=>{
            //     if(d){
            //         this.saveTableConfigData();
            //     }
            // })
            this.checkSelectAll();

        }
    }
    getDefaultOrder(field) {
        let matchedField = this._editableGridData.fields.find(d => d.key === field.name);
        //console.log("fields after reset", matchedField);

        if (matchedField?.order !== undefined) {
            return matchedField.order;
        }
    }
    modifyFields = (callback) => {
        if (this._editableGridData.fields) {
            let arr = this._editableGridData.fields.filter((f) => { return f.controlType != "hidden" }).map((d) => { return { selected: d.selected, key: d.key, hidden: d.hidden, order: d.order } })
            callback(arr)
        }
    }
    saveTableConfigData(data?) {
        if (!data) {
            data = {};
        }
        let key = this._editableGridData.currentResource + "_list_config";
        try {
            this.modifyFields(f => {
                if (f && f.length > 0) {
                    data.fields = f;
                    if (!data.hasOwnProperty('fields_order')) {
                        data.fields_order = this._editableGridData.fieldsOrder;
                    }
                    this.storageService.setData(key, data, () => {
                        // console.log("user preference data", data);
                        this.subs.add(this.baseService.action({ name: key, json: JSON.stringify(data) }, "UPDATE_USER", "account-management", "user_preference").subscribe(
                            (data: any) => {
                                this.applyUserPreference(this._editableGridData.user_preference_json);
                            }, error => {
                                //console.log(error);
                            }
                        ));
                    });
                }
            })
        } catch (error) {
        }
    }

    /**
  * // TODO: comment Editable Grid Mobile responsiveness work starts here
  * initial script version
  * @param Mobile
  * @returns responsive design in Mobile
  */
    checkGridOpensInSmallDevice() {
        ////console.log("is Mobile",this.utilService.isMobile())
        ////console.log("Editable grid setings",this._editableGridData)
        this._editableGridData.table = true;
        this._editableGridData['activeField'] = 'table';
        //Uncommnet from Here to make it responsive in mobile
        if (!this.utilService.isMobile()) { //  If isMobile condition not Met
            this._editableGridData.table = true;
            this._editableGridData['activeField'] = 'table';
        }
        if (this._editableGridData.hasOwnProperty('tile') && this._editableGridData.tile) { //  If isMobile condition not Met
            this._editableGridData.tile = true;
            this._editableGridData['activeField'] = 'tile';
        }
        if (this.utilService.isMobile()) { //  If isMobile condition Met
            this._editableGridData.table = false;
            this._editableGridData.tile = true;
            this._editableGridData['activeField'] = 'tile';
        }
    }

    checkExpression(i, field) {
        if (field.action_config && field.action_config.expression && this.editableTable && this.editableTable.controls && this.editableTable.controls.editableRows && this.editableTable.controls.editableRows['controls']) {
            var item = this.editableTable.controls.editableRows['controls'][i].getRawValue();
            let verified = eval(field.action_config.expression)
            if (verified)
                return true;
            else
                return false
        } else
            return true;
    }
    getAction(index, field) {//on color label click open popup function
        if (this._editableGridData && this._editableGridData.listBlocks && this._editableGridData.listBlocks.fields && field && field.key && field.hasOwnProperty('class_conditions')) {
            let _currentField = this._editableGridData.listBlocks.fields.find(x => {
                return x.name == field.key
            });
            if (_currentField) {
                this.view_details(index, _currentField);
            }
        };
    }
    viewLocation(index) {
        if (this._editableGridData && this._editableGridData.listBlocks && this._editableGridData.listBlocks.fields) {
            let _currentField = this._editableGridData.listBlocks.fields.find(x => {
                return x.key == "view_location"
            });
            if (_currentField) {
                this.view_details(index, _currentField);
            }
        };
    }

    iconRedirect(currentFormGroup, event) {
        let item = currentFormGroup.value;
        event.route.banner.datasource.args = this.baseService.buildDyanamicStr(event.route.banner.datasource.args, { data: item });
        let queryParams = {
            "banner": JSON.stringify(event.route.banner),
            "returnUrl": this.Router.url,
            "key": item.id,
            "query_params": event.route.banner.datasource.args
        };
        if (event.required_rowData != undefined && event.required_rowData) {
            sessionStorage.setItem('currentData', JSON.stringify(item))
        }
        this.Router.navigate([event.route.redirectLink], { queryParams: queryParams });
    }

    emitEllipseId(item, action) {
        const proceed = () => {
            switch (action.action) {
                case 'popup_form': {
                    this.popupFormSetup(item, action);
                    break;
                }
                case "confirm": {
                    this.confirmBoxResource(item.value, action);
                    break;
                }
                case "print": {
                    let obj = {
                        data: item.getRawValue()
                    };
                    if (action != undefined && action.print_barcode!=undefined && action.print_barcode && this.appService.getAccountConfig().print_barcode!=undefined && this.appService.getAccountConfig().print_barcode) {
                        this.utilService.printLabel(obj.data);
                    } else {
                        this.handleFile(action, obj);
                    }
                    break;
                }
                case "custom": {
                    const rowData = item?.getRawValue ? item.getRawValue() : item?.value;
                    if (action.required_rowData && rowData) {
                        sessionStorage.setItem('currentData', JSON.stringify(rowData));
                        localStorage.setItem('currentChildData', JSON.stringify(rowData));
                    }
                    if (action.route_path) {
                        this.baseService.redirectToOtherPage(action.route_path, rowData);
                    }
                    break;
                }
                default: {
                    //do nothing
                }
            }
        };
        if (action && action.templateInterceptor && (action.action == 'popup_form' || action.action == 'confirm')) {
            let data_ = item?.getRawValue ? item.getRawValue() : item?.value;
            this.checkTemplates(data_, action, proceed);
        } else {
            proceed();
        }
    }
    //checks if a clinical-consent template is configured for this action's next_stage before letting it proceed
    checkTemplates(data_, action, proceed: () => void) {
        try {
            this.loader.showSpinner();
            let datasource = action.templateInterceptor.datasource;
            data_['next_stage'] = action.templateInterceptor.next_stage;
            if (data_ != undefined && !data_.care_type) {
                try { data_['care_type'] = this.appService.getDynamicFunctions("getCurrentCareType"); } catch (error) { }
            }
            if (data_ != undefined && data_.patient_gender) {
                data_['patient_gender'] = (data_.patient_gender + '').toLowerCase();
            }
            let args = this.baseService.buildDyanamicStr(datasource.args, { data: data_ });
            this.baseService.get(datasource.query_id, args, datasource.resource, datasource.application, datasource.filter).subscribe(data => {
                if (data && data.errCode != -1 && data.resource != undefined && data.resource.length != undefined && data.resource.length > 0) {
                    this.openTemplIntersep(data_, { templateInterceptor: action.templateInterceptor }, false, (res) => {
                        if (res) { proceed(); }
                    });
                } else {
                    this.loader.hideSpinner();
                    proceed();
                }
            }, (error) => {
              this.loader.hideSpinner();
              proceed();
            });
        } catch (error) {
            this.loader.hideSpinner();
            proceed();
        }
    }
    openTemplIntersep(data: any, actionType, config?, callback?) {
        let popobj = { data: { action: actionType, data: data }, title: 'Template', size: DialogModalSize.Lg };
        if (config) popobj.data['config'] = config;
        this.dialogService.open(TemplateInterceptorComponent, popobj).afterClosed.subscribe(res => {
            if (res) callback(true);
        });
    }

    popupFormSetup(item, action) {
        if (action.selector != undefined) {
            let size = this.baseService.getModalSize(action['popup']['size'] ? action['popup']['size'] : '');
            let obj = {
                data: {
                    "selector": action.selector,
                    "item": item.getRawValue(),
                    "action": action,
                    "currentForm": item,
                    "form": this.editableTable,
                    "selectedIndices": this.selectedIndices,
                    "parentForm": this.parentForm != undefined ? this.parentForm : false,
                    "selectedItemsValue": this.selectedItems != undefined ? this.selectedItems : [],
                },
                title: action.popup.title,
                size: action.popup.size
            }

            this.subs.add(this.dialogService.open(DynamicPopUpComponent, obj).afterClosed.subscribe(res => {
                if (res) {
                    try {
                        if (res != undefined && action.patch_keys != undefined) {
                            let obj = {};
                            for (let key of action.patch_keys) {
                                if (res[key.key] != undefined) {
                                    obj[key.val] = res[key.key]
                                }
                            }
                            item.patchValue(obj);
                        }
                        else
                            item.patchValue(res);
                        //console.log(item);
                        if (action && action.gridRefresh != undefined && action.gridRefresh) {
                            this.fetchData(this._editableGridData.listBlocks.APIresource.datasource);
                        }
                    } catch (error) {
                        //console.log("Item : " + item + ", Error : " + error);

                    }
                }
            },
                err => { console.log("err"); }));
        } else if (action.without_selector != undefined && action.without_selector) {   // non-selector popup support
            let obj = {
                data: {
                    "val": item.getRawValue(),
                    "action": action,
                    "currentForm": item,
                    "form": this.editableTable,
                    "selectedIndices": this.selectedIndices,
                    "parentForm": this.parentForm != undefined ? this.parentForm : false,
                    "selectedItemsValue": this.selectedItems != undefined ? this.selectedItems : [],
                },
                title: action.popup.title,
                size: action.popup.size
            }   
            let size = this.baseService.getModalSize(action['popup'] && action['popup']['size'] ? action['popup']['size'] : 'lg');
            this.subs.add(this.smartModalService.open(DynamicPopUpComponent, obj, obj.title, size).subscribe(res => {
                if (res) {
                    try {
                        if (res != undefined && action.patch_keys != undefined) {
                            let obj = {};
                            for (let key of action.patch_keys) {
                                if (res[key.key] != undefined) {
                                    obj[key.val] = res[key.key]
                                }
                            }
                            item.patchValue(obj);
                        }
                        else
                            item.patchValue(res);
                        //console.log(item);
                        if (action && action.gridRefresh != undefined && action.gridRefresh) {
                            this.fetchData(this._editableGridData.listBlocks.APIresource.datasource);
                        }
                    } catch (error) {
                        //console.log("Item : " + item + ", Error : " + error);

                    }
                }
            }));
        }
    }

    onSort(field) {
        if (this._isMaintainCheckBox()) {
            this.saveCheckboxState()
        };
        if (!this.currentSort.has(field.key)) {
            this.currentSort.clear();
            this.currentSort.set(field.key, 1);
        } else {
            const value = this.currentSort.get(field.key);
            this.currentSort.set(field.key, value * -1);
        }
        let sortObject = this.mapToObj(this.currentSort);
        if (sortObject.value == '1')
            sortObject.value = 'asc';
        else
            sortObject.value = 'desc';

        this.sortObject = sortObject;

        this.fetchData(this._editableGridData.listBlocks.APIresource.datasource, this._editableGridData.existingFilter ? this._editableGridData.existingFilter : null, this._editableGridData.exsitingComplexSearch ? this._editableGridData.exsitingComplexSearch : "", sortObject);

    }
    mapToObj(inputMap) {
        let obj = { 'value': '', 'key': '' };
        inputMap.forEach(function (value, key) {
            obj['value'] = value;
            obj['key'] = key;
        });
        return obj;
    }
    clearSort() {
        this.currentSort.clear();
        this.fetchData(this._editableGridData.listBlocks.APIresource.datasource, this._editableGridData.existingFilter ? this._editableGridData.existingFilter : null, this._editableGridData.exsitingComplexSearch ? this._editableGridData.exsitingComplexSearch : "");
    }
    configureGrid() {
        var obj: any = {};
        var jsonName = this._editableGridData.currentResource
        obj["key"] = this.getConfigurationKey(jsonName);
        obj["resource_name"] = jsonName;
        obj["context"] = "edit_grid";
        this.preferenceService.openConfigurePopup(obj, (response) => {
            if (response.result != undefined) {
                this.preferenceService.saveConfigurationData(obj, response.result, (result) => {
                    ////console.log(result);
                });
            }
        });
    }
    getConfigurationKey(jsonName) {
        return this.preferenceService.getConfigurationKey(jsonName);
    }

    openMasterUpload() {
        this.loader.showSpinner();
        let objRefer = {
            "application": "data-onboarding",
            "resource": "master_upload_checklist",
            "query_id": "GET_CHECKLIST_FOR_TEMPLATE",
            "args": "resource_name:" + this._editableGridData.master_upload.resource
        };
        this.baseService.getByDataSource(objRefer).subscribe((res) => {
            this.loader.hideSpinner();
            if (res.errCode == 0 && res.resource != undefined && res.resource.length > 0) {
                this.storageService.setSessionStorageData("currentData", res.resource[0], () => {
                    this.Router.navigateByUrl('data-onboarding/upload_file?key=' + res.resource[0].id);
                });
            }
        }, error => {
            this.loader.hideSpinner();
        })
    }

    confirmBoxResource(data, action) {
        if (this.dialogRef)
            this.dialogRef.close();
        let popupTitle = "";
        this.subs.add(this.translateService.translate(action.label ? action.label : action.title).subscribe(x => {
            if (x) {
                popupTitle = x;
            }
        }));
        let name: string = "";
        if (action.name != undefined) {
            name = data[action.name];
        } else {
            name = "";
        }
        const dialogRef = this.modalService.confirm(popupTitle, action.message + ' ' + name + '?', ModalSize.Sm);
        this.subs.add(dialogRef.subscribe(result => {
            if (result) {
                this.loader.showSpinner();
                if (action.datasource.data != undefined) {
                    var res = action.datasource.data[0];
                    for (let i = 0; i < Object.keys(res).length; i++) {
                        data[Object.keys(res)[i]] = res[Object.keys(res)[i]];
                    }
                    this.confirmResource(data, action);
                } else if (action.datasource.url != undefined) {
                    var url = this.baseService.buildDyanamicStr(action.datasource.url, { data: data });
                    let i = document.createElement('iframe');
                    i.src = url
                    i.width = "1";
                    i.height = "1";
                    var r = document.querySelector('body').appendChild(i);
                    setTimeout(() => {
                        r.hidden = true
                    }, 100)

                    this.loader.hideSpinner();
                } else {
                    this.confirmResource(data, action);
                }
            }
        },
            () => { }));
    }

    confirmResource(item, action) {
        /******** DEOCRATOR IMPLEMENTATION *******/
        if (action && action.decorator != undefined && action.decorator) {
            if (this._editableGridData != undefined && this._editableGridData && this._editableGridData.decorator != undefined && this._editableGridData.decorator && this._editableGridData.decorator.confirmBeforeSubmit != undefined) {
                var submitRes = this._editableGridData.decorator.confirmBeforeSubmit(item, action);
                if (!submitRes) {
                    return;
                }
            }
        }
        this.subs.add(this.baseService.action(item, action.datasource.action, action.datasource.application, action.datasource.resource).subscribe(
            (data: any) => {
                this.communicationService.emitChange({ completed: true });
                if (data.errCode == -1) {
                    this.alerts.error(data.message);
                } else {
                    if (this.formService.action == 'ADD') {
                        this.alerts.success("Added Successfully");
                    } else if (action.gridRefresh != undefined && action.gridRefresh) {
                        this.fetchData(this._editableGridData.listBlocks.APIresource.datasource);
                        this.alerts.success("Updated Successfully");
                    } else {
                        this.alerts.success("Updated Successfully");
                    }
                }
                this.loader.hideSpinner();
            }, error => {
                console.log(error);
                this.alerts.error('API error');
                this.loader.hideSpinner();
            }));
    }
    async barcodeReader(event) {
        if (!event) {
            this.alerts.error("Please enter barcode first.");
            return false;
        }
        // Screens whose sellable stock is not in `stock` - consignment walk-in reads
        // consignment_challan_detail - declare their own source as settings.barcode_datasource in
        // the screen JSON. Absent (every screen today), this stays the stock lookup it always was.
        const barcodeSource = this._editableGridData.barcode_datasource;
        let params = {
            args: `barCode:${event}`
        };
        if (barcodeSource && barcodeSource.args) {
            const currentLocation = this.appService.getCurrentLocation();
            // Must never be undefined: buildDynamicValue leaves an unresolved !!!key!!! in place,
            // which would then travel to the backend as the literal store id.
            const locationId = currentLocation && currentLocation.location_id ? currentLocation.location_id : "";
            params.args += `,${this.utilService.buildDynamicValue(barcodeSource.args, false, { location_id: locationId })}`;
        }

        this.loader.showSpinner();
        this._editableGridData.barcodeReaderModel = "";
        try {
            const data = barcodeSource
                ? await this.baseService.getData(params, "", barcodeSource.resource, barcodeSource.application, barcodeSource.query_id).toPromise()
                : await this.baseService.getData(params, "", "stock", "inventory-management", "GET_STOCK_BY_BARCODE").toPromise();

            if (data.errCode == -1) {
                this.alerts.error(data.message);
            } else if (data.errCode == 0 && data.resource.length > 0) {
                let obj = data.resource[0];
                let obj1 = { data: obj, type: "Barcode_setValue_without_index", editableGrid: this.editableTable.controls.editableRows['controls'] };
                this.listenEvent(obj1);
            } else if (barcodeSource) {
                // GET_STOCK_BY_BARCODE throws on a miss, so the default path never reaches here;
                // a custom query may answer with an empty list instead of an error.
                this.alerts.error(`No stock found with given barcode - ${event}!!!`);
            }
        } catch (error) {
            console.error(error);
            this.alerts.error("An error occurred while retrieving barcode data.");
        } finally {
            this.loader.hideSpinner();
        }
    }

    applyFilter(filter) {
        let res = this._currentData != undefined && this._currentData.json != undefined ? this._currentData.json : '';
        this.storageService.getData('filterConfig' + res, (data) => {
            if (data) {
                this._editableGridData.config.filterConfig = data;
                this.storageService.removeData('filterConfig' + res, () => { });
                // this.kxFilter['form']['resetOnlyForm']({});
                this.kxFilter['resetParams']('');
                this.storageService.getData('filterFormMapping' + res, (data_) => {
                    this.filterFormMapping = data_;
                });
                this.storageService.removeData('filterFormMapping' + res, () => { });
                this._editableGridData.config.stopChangeProp = true;
                this.kxFilter['stopChangeProp'] = true;
            }
        })
        if (this._editableGridData.config.filterConfig && this._editableGridData.config.filterConfig.currentFilter != undefined && this._editableGridData.config.filterConfig.currentFilter == filter.key) {
            this._editableGridData.listBlocks.filter.default_open = true;
            this.kxFilter['stopChangeProp'] = false;
            // this.kxFilter['resetFormClick']('');
            this.filterFormGroup.setValue(this.dummyFilterFormGroup);
            this._editableGridData.config.resetQuickFilter = undefined; /* #183749 */
            this.resetFilter(filter, false);
        } else {
            if (filter.data != undefined && this.filterFormMapping != undefined && this.filterFormGroup != undefined) {
                this.filterFormGroup.setValue(this.dummyFilterFormGroup);
                var oldFilterMapping = { ...this.filterFormMapping };
                this._editableGridData.config.filterConfig = { ... this._editableGridData.config.filterConfig };
                this._editableGridData.config.filterConfig.reset = new Date().getTime();
                this._editableGridData.config.filterConfig.currentFilter = filter.key;
                this._editableGridData.config.filterConfig.FilterName = filter.name;
                this._editableGridData.config.filterConfig.quickReset = false;
                setTimeout(async () => {
                    for (let f in filter.data) {
                        if (this.filterFormGroup && this.filterFormGroup.controls && this.filterFormGroup.controls[f] != undefined && oldFilterMapping[f] != undefined) {
                            if (filter.data[f]['type'] == undefined)
                                filter.data[f]['type'] = oldFilterMapping[f]['controlType'];
                            if (filter.type != undefined && filter.subType == undefined && (oldFilterMapping[f]['controlType'] == 'dropdown' || oldFilterMapping[f]['controlType'] == 'searchselect')) {
                                if (filter.dynamic_str) {
                                    if (filter.data[f].value.indexOf('!!!') != -1)
                                        filter.data[f].value = this.baseService.buildDyanamicStr(filter.data[f].value, { data: null });
                                    if (this.filterFormGroup.controls[f].question_component)
                                        this.filterFormGroup.controls[f].question_component.updateDependentValue(filter.data[f].value);
                                    this.filterFormGroup.controls[f].setValue(filter.data[f].value);
                                } else {
                                    await oldFilterMapping[f].options.find(val => {
                                        if (val[oldFilterMapping[f].getterValue] == filter.data[f].value) {
                                            if (this.filterFormGroup.controls[f].question_component)
                                                this.filterFormGroup.controls[f].question_component.updateDependentValue(val[oldFilterMapping[f].getterKey]);
                                            this.filterFormGroup.controls[f].setValue(val[oldFilterMapping[f].getterKey]);
                                        }
                                    });
                                }
                            } else if (oldFilterMapping[f].controlType == "daterangepicker" && !oldFilterMapping[f].singleDatePicker) {
                                let date;
                                if (filter.data[f] && filter.data[f].custom != undefined && filter.data[f].custom && filter.data[f].value != undefined) {
                                    date = [dayjs().valueOf(), new Date(dayjs().add(filter.data[f].value - 1, 'days').valueOf()).setUTCHours(23, 59, 59, 999)];
                                }
                                else {
                                    date = await DateRangeConfig[filter.data[f].value]();
                                }
                                if (date != undefined)
                                    if (this.filterFormGroup.controls[f].question_component)
                                        this.filterFormGroup.controls[f].question_component.updateDependentValue({ "FROM": date[0], "TO": date[1] });
                                if (this.filterFormGroup.controls[f].question_component.question.startKey != 'FROM') {
                                    this.filterFormGroup.controls[f].setValue({ [this.filterFormGroup.controls[f].question_component.question.startKey]: date[0], [this.filterFormGroup.controls[f].question_component.question.endKey]: date[1] });
                                } else
                                    this.filterFormGroup.controls[f].setValue({ "FROM": date[0], "TO": date[1] });

                            } else {
                                if (this.filterFormGroup.controls[f].question_component)
                                    this.filterFormGroup.controls[f].question_component.updateDependentValue(filter.data[f].value);
                                this.filterFormGroup.controls[f].setValue(filter.data[f].value);
                            }
                        }
                    }
                    this.kxFilter['stopChangeProp'] = false;
                    let res = this.config != undefined && this._currentData.json != undefined ? this._currentData.json : '';
                    let filter_ = this.filterService.bindFilterGrid(this.filterFormGroup.value);
                    this.doSearch(filter_);
                    this._editableGridData.config.filterConfig = { ... this._editableGridData.config.filterConfig };
                    // this._currentData.filterName = this._editableGridData.config.filterConfig.FilterName;
                    // this.storageService.setData('filterName' + res, this._editableGridData.config.filterConfig.FilterName, () => { });
                    this.storageService.setData('filterConfig' + res, this._editableGridData.config.filterConfig, () => { });
                    this._editableGridData.config.filterConfig.submit = new Date().getTime();
                    this.storageService.setData('filterFormMapping' + res, this.filterFormMapping, () => { });
                });
                this._editableGridData.config.stopChangeProp = false;
            }
        }
    }

    getDataFn(data: any) {
        if (data.type == "form" && data.obj && data.obj.form != undefined) {
            this.filterFormGroup = data.obj.form;
            this.dummyFilterFormGroup = this.filterFormGroup.value;

            if (this._editableGridData.config != undefined && this._editableGridData.config.filterData != undefined && Object.keys(this._editableGridData.config.filterData).length) {
                for (let key in this._editableGridData.config.filterData) {
                    if (this.filterFormGroup.controls != undefined && this.filterFormGroup.controls[key] != undefined) {
                        this.filterFormGroup.controls[key].setValue(this._editableGridData.config.filterData[key]);
                    }
                }
            }
        } else if (data.type == "mapping" && data.obj && data.obj.form != undefined) {
            this.filterFormMapping = data.obj.form;
        }
        else if (data.type == "default_filter" && data.obj && data.obj.form != undefined) {
            if (this._editableGridData.config && this._editableGridData.config.default_sorted) {
                // this.applyDefaultSorting(data.obj.form)
            }
            else {
                this.setDataForFilter(data.obj.form);
            }
        } else if (data.type == 'filter_save') {
            this.saveFilterData(data.obj, data.forUserPref != undefined ? data.forUserPref : false);
        } else if (data.type == 'changePage') {
            // this.configValues.emit({ 'changePage': data.obj.page });
        }
    }

    setDataForFilter(e) {
        if (this.defaultDynamicfilter && this.defaultDynamicfilter.data) {
            let x = '';
            for (let key in this.defaultDynamicfilter.data) {
                if (x == undefined || x == '') {
                    x = key + ':' + this.defaultDynamicfilter.data[key]['value'];
                } else {
                    x = x + ',' + (key + ':' + this.defaultDynamicfilter.data[key]['value']);
                }
            }
        } else {    // if default_filter is present in json
            this.applyDefaultFilter(e);
        }
    }

    saveFilterData(obj, forUserPref?) {
        this.getTableConfigFn((all_resource_data) => {
            var saveData = {};
            var key = this._editableGridData.config.saveKey;
            if (forUserPref) {
                if (all_resource_data["account__" + key] != undefined) {
                    saveData = all_resource_data["account__" + key];
                }
            } else {
                saveData = (all_resource_data) ? all_resource_data : {};
            }

            saveData["filter__"] = (saveData["filter__"] == undefined) ? [] : saveData["filter__"];
            var found = false;
            let index = 0
            if (obj.key != undefined) {
                for (index = 0; index < saveData["filter__"].length; index++) {
                    var filter = saveData["filter__"][index];
                    if (filter.key == obj.key) {
                        found = true;
                        break;
                    }
                }
            }
            if (found) {
                saveData["filter__"][index] = obj;
            } else {
                if (forUserPref) {
                    saveData["filter__"] = [obj]; // not pushing because it will be merged with latest data in line no 1191 in saveTableConfigData function , if we merge here duplicate filter will be created earlier it was working because of a bug where user data was coming and after it was being removed so effectively only one data was being pushed from here.
                } else {
                    saveData["filter__"].push(obj);
                }

            }
            this.saveTableConfigDataFn(saveData, () => {
                this.getSavedFilter();
            }, forUserPref);
        }, forUserPref);

    }

    getSavedFilter(callback: any = false) {
        //console.log("Config", this._editableGridData.config);
        this.getTableConfigFn((data) => {
            //console.log("Quick Filters ", this.filterFieldGroup);
            // getting account 
            if (data) {
                // removing filters 
                if (this.filterFieldGroup && this.filterFieldGroup.quick_filters && data['filter__'] != undefined) {
                    this.filterFieldGroup.quick_filters.forEach(function (item) {
                        item['type'] = 'quick';
                    });
                    this._editableGridData.config.filterAr = this.filterFieldGroup.quick_filters.concat(data['filter__']);
                    if (callback) {
                        callback(this._editableGridData.config.filterAr);
                    }
                } else if (this.filterFieldGroup && this.filterFieldGroup.quick_filters && data['filter__'] == undefined) {
                    this.filterFieldGroup.quick_filters.forEach(function (item) {
                        item['type'] = 'quick';
                    });
                    this._editableGridData.config.filterAr = this.filterFieldGroup.quick_filters;
                    if (callback) {
                        callback(this._editableGridData.config.filterAr);
                    }
                } else
                    if (data['filter__'] != undefined && data['filter__'].length) {
                        this._editableGridData.config.filterAr = data['filter__'];
                        if (callback) {
                            callback(data['filter__']);
                        }
                    }
                    else if (data[this.searchConfig.saveKey] != undefined && data[this.searchConfig.saveKey]['filter__'] != undefined && data[this.searchConfig.saveKey]['filter__'].length) {
                        this._editableGridData.config.filterAr = data[this.searchConfig.saveKey]['filter__'];
                        this._editableGridData.config.localStorageData = { filter__: data[this.searchConfig.saveKey]['filter__'] }
                        if (callback) {
                            callback(data[this.searchConfig.saveKey]['filter__']);
                        }
                    } else {
                        this._editableGridData.config.filterAr = [];
                        if (callback) {
                            callback([]);
                        }
                    }
            }
        });
    }

    saveTableConfigDataFn(data, callback: any = false, userScope?, del?) {
        var key = this.searchConfig.saveKey;
        let data__ = JSON.parse(JSON.stringify(data));
        if (userScope) {
            this.getTableConfigFn((all_resource_data) => {
                var account_data: any = {};
                if (all_resource_data["account__" + key] != undefined) {
                    account_data = all_resource_data["account__" + key];
                }
                if (account_data.filter__ != undefined && account_data.filter__.length != undefined && account_data.filter__.length > 0) {
                    if (del) {
                        data__.filter__ = JSON.parse(JSON.stringify(account_data.filter__));    //if it is being deleted then we get the latest data from server and then remove the key which is deleted by user
                    } else {
                        data__.filter__ = [...data__.filter__, ...account_data.filter__];
                    }

                }
                if (data__.filter__ != undefined && data__.filter__.length != undefined && data__.filter__.length > 0) {
                    data__.filter__ = data__.filter__.filter(x => x.userGroupId != undefined && x.userGroupId)
                }
                if (del) {
                    //delete case
                    let delIndex = data__.filter__.findIndex(x => x.key != undefined && x.key == del);
                    if (delIndex > -1) {
                        data__.filter__.splice(delIndex, 1);
                    } else {
                        this.alerts.error("ERROR");
                        console.error("Deleted Filter key not found");
                    }
                    //console.log("delIndex==>", delIndex);
                }

                key = 'account__' + key;


                account_data['filter__'] = data__.filter__;

                this.preferenceService.saveConfigurationData({ key: key }, account_data, (result) => {
                    callback()
                });
                // })


            }, true); //forcing to get data from db and not use cached data in localstorage
        }
        else
            this.preferenceService.saveTableConfigData(key, data, callback);

    }

    manageFilter() {
        if (this.searchConfig.saveKey == undefined) {
            console.error("resource not found");
        } else {
            this.getSavedFilter((filterData) => {
                let popobj = { data: { self: this, data: filterData }, title: 'Manage Your Filters', size: DialogModalSize.Sm };
                this.subs.add(this.dialogService.open(ManageFilterComponent, popobj).afterClosed.subscribe(
                    res => {
                        this.getSavedFilter();
                        this.resetFilter('', false);
                    }));
            });
        }
    }

    applyDefaultFilter(e) {
        try {
            let filterSavedObj = this.getFilterLabel();
            if (filterSavedObj != undefined && filterSavedObj && filterSavedObj['existingFilter'] != undefined && this._editableGridData) {   // For getting saved filter
                this._editableGridData.existingFilter = filterSavedObj['existingFilter'];
            }
            if (filterSavedObj != undefined && filterSavedObj && filterSavedObj['existingFilter'] != undefined && this._editableGridData) {   // For previous screen saved filter
                this.previousFilterVal = filterSavedObj['filterVal'];
                this._editableGridData.initialFilter = this.filterService.bindFilterGrid(this.previousFilterVal);
            } else if (this._editableGridData && this._editableGridData.existingFilter != undefined && this._editableGridData.existingFilter) {
                this._editableGridData.initialFilter = this._editableGridData.existingFilter;
            } else {
                this._editableGridData.initialFilter = e;
            }
            // applied filter after grid refresh on any action performed
            this.storageService.getData('filterSavedVal' + this._editableGridData.currentResource, (data_) => {
                if (data_) {
                    this.filterSavedVal = data_;
                    this._editableGridData.initialFilter = this.filterSavedVal;
                }
            });
            this.storageService.getData('filterFormGroup' + this._editableGridData.currentResource, (data_) => {
                if (data_) {
                    this.filterFormGroup.patchValue(data_);
                }
            });
            this.storageService.removeData('filterSavedVal' + this._editableGridData.currentResource, () => { });
            this.storageService.removeData('filterFormGroup' + this._editableGridData.currentResource, () => { });
            this.fetchData(this._editableGridData.listBlocks.APIresource.datasource, this._editableGridData.initialFilter);

        } catch (error) {
            //console.log(error);
        }
    }
    setWhiteSpaceNoWrapForEG() {
        // Check if document exists and fetch all elements with the tag name "dhs-editable-grid"
        //const editableGrids = document?.getElementsByClassName(this.resource);
        const element = document?.querySelector('dhs-editable-grid');
        if(element){
            this._editableGridData.noWrapApplied = true;
            element['style'].whiteSpace = "nowrap";
        }
    }

    handleFile(action, obj, callback = null) {
        this.loader.stophideSpinner(true);
        if (action.file_data != undefined) {
            var key = (obj.data != undefined && obj.data[action.key] != undefined) ? obj.data[action.key] : action.file_data.name;
            this.loader.showSpinner();
            var fileObj = JSON.parse(JSON.stringify(action.file_data));
            fileObj.contentType = fileObj.file_type != undefined ? fileObj.file_type : 'pdf';
            fileObj.amount = fileObj.amount != undefined ? fileObj.amount : '';
            fileObj.resource = fileObj.resource != undefined ? this.baseService.buildDyanamicStr(fileObj.resource, obj) : this._currentData.resource;
            fileObj.application = fileObj.application != undefined ? this.baseService.buildDyanamicStr(fileObj.application, obj) : this.appService.getApplication();
            fileObj.query_id = fileObj.query_id != undefined ? fileObj.query_id : undefined;
            fileObj.args = fileObj.args != undefined ? this.baseService.buildDyanamicStr(fileObj.args, obj) : false;
            fileObj.filter = fileObj.filter != undefined ? this.baseService.buildDyanamicStr(fileObj.filter, obj) : false;
            fileObj.print_doc_details = (fileObj.print_details != undefined && fileObj.print_details != undefined && fileObj.print_details.length > 0) ? fileObj.print_details : undefined;
            if (this.appService.getOrganization() && fileObj.args != undefined && fileObj.args && this._currentData.bannerJson != undefined && this._currentData.bannerJson.key != undefined) {
                fileObj.args = fileObj.args + ",facility_id:" + (this.appService.getOrganization().org_id != "" ? this.appService.getOrganization().org_id : this._currentData.bannerJson.key.facility_id);
            } else if (this.appService.getOrganization() && fileObj.args != undefined && fileObj.args && ((this.appService.getOrganization().org_id != undefined && this.appService.getOrganization().org_id) || (sessionStorage.getItem('facility_id') != undefined && sessionStorage.getItem('facility_id')))) {
                fileObj.args = fileObj.args + ",facility_id:" + (this.appService.getOrganization().org_id != "" ? this.appService.getOrganization().org_id : sessionStorage.getItem('facility_id'));
            }
            fileObj.args = this.baseService.appendEhrFacilityIdArg(fileObj.args, obj);
            if(action.action=="print-async"){
                fileObj.action=action.action;
            }
            this.baseService.handleFile(fileObj, async (fileData) => {
                this.loader.stophideSpinner(false);
                if (fileData) {
                    if (fileData.type == "application/json") {
                        try {
                            var response = await fileData.text();
                            response = JSON.parse(response);
                            // if (response.printErrorMessage && response.printErrorMessage != undefined) {
                            //   response["printErrorMessage"] = this.utilService.extractTextContent(response.printErrorMessage);
                            // }
                            if (response.errCode == -1 && response.message != undefined) {
                                this.alerts.error(response.message);
                            }
                            if (fileObj.action && fileObj.action=="print-async" && response.errCode == 0 && response.message != undefined) {
                                this.alerts.success(response.message,"",true);
                            }
                            //console.log(response);
                        } catch (e) {
                            this.alerts.error('API error');
                        }
                    } else {
                        fileObj.key = key;
                        this.print_Service.handleFileReponse(fileObj, action.action, fileData, callback);
                        if (callback && this.appService.checkNativeApp()) {
                            callback(true);
                        }
                    }
                } else {
                    this.alerts.error('server error');
                    if (callback) {
                        callback(false);
                    }
                }
                this.loader.hideSpinner();
            });
        } else {
            this.loader.stophideSpinner(false);
            console.error("Please provide File Data");
            if (callback) {
                callback(false);
            }
        }
    }

     addCapability(index: number, items: any, capability: any[]): any[] {
        let capabilityList: any[] = [];

        capability.forEach(action => {
            // Case 1: No permissions & no conditions
            if (!action.permission_required && !action.conditions) {
                capabilityList.push(action);
            }

            // Case 2: Permissions required but no conditions
            else if (action.permission_required && (!action.conditions || !Array.isArray(action.conditions))) {
                const permission = this.rolePermissionService.checkAccessPermission(action.action_name, localStorage.CurrentResource, action.application ?? this.appService.getApplication());
                if (permission) {
                    capabilityList.push(action);
                }
            }

            // Case 3: Permissions false + conditions
            else if (!action.permission_required && items && Array.isArray(action.conditions) && action.conditions.length > 0) {
                    let allConditionsPassed = true;
                    action.conditions.forEach(condition => {
                        if (!condition.expression) return;
                        try {
                            let expression = condition.expression.trim();
                            expression = expression.replace(/item\['([^']+)'\]/g, (_, key) => {
                                const value = items?.[key];
                                if (value === undefined || value === null) {
                                    return "undefined"; // keep JS-valid
                                }
                                return typeof value === "string" ? `'${value}'` : String(value);
                            });
                           const result = new Function(`return (${expression});`)();
                            if (!result) {
                                allConditionsPassed = false;
                            }
                        } catch (error) {
                            console.error("Error evaluating condition:", condition.expression, error);
                            allConditionsPassed = false;
                        }
                    });
                    if (allConditionsPassed) {
                        capabilityList.push(action);
                    }
                
            }

            // Case 4: Permissions + conditions
            else if (action.permission_required && items && Array.isArray(action.conditions) && action.conditions.length > 0) {
                const permission = this.rolePermissionService.checkAccessPermission(action.action_name, localStorage.CurrentResource, action.application ?? this.appService.getApplication());
                if (permission) {
                    let allConditionsPassed = true;
                    action.conditions.forEach(condition => {
                        if (!condition.expression) return;
                        try {
                            let expression = condition.expression.trim();
                            expression = expression.replace(/item\['([^']+)'\]/g, (_, key) => {
                                const value = items?.[key];
                                if (value === undefined || value === null) {
                                    return "undefined"; // keep JS-valid
                                }
                                return typeof value === "string" ? `'${value}'` : String(value);
                            });
                           const result = new Function(`return (${expression});`)();
                            if (!result) {
                                allConditionsPassed = false;
                            }
                        } catch (error) {
                            console.error("Error evaluating condition:", condition.expression, error);
                            allConditionsPassed = false;
                        }
                    });
                    if (allConditionsPassed) {
                        capabilityList.push(action);
                    }
                }
            }
        });
        return capabilityList;
    }


    findNestedCapability(data: any): boolean {
        if (Array.isArray(data)) {
            // If any element is also an array -> nested
            if (data.some(el => Array.isArray(el))) {
                return true;
            }
            // Otherwise, keep checking inside objects/arrays
            return data.some(el => this.findNestedCapability(el));
        } else if (typeof data === "object" && data !== null) {
            return Object.values(data).some(val => this.findNestedCapability(val));
        }
        return false;
    }

    ngOnDestroy(): void {
        this.removeExistingBarcodeListener();
        if(this.subs) {
            this.subs.unsubscribe();
        }
        if (this._isMaintainCheckBox()) {
            this.clearCheckboxState();
        }
    }
}
export class BulkActionClickEventEditGrid {

    constructor(public action: string, public items: any[], public anyItem?: any, public selectedIndices?: boolean[], public projectionkeys?: any, public $event?: any) {
    }
}